const DashboardIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M19 10.75H17C14.58 10.75 13.25 9.42 13.25 7V5C13.25 2.58 14.58 1.25 17 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM17 2.75C15.42 2.75 14.75 3.42 14.75 5V7C14.75 8.58 15.42 9.25 17 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H17Z"
          fill="white"
        />
        <path
          d="M7 22.75H5C2.58 22.75 1.25 21.42 1.25 19V17C1.25 14.58 2.58 13.25 5 13.25H7C9.42 13.25 10.75 14.58 10.75 17V19C10.75 21.42 9.42 22.75 7 22.75ZM5 14.75C3.42 14.75 2.75 15.42 2.75 17V19C2.75 20.58 3.42 21.25 5 21.25H7C8.58 21.25 9.25 20.58 9.25 19V17C9.25 15.42 8.58 14.75 7 14.75H5Z"
          fill="white"
        />
        <path
          d="M6 10.75C3.38 10.75 1.25 8.62 1.25 6C1.25 3.38 3.38 1.25 6 1.25C8.62 1.25 10.75 3.38 10.75 6C10.75 8.62 8.62 10.75 6 10.75ZM6 2.75C4.21 2.75 2.75 4.21 2.75 6C2.75 7.79 4.21 9.25 6 9.25C7.79 9.25 9.25 7.79 9.25 6C9.25 4.21 7.79 2.75 6 2.75Z"
          fill="#F5C364"
        />
        <path
          d="M18 22.75C15.38 22.75 13.25 20.62 13.25 18C13.25 15.38 15.38 13.25 18 13.25C20.62 13.25 22.75 15.38 22.75 18C22.75 20.62 20.62 22.75 18 22.75ZM18 14.75C16.21 14.75 14.75 16.21 14.75 18C14.75 19.79 16.21 21.25 18 21.25C19.79 21.25 21.25 19.79 21.25 18C21.25 16.21 19.79 14.75 18 14.75Z"
          fill="#F5C364"
        />
      </svg>
    </>
  );
};
const LogoutIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M17.4409 15.3699C17.2509 15.3699 17.0609 15.2999 16.9109 15.1499C16.6209 14.8599 16.6209 14.3799 16.9109 14.0899L18.9409 12.0599L16.9109 10.0299C16.6209 9.73994 16.6209 9.25994 16.9109 8.96994C17.2009 8.67994 17.6809 8.67994 17.9709 8.96994L20.5309 11.5299C20.8209 11.8199 20.8209 12.2999 20.5309 12.5899L17.9709 15.1499C17.8209 15.2999 17.6309 15.3699 17.4409 15.3699Z"
          fill="#F5C364"
        />
        <path
          d="M19.9298 12.8101H9.75977C9.34977 12.8101 9.00977 12.4701 9.00977 12.0601C9.00977 11.6501 9.34977 11.3101 9.75977 11.3101H19.9298C20.3398 11.3101 20.6798 11.6501 20.6798 12.0601C20.6798 12.4701 20.3398 12.8101 19.9298 12.8101Z"
          fill="#F5C364"
        />
        <path
          d="M11.7598 20.75C6.60977 20.75 3.00977 17.15 3.00977 12C3.00977 6.85 6.60977 3.25 11.7598 3.25C12.1698 3.25 12.5098 3.59 12.5098 4C12.5098 4.41 12.1698 4.75 11.7598 4.75C7.48977 4.75 4.50977 7.73 4.50977 12C4.50977 16.27 7.48977 19.25 11.7598 19.25C12.1698 19.25 12.5098 19.59 12.5098 20C12.5098 20.41 12.1698 20.75 11.7598 20.75Z"
          fill="white"
        />
      </svg>
    </>
  );
};

const IndexIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M15 12.9502H8C7.59 12.9502 7.25 12.6102 7.25 12.2002C7.25 11.7902 7.59 11.4502 8 11.4502H15C15.41 11.4502 15.75 11.7902 15.75 12.2002C15.75 12.6102 15.41 12.9502 15 12.9502Z"
          fill="#FFBD35"
        />
        <path
          d="M12.38 16.9502H8C7.59 16.9502 7.25 16.6102 7.25 16.2002C7.25 15.7902 7.59 15.4502 8 15.4502H12.38C12.79 15.4502 13.13 15.7902 13.13 16.2002C13.13 16.6102 12.79 16.9502 12.38 16.9502Z"
          fill="#FFBD35"
        />
        <path
          d="M14 6.75H10C9.04 6.75 7.25 6.75 7.25 4C7.25 1.25 9.04 1.25 10 1.25H14C14.96 1.25 16.75 1.25 16.75 4C16.75 4.96 16.75 6.75 14 6.75ZM10 2.75C9.01 2.75 8.75 2.75 8.75 4C8.75 5.25 9.01 5.25 10 5.25H14C15.25 5.25 15.25 4.99 15.25 4C15.25 2.75 14.99 2.75 14 2.75H10Z"
          fill="white"
        />
        <path
          d="M15 22.7499H9C3.38 22.7499 2.25 20.1699 2.25 15.9999V9.99993C2.25 5.43993 3.9 3.48993 7.96 3.27993C8.36 3.25993 8.73 3.56993 8.75 3.98993C8.77 4.40993 8.45 4.74993 8.04 4.76993C5.2 4.92993 3.75 5.77993 3.75 9.99993V15.9999C3.75 19.6999 4.48 21.2499 9 21.2499H15C19.52 21.2499 20.25 19.6999 20.25 15.9999V9.99993C20.25 5.77993 18.8 4.92993 15.96 4.76993C15.55 4.74993 15.23 4.38993 15.25 3.97993C15.27 3.56993 15.63 3.24993 16.04 3.26993C20.1 3.48993 21.75 5.43993 21.75 9.98993V15.9899C21.75 20.1699 20.62 22.7499 15 22.7499Z"
          fill="white"
        />
      </svg>
    </>
  );
};

const OprationIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
          fill="white"
        />
        <path
          d="M13.7602 17.75H10.2302C9.13023 17.75 8.26023 17.21 7.77023 16.23L6.88023 14.44C6.67023 14.01 6.24023 13.75 5.76023 13.75H1.99023C1.58023 13.75 1.24023 13.41 1.24023 13C1.24023 12.59 1.59023 12.25 2.00023 12.25H5.76023C6.81024 12.25 7.75024 12.83 8.22023 13.77L9.11023 15.56C9.34023 16.02 9.71023 16.25 10.2302 16.25H13.7602C14.2402 16.25 14.6702 15.99 14.8802 15.56L15.7702 13.77C16.2402 12.83 17.1802 12.25 18.2302 12.25H21.9702C22.3802 12.25 22.7202 12.59 22.7202 13C22.7202 13.41 22.3802 13.75 21.9702 13.75H18.2302C17.7502 13.75 17.3202 14.01 17.1102 14.44L16.2202 16.23C15.7502 17.17 14.8102 17.75 13.7602 17.75Z"
          fill="white"
        />
        <path
          d="M13.6701 7.75H10.3401C9.92008 7.75 9.58008 7.41 9.58008 7C9.58008 6.59 9.92008 6.25 10.3301 6.25H13.6601C14.0701 6.25 14.4101 6.59 14.4101 7C14.4101 7.41 14.0801 7.75 13.6701 7.75Z"
          fill="#FFBD35"
        />
        <path
          d="M14.5 10.75H9.5C9.09 10.75 8.75 10.41 8.75 10C8.75 9.59 9.09 9.25 9.5 9.25H14.5C14.91 9.25 15.25 9.59 15.25 10C15.25 10.41 14.91 10.75 14.5 10.75Z"
          fill="#FFBD35"
        />
      </svg>
    </>
  );
};

const ReportIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M10.1103 18.1501H6.32031C5.91031 18.1501 5.57031 17.8101 5.57031 17.4001V12.2802C5.57031 11.2402 6.4203 10.3901 7.4603 10.3901H10.1103C10.5203 10.3901 10.8603 10.7301 10.8603 11.1401V17.3901C10.8603 17.8101 10.5203 18.1501 10.1103 18.1501ZM7.07031 16.6501H9.36029V11.9001H7.4603C7.2503 11.9001 7.07031 12.0701 7.07031 12.2901V16.6501Z"
          fill="#F5C364"
        />
        <path
          d="M13.8896 18.1501H10.0996C9.68961 18.1501 9.34961 17.8101 9.34961 17.4001V7.74011C9.34961 6.70011 10.1996 5.8501 11.2396 5.8501H12.7596C13.7996 5.8501 14.6496 6.70011 14.6496 7.74011V17.4001C14.6396 17.8101 14.3096 18.1501 13.8896 18.1501ZM10.8596 16.6501H13.1496V7.74011C13.1496 7.53011 12.9796 7.3501 12.7596 7.3501H11.2396C11.0296 7.3501 10.8496 7.52011 10.8496 7.74011V16.6501H10.8596Z"
          fill="#F5C364"
        />
        <path
          d="M17.6806 18.1501H13.8906C13.4806 18.1501 13.1406 17.8101 13.1406 17.4001V12.8501C13.1406 12.4401 13.4806 12.1001 13.8906 12.1001H16.5406C17.5806 12.1001 18.4306 12.9501 18.4306 13.9901V17.4001C18.4306 17.8101 18.1006 18.1501 17.6806 18.1501ZM14.6406 16.6501H16.9306V13.9901C16.9306 13.7801 16.7606 13.6001 16.5406 13.6001H14.6406V16.6501Z"
          fill="#F5C364"
        />
        <path
          d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
          fill="white"
        />
      </svg>
    </>
  );
};

const SettingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
      fill="#F5C364"
    />
    <path
      d="M15.21 22.1898C15 22.1898 14.79 22.1598 14.58 22.1098C13.96 21.9398 13.44 21.5498 13.11 20.9998L12.99 20.7998C12.4 19.7798 11.59 19.7798 11 20.7998L10.89 20.9898C10.56 21.5498 10.04 21.9498 9.42 22.1098C8.79 22.2798 8.14 22.1898 7.59 21.8598L5.87 20.8698C5.26 20.5198 4.82 19.9498 4.63 19.2598C4.45 18.5698 4.54 17.8598 4.89 17.2498C5.18 16.7398 5.26 16.2798 5.09 15.9898C4.92 15.6998 4.49 15.5298 3.9 15.5298C2.44 15.5298 1.25 14.3398 1.25 12.8798V11.1198C1.25 9.6598 2.44 8.4698 3.9 8.4698C4.49 8.4698 4.92 8.2998 5.09 8.0098C5.26 7.7198 5.19 7.2598 4.89 6.7498C4.54 6.1398 4.45 5.4198 4.63 4.7398C4.81 4.0498 5.25 3.4798 5.87 3.1298L7.6 2.1398C8.73 1.4698 10.22 1.8598 10.9 3.0098L11.02 3.2098C11.61 4.2298 12.42 4.2298 13.01 3.2098L13.12 3.0198C13.8 1.8598 15.29 1.4698 16.43 2.1498L18.15 3.1398C18.76 3.4898 19.2 4.0598 19.39 4.7498C19.57 5.4398 19.48 6.1498 19.13 6.7598C18.84 7.2698 18.76 7.7298 18.93 8.0198C19.1 8.3098 19.53 8.4798 20.12 8.4798C21.58 8.4798 22.77 9.6698 22.77 11.1298V12.8898C22.77 14.3498 21.58 15.5398 20.12 15.5398C19.53 15.5398 19.1 15.7098 18.93 15.9998C18.76 16.2898 18.83 16.7498 19.13 17.2598C19.48 17.8698 19.58 18.5898 19.39 19.2698C19.21 19.9598 18.77 20.5298 18.15 20.8798L16.42 21.8698C16.04 22.0798 15.63 22.1898 15.21 22.1898ZM12 18.4898C12.89 18.4898 13.72 19.0498 14.29 20.0398L14.4 20.2298C14.52 20.4398 14.72 20.5898 14.96 20.6498C15.2 20.7098 15.44 20.6798 15.64 20.5598L17.37 19.5598C17.63 19.4098 17.83 19.1598 17.91 18.8598C17.99 18.5598 17.95 18.2498 17.8 17.9898C17.23 17.0098 17.16 15.9998 17.6 15.2298C18.04 14.4598 18.95 14.0198 20.09 14.0198C20.73 14.0198 21.24 13.5098 21.24 12.8698V11.1098C21.24 10.4798 20.73 9.9598 20.09 9.9598C18.95 9.9598 18.04 9.5198 17.6 8.7498C17.16 7.9798 17.23 6.9698 17.8 5.9898C17.95 5.7298 17.99 5.4198 17.91 5.1198C17.83 4.8198 17.64 4.5798 17.38 4.4198L15.65 3.4298C15.22 3.1698 14.65 3.3198 14.39 3.7598L14.28 3.9498C13.71 4.9398 12.88 5.4998 11.99 5.4998C11.1 5.4998 10.27 4.9398 9.7 3.9498L9.59 3.7498C9.34 3.3298 8.78 3.1798 8.35 3.4298L6.62 4.4298C6.36 4.5798 6.16 4.8298 6.08 5.1298C6 5.4298 6.04 5.7398 6.19 5.9998C6.76 6.9798 6.83 7.9898 6.39 8.7598C5.95 9.5298 5.04 9.9698 3.9 9.9698C3.26 9.9698 2.75 10.4798 2.75 11.1198V12.8798C2.75 13.5098 3.26 14.0298 3.9 14.0298C5.04 14.0298 5.95 14.4698 6.39 15.2398C6.83 16.0098 6.76 17.0198 6.19 17.9998C6.04 18.2598 6 18.5698 6.08 18.8698C6.16 19.1698 6.35 19.4098 6.61 19.5698L8.34 20.5598C8.55 20.6898 8.8 20.7198 9.03 20.6598C9.27 20.5998 9.47 20.4398 9.6 20.2298L9.71 20.0398C10.28 19.0598 11.11 18.4898 12 18.4898Z"
      fill="white"
    />
  </svg>
);

const DeleteBoxInAdminDashboardSetting = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
      fill="#F84459"
    />
    <path
      d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
      fill="#F84459"
    />
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill="#F84459"
    />
  </svg>
);
const responsiveMenu = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
          fill="#484848"
        />
        <path
          d="M21 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H21C21.41 11.25 21.75 11.59 21.75 12C21.75 12.41 21.41 12.75 21 12.75Z"
          fill="#484848"
        />
        <path
          d="M21 17.75H3C2.59 17.75 2.25 17.41 2.25 17C2.25 16.59 2.59 16.25 3 16.25H21C21.41 16.25 21.75 16.59 21.75 17C21.75 17.41 21.41 17.75 21 17.75Z"
          fill="#484848"
        />
      </svg>
    </>
  );
};
const DataIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
          fill="#A0A0A0"
        />
        <path
          d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
          fill="#A0A0A0"
        />
        <path
          d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
          fill="#A0A0A0"
        />
        <path
          d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
          fill="#A0A0A0"
        />
      </svg>
    </>
  );
};

const ChartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.1103 18.1501H6.32031C5.91031 18.1501 5.57031 17.8101 5.57031 17.4001V12.2802C5.57031 11.2402 6.4203 10.3901 7.4603 10.3901H10.1103C10.5203 10.3901 10.8603 10.7301 10.8603 11.1401V17.3901C10.8603 17.8101 10.5203 18.1501 10.1103 18.1501ZM7.07031 16.6501H9.36029V11.9001H7.4603C7.2503 11.9001 7.07031 12.0701 7.07031 12.2901V16.6501Z"
      fill="#F5C364"
    />
    <path
      d="M13.8896 18.1501H10.0996C9.68961 18.1501 9.34961 17.8101 9.34961 17.4001V7.74011C9.34961 6.70011 10.1996 5.8501 11.2396 5.8501H12.7596C13.7996 5.8501 14.6496 6.70011 14.6496 7.74011V17.4001C14.6396 17.8101 14.3096 18.1501 13.8896 18.1501ZM10.8596 16.6501H13.1496V7.74011C13.1496 7.53011 12.9796 7.3501 12.7596 7.3501H11.2396C11.0296 7.3501 10.8496 7.52011 10.8496 7.74011V16.6501H10.8596Z"
      fill="#F5C364"
    />
    <path
      d="M17.6806 18.1501H13.8906C13.4806 18.1501 13.1406 17.8101 13.1406 17.4001V12.8501C13.1406 12.4401 13.4806 12.1001 13.8906 12.1001H16.5406C17.5806 12.1001 18.4306 12.9501 18.4306 13.9901V17.4001C18.4306 17.8101 18.1006 18.1501 17.6806 18.1501ZM14.6406 16.6501H16.9306V13.9901C16.9306 13.7801 16.7606 13.6001 16.5406 13.6001H14.6406V16.6501Z"
      fill="#F5C364"
    />
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill="white"
    />
  </svg>
);

const ChartSvg = (props) => (
  <svg
    width="320"
    height="194"
    viewBox="0 0 320 194"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.45898 0V192.888H319.25" stroke="#494949"/>
    <path
      d="M4.3125 98.1512L64.9102 105.833L97.3427 81.5082L151.112 59.3175L175.864 42.6744L208.296 59.3175L252.251 42.6744L309.861 59.3175V192.035H4.3125V98.1512Z"
      fill={props.color !== undefined ? props.color : "#6ACBD8"}
    />
    <path d="M6.01937 182.646H0.898438" stroke="#494949"/>
    <path d="M6.01937 170.698H0.898438" stroke="#494949"/>
    <path d="M6.01937 158.749H0.898438" stroke="#494949"/>
    <path d="M6.01937 146.8H0.898438" stroke="#494949"/>
    <path d="M6.01937 134.851H0.898438" stroke="#494949"/>
    <path d="M6.01937 122.902H0.898438" stroke="#494949"/>
    <path d="M6.01937 110.953H0.898438" stroke="#494949"/>
    <path d="M6.01937 99.0046H0.898438" stroke="#494949"/>
    <path d="M6.01937 87.0558H0.898438" stroke="#494949"/>
    <path d="M6.01937 75.107H0.898438" stroke="#494949"/>
    <path d="M6.01937 63.1581H0.898438" stroke="#494949"/>
  </svg>
);
const ManagerIconSettingSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
      fill="#F5C364"
    />
    <path
      d="M15.21 22.1898C15 22.1898 14.79 22.1598 14.58 22.1098C13.96 21.9398 13.44 21.5498 13.11 20.9998L12.99 20.7998C12.4 19.7798 11.59 19.7798 11 20.7998L10.89 20.9898C10.56 21.5498 10.04 21.9498 9.42 22.1098C8.79 22.2798 8.14 22.1898 7.59 21.8598L5.87 20.8698C5.26 20.5198 4.82 19.9498 4.63 19.2598C4.45 18.5698 4.54 17.8598 4.89 17.2498C5.18 16.7398 5.26 16.2798 5.09 15.9898C4.92 15.6998 4.49 15.5298 3.9 15.5298C2.44 15.5298 1.25 14.3398 1.25 12.8798V11.1198C1.25 9.6598 2.44 8.4698 3.9 8.4698C4.49 8.4698 4.92 8.2998 5.09 8.0098C5.26 7.7198 5.19 7.2598 4.89 6.7498C4.54 6.1398 4.45 5.4198 4.63 4.7398C4.81 4.0498 5.25 3.4798 5.87 3.1298L7.6 2.1398C8.73 1.4698 10.22 1.8598 10.9 3.0098L11.02 3.2098C11.61 4.2298 12.42 4.2298 13.01 3.2098L13.12 3.0198C13.8 1.8598 15.29 1.4698 16.43 2.1498L18.15 3.1398C18.76 3.4898 19.2 4.0598 19.39 4.7498C19.57 5.4398 19.48 6.1498 19.13 6.7598C18.84 7.2698 18.76 7.7298 18.93 8.0198C19.1 8.3098 19.53 8.4798 20.12 8.4798C21.58 8.4798 22.77 9.6698 22.77 11.1298V12.8898C22.77 14.3498 21.58 15.5398 20.12 15.5398C19.53 15.5398 19.1 15.7098 18.93 15.9998C18.76 16.2898 18.83 16.7498 19.13 17.2598C19.48 17.8698 19.58 18.5898 19.39 19.2698C19.21 19.9598 18.77 20.5298 18.15 20.8798L16.42 21.8698C16.04 22.0798 15.63 22.1898 15.21 22.1898ZM12 18.4898C12.89 18.4898 13.72 19.0498 14.29 20.0398L14.4 20.2298C14.52 20.4398 14.72 20.5898 14.96 20.6498C15.2 20.7098 15.44 20.6798 15.64 20.5598L17.37 19.5598C17.63 19.4098 17.83 19.1598 17.91 18.8598C17.99 18.5598 17.95 18.2498 17.8 17.9898C17.23 17.0098 17.16 15.9998 17.6 15.2298C18.04 14.4598 18.95 14.0198 20.09 14.0198C20.73 14.0198 21.24 13.5098 21.24 12.8698V11.1098C21.24 10.4798 20.73 9.9598 20.09 9.9598C18.95 9.9598 18.04 9.5198 17.6 8.7498C17.16 7.9798 17.23 6.9698 17.8 5.9898C17.95 5.7298 17.99 5.4198 17.91 5.1198C17.83 4.8198 17.64 4.5798 17.38 4.4198L15.65 3.4298C15.22 3.1698 14.65 3.3198 14.39 3.7598L14.28 3.9498C13.71 4.9398 12.88 5.4998 11.99 5.4998C11.1 5.4998 10.27 4.9398 9.7 3.9498L9.59 3.7498C9.34 3.3298 8.78 3.1798 8.35 3.4298L6.62 4.4298C6.36 4.5798 6.16 4.8298 6.08 5.1298C6 5.4298 6.04 5.7398 6.19 5.9998C6.76 6.9798 6.83 7.9898 6.39 8.7598C5.95 9.5298 5.04 9.9698 3.9 9.9698C3.26 9.9698 2.75 10.4798 2.75 11.1198V12.8798C2.75 13.5098 3.26 14.0298 3.9 14.0298C5.04 14.0298 5.95 14.4698 6.39 15.2398C6.83 16.0098 6.76 17.0198 6.19 17.9998C6.04 18.2598 6 18.5698 6.08 18.8698C6.16 19.1698 6.35 19.4098 6.61 19.5698L8.34 20.5598C8.55 20.6898 8.8 20.7198 9.03 20.6598C9.27 20.5998 9.47 20.4398 9.6 20.2298L9.71 20.0398C10.28 19.0598 11.11 18.4898 12 18.4898Z"
      fill="white"
    />
  </svg>
);

const TriangleSign = (props) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8.73205C-0.333331 7.96225 -0.333334 6.03775 0.999999 5.26795L9.25 0.504811C10.5833 -0.26499 12.25 0.697258 12.25 2.23686L12.25 11.7631C12.25 13.3027 10.5833 14.265 9.25 13.4952L1 8.73205Z"
      fill={props.color ? props.color : "#FC909B"}
    />
  </svg>
);

const BgHeartNiko = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="200"
      height="100"
      rx="10"
      fill="url(#paint0_linear_869_2472)"
    />
    <mask
      id="mask0_869_2472"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2472)">
      <ellipse
        cx="115"
        cy="8.5"
        rx="100"
        ry="78.5"
        fill="white"
        fill-opacity="0.1"
      />
    </g>
    <path
      d="M160 66.0835C159.483 66.0835 158.983 66.0169 158.567 65.8669C152.2 63.6835 142.083 55.9335 142.083 44.4835C142.083 38.6502 146.8 33.9169 152.6 33.9169C155.417 33.9169 158.05 35.0169 160 36.9835C161.95 35.0169 164.583 33.9169 167.4 33.9169C173.2 33.9169 177.917 38.6669 177.917 44.4835C177.917 55.9502 167.8 63.6835 161.433 65.8669C161.017 66.0169 160.517 66.0835 160 66.0835ZM152.6 36.4169C148.183 36.4169 144.583 40.0335 144.583 44.4835C144.583 55.8669 155.533 62.2002 159.383 63.5169C159.683 63.6169 160.333 63.6169 160.633 63.5169C164.467 62.2002 175.433 55.8835 175.433 44.4835C175.433 40.0335 171.833 36.4169 167.417 36.4169C164.883 36.4169 162.533 37.6002 161.017 39.6502C160.55 40.2835 159.483 40.2835 159.017 39.6502C157.467 37.5835 155.133 36.4169 152.6 36.4169Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2472"
        x1="3.5"
        y1="53.5"
        x2="200"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FB6B7A"/>
        <stop offset="1" stop-color="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const NikoTimeBg = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="200"
      height="100"
      rx="10"
      fill="url(#paint0_linear_869_2478)"
    />
    <mask
      id="mask0_869_2478"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2478)">
      <ellipse
        cx="115"
        cy="8.5"
        rx="100"
        ry="78.5"
        fill="white"
        fill-opacity="0.1"
      />
    </g>
    <path
      d="M160 67.9167C150.117 67.9167 142.083 59.8834 142.083 50C142.083 40.1167 150.117 32.0834 160 32.0834C169.883 32.0834 177.917 40.1167 177.917 50C177.917 59.8834 169.883 67.9167 160 67.9167ZM160 34.5834C151.5 34.5834 144.583 41.5 144.583 50C144.583 58.5 151.5 65.4167 160 65.4167C168.5 65.4167 175.417 58.5 175.417 50C175.417 41.5 168.5 34.5834 160 34.5834Z"
      fill="#FF99A4"
    />
    <path
      d="M166.183 56.55C165.966 56.55 165.749 56.5 165.549 56.3667L160.383 53.2834C159.099 52.5167 158.149 50.8334 158.149 49.35V42.5167C158.149 41.8334 158.716 41.2667 159.399 41.2667C160.083 41.2667 160.649 41.8334 160.649 42.5167V49.35C160.649 49.95 161.149 50.8334 161.666 51.1334L166.833 54.2167C167.433 54.5667 167.616 55.3334 167.266 55.9334C167.016 56.3334 166.599 56.55 166.183 56.55Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2478"
        x1="3.5"
        y1="53.5"
        x2="200"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FB6B7A"/>
        <stop offset="1" stop-color="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const NikoMoneyBg = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="200"
      height="100"
      rx="10"
      fill="url(#paint0_linear_869_2477)"
    />
    <mask
      id="mask0_869_2477"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2477)">
      <ellipse
        cx="115"
        cy="8.5"
        rx="100"
        ry="78.5"
        fill="white"
        fill-opacity="0.1"
      />
    </g>
    <path
      d="M158.067 52.567H155.567C153.65 52.567 152.1 50.967 152.1 48.9837C152.1 48.3004 152.667 47.7337 153.35 47.7337C154.033 47.7337 154.6 48.3004 154.6 48.9837C154.6 49.5837 155.033 50.067 155.567 50.067H158.067C158.45 50.067 158.75 49.717 158.75 49.2837C158.75 48.7004 158.65 48.667 158.267 48.5337L154.25 47.1337C152.8 46.6337 152.083 45.617 152.083 44.0337C152.083 42.2337 153.517 40.7504 155.267 40.7504H157.767C159.683 40.7504 161.233 42.3504 161.233 44.3337C161.233 45.017 160.667 45.5837 159.983 45.5837C159.3 45.5837 158.733 45.017 158.733 44.3337C158.733 43.7337 158.3 43.2504 157.767 43.2504H155.267C154.883 43.2504 154.583 43.6004 154.583 44.0337C154.583 44.617 154.683 44.6504 155.067 44.7837L159.083 46.1837C160.533 46.7004 161.233 47.717 161.233 49.2837C161.25 51.1004 159.817 52.567 158.067 52.567Z"
      fill="#FF99A4"
    />
    <path
      d="M156.667 53.9002C155.983 53.9002 155.417 53.3335 155.417 52.6502V51.4169C155.417 50.7335 155.983 50.1669 156.667 50.1669C157.35 50.1669 157.917 50.7335 157.917 51.4169V52.6502C157.917 53.3502 157.35 53.9002 156.667 53.9002Z"
      fill="#FF99A4"
    />
    <path
      d="M156.667 43.2336C155.983 43.2336 155.417 42.6669 155.417 41.9836V40.6836C155.417 40.0003 155.983 39.4336 156.667 39.4336C157.35 39.4336 157.917 40.0003 157.917 40.6836V41.9836C157.917 42.6669 157.35 43.2336 156.667 43.2336Z"
      fill="#FF99A4"
    />
    <path
      d="M156.65 61.2003C148.617 61.2003 142.083 54.667 142.083 46.6337C142.083 38.6004 148.617 32.067 156.65 32.067C164.683 32.067 171.217 38.6004 171.217 46.6337C171.217 54.667 164.667 61.2003 156.65 61.2003ZM156.65 34.5837C150 34.5837 144.583 40.0003 144.583 46.6503C144.583 53.3003 150 58.7003 156.65 58.7003C163.3 58.7003 168.717 53.2836 168.717 46.6337C168.717 39.9837 163.3 34.5837 156.65 34.5837Z"
      fill="#FF99A4"
    />
    <path
      d="M168.365 67.8663C165.282 67.8663 162.382 66.3663 160.598 63.833C160.198 63.2663 160.332 62.483 160.898 62.0829C161.465 61.683 162.248 61.8163 162.648 62.383C163.965 64.2496 166.098 65.3496 168.365 65.3496C172.232 65.3496 175.365 62.2163 175.365 58.3496C175.365 56.0996 174.265 53.9663 172.432 52.6496C171.865 52.2496 171.748 51.4663 172.148 50.8996C172.548 50.3329 173.332 50.2163 173.898 50.6163C176.382 52.3996 177.865 55.2829 177.865 58.3496C177.865 63.6163 173.615 67.8663 168.365 67.8663Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2477"
        x1="3.5"
        y1="53.5"
        x2="200"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FB6B7A"/>
        <stop offset="1" stop-color="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const NikoHeartBg = () => (
  <svg
    width={200}
    height={100}
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width={200}
      height={100}
      rx={10}
      fill="url(#paint0_linear_869_2472)"
    />
    <mask
      id="mask0_869_2472"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={200}
      height={100}
    >
      <rect width={200} height={100} rx={10} fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2472)">
      <ellipse
        cx={115}
        cy="8.5"
        rx={100}
        ry="78.5"
        fill="white"
        fillOpacity="0.1"
      />
    </g>
    <path
      d="M160 66.0835C159.483 66.0835 158.983 66.0169 158.567 65.8669C152.2 63.6835 142.083 55.9335 142.083 44.4835C142.083 38.6502 146.8 33.9169 152.6 33.9169C155.417 33.9169 158.05 35.0169 160 36.9835C161.95 35.0169 164.583 33.9169 167.4 33.9169C173.2 33.9169 177.917 38.6669 177.917 44.4835C177.917 55.9502 167.8 63.6835 161.433 65.8669C161.017 66.0169 160.517 66.0835 160 66.0835ZM152.6 36.4169C148.183 36.4169 144.583 40.0335 144.583 44.4835C144.583 55.8669 155.533 62.2002 159.383 63.5169C159.683 63.6169 160.333 63.6169 160.633 63.5169C164.467 62.2002 175.433 55.8835 175.433 44.4835C175.433 40.0335 171.833 36.4169 167.417 36.4169C164.883 36.4169 162.533 37.6002 161.017 39.6502C160.55 40.2835 159.483 40.2835 159.017 39.6502C157.467 37.5835 155.133 36.4169 152.6 36.4169Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2472"
        x1="3.5"
        y1="53.5"
        x2={200}
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB6B7A"/>
        <stop offset={1} stopColor="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const NikoPeopleBg = () => (
  <svg
    width={200}
    height={100}
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width={200}
      height={100}
      rx={10}
      fill="url(#paint0_linear_869_2471)"
    />
    <mask
      id="mask0_869_2471"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={200}
      height={100}
    >
      <rect width={200} height={100} rx={10} fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2471)">
      <ellipse
        cx={115}
        cy="8.5"
        rx={100}
        ry="78.5"
        fill="white"
        fillOpacity="0.1"
      />
    </g>
    <path
      d="M155.268 49.3667C155.218 49.3667 155.184 49.3667 155.134 49.3667C155.051 49.35 154.934 49.35 154.834 49.3667C150.001 49.2167 146.351 45.4167 146.351 40.7334C146.351 35.9667 150.234 32.0834 155.001 32.0834C159.767 32.0834 163.651 35.9667 163.651 40.7334C163.634 45.4167 159.967 49.2167 155.318 49.3667C155.301 49.3667 155.284 49.3667 155.268 49.3667ZM155.001 34.5834C151.618 34.5834 148.851 37.35 148.851 40.7334C148.851 44.0667 151.451 46.75 154.768 46.8667C154.868 46.85 155.084 46.85 155.301 46.8667C158.567 46.7167 161.134 44.0334 161.151 40.7334C161.151 37.35 158.384 34.5834 155.001 34.5834Z"
      fill="#FF99A4"
    />
    <path
      d="M167.567 49.5833C167.517 49.5833 167.467 49.5833 167.417 49.5666C166.734 49.6333 166.034 49.15 165.967 48.4666C165.901 47.7833 166.317 47.1666 167.001 47.0833C167.201 47.0666 167.417 47.0666 167.601 47.0666C170.034 46.9333 171.934 44.9333 171.934 42.4833C171.934 39.95 169.884 37.9 167.351 37.9C166.667 37.9166 166.101 37.35 166.101 36.6666C166.101 35.9833 166.667 35.4166 167.351 35.4166C171.251 35.4166 174.434 38.6 174.434 42.5C174.434 46.3333 171.434 49.4333 167.617 49.5833C167.601 49.5833 167.584 49.5833 167.567 49.5833Z"
      fill="#FF99A4"
    />
    <path
      d="M155.283 67.5833C152.016 67.5833 148.733 66.75 146.249 65.0833C143.933 63.55 142.666 61.45 142.666 59.1666C142.666 56.8833 143.933 54.7666 146.249 53.2166C151.249 49.9 159.349 49.9 164.316 53.2166C166.616 54.75 167.899 56.85 167.899 59.1333C167.899 61.4166 166.633 63.5333 164.316 65.0833C161.816 66.75 158.549 67.5833 155.283 67.5833ZM147.633 55.3166C146.033 56.3833 145.166 57.75 145.166 59.1833C145.166 60.6 146.049 61.9666 147.633 63.0166C151.783 65.8 158.783 65.8 162.933 63.0166C164.533 61.95 165.399 60.5833 165.399 59.15C165.399 57.7333 164.516 56.3666 162.933 55.3166C158.783 52.55 151.783 52.55 147.633 55.3166Z"
      fill="#FF99A4"
    />
    <path
      d="M170.567 64.5834C169.984 64.5834 169.467 64.1834 169.35 63.5834C169.217 62.9 169.65 62.25 170.317 62.1C171.367 61.8834 172.334 61.4667 173.084 60.8834C174.034 60.1667 174.55 59.2667 174.55 58.3167C174.55 57.3667 174.034 56.4667 173.1 55.7667C172.367 55.2 171.45 54.8 170.367 54.55C169.7 54.4 169.267 53.7334 169.417 53.05C169.567 52.3834 170.234 51.95 170.917 52.1C172.35 52.4167 173.6 52.9834 174.617 53.7667C176.167 54.9334 177.05 56.5834 177.05 58.3167C177.05 60.05 176.15 61.7 174.6 62.8834C173.567 63.6834 172.267 64.2667 170.834 64.55C170.734 64.5834 170.65 64.5834 170.567 64.5834Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2471"
        x1="3.5"
        y1="53.5"
        x2={200}
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB6B7A"/>
        <stop offset={1} stopColor="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const NikoReportBg = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="200"
      height="100"
      rx="10"
      fill="url(#paint0_linear_869_2479)"
    />
    <mask
      id="mask0_869_2479"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2479)">
      <ellipse
        cx="115"
        cy="8.5"
        rx="100"
        ry="78.5"
        fill="white"
        fill-opacity="0.1"
      />
    </g>
    <path
      d="M175 67.9166H145C144.317 67.9166 143.75 67.35 143.75 66.6666C143.75 65.9833 144.317 65.4166 145 65.4166H175C175.683 65.4166 176.25 65.9833 176.25 66.6666C176.25 67.35 175.683 67.9166 175 67.9166Z"
      fill="#FF99A4"
    />
    <path
      d="M149.333 62.9165H146.667C145.067 62.9165 143.75 61.5998 143.75 59.9998V45.6331C143.75 44.0331 145.067 42.7164 146.667 42.7164H149.333C150.933 42.7164 152.25 44.0331 152.25 45.6331V59.9998C152.25 61.5998 150.933 62.9165 149.333 62.9165ZM146.667 45.1997C146.433 45.1997 146.25 45.3831 146.25 45.6164V59.9998C146.25 60.2331 146.433 60.4165 146.667 60.4165H149.333C149.567 60.4165 149.75 60.2331 149.75 59.9998V45.6331C149.75 45.3998 149.567 45.2164 149.333 45.2164H146.667V45.1997Z"
      fill="#FF99A4"
    />
    <path
      d="M161.334 62.9165H158.667C157.067 62.9165 155.75 61.5998 155.75 59.9998V40.3166C155.75 38.7166 157.067 37.3999 158.667 37.3999H161.334C162.934 37.3999 164.25 38.7166 164.25 40.3166V59.9998C164.25 61.5998 162.934 62.9165 161.334 62.9165ZM158.667 39.8999C158.434 39.8999 158.25 40.0832 158.25 40.3166V59.9998C158.25 60.2332 158.434 60.4165 158.667 60.4165H161.334C161.567 60.4165 161.75 60.2332 161.75 59.9998V40.3166C161.75 40.0832 161.567 39.8999 161.334 39.8999H158.667Z"
      fill="#FF99A4"
    />
    <path
      d="M173.334 62.9167H170.667C169.067 62.9167 167.751 61.6 167.751 60V35C167.751 33.4 169.067 32.0834 170.667 32.0834H173.334C174.934 32.0834 176.251 33.4 176.251 35V60C176.251 61.6 174.934 62.9167 173.334 62.9167ZM170.667 34.5834C170.434 34.5834 170.251 34.7667 170.251 35V60C170.251 60.2334 170.434 60.4167 170.667 60.4167H173.334C173.567 60.4167 173.751 60.2334 173.751 60V35C173.751 34.7667 173.567 34.5834 173.334 34.5834H170.667Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2479"
        x1="3.5"
        y1="53.5"
        x2="200"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FB6B7A"/>
        <stop offset="1" stop-color="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const NikoCommentBg = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="200"
      height="100"
      rx="10"
      fill="url(#paint0_linear_869_2476)"
    />
    <mask
      id="mask0_869_2476"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2476)">
      <ellipse
        cx="115"
        cy="8.5"
        rx="100"
        ry="78.5"
        fill="white"
        fill-opacity="0.1"
      />
    </g>
    <path
      d="M160 68.0167C158.85 68.0167 157.767 67.4334 157 66.4167L154.5 63.0834C154.45 63.0167 154.25 62.9334 154.167 62.9167H153.333C146.383 62.9167 142.083 61.0334 142.083 51.6667V43.3334C142.083 35.9667 145.967 32.0834 153.333 32.0834H166.667C174.033 32.0834 177.917 35.9667 177.917 43.3334V51.6667C177.917 59.0334 174.033 62.9167 166.667 62.9167H165.833C165.7 62.9167 165.583 62.9834 165.5 63.0834L163 66.4167C162.233 67.4334 161.15 68.0167 160 68.0167ZM153.333 34.5834C147.367 34.5834 144.583 37.3667 144.583 43.3334V51.6667C144.583 59.2 147.167 60.4167 153.333 60.4167H154.167C155.017 60.4167 155.983 60.9 156.5 61.5834L159 64.9167C159.583 65.6834 160.417 65.6834 161 64.9167L163.5 61.5834C164.05 60.85 164.917 60.4167 165.833 60.4167H166.667C172.633 60.4167 175.417 57.6334 175.417 51.6667V43.3334C175.417 37.3667 172.633 34.5834 166.667 34.5834H153.333Z"
      fill="#FF99A4"
    />
    <path
      d="M168.333 44.5834H151.667C150.983 44.5834 150.417 44.0167 150.417 43.3334C150.417 42.65 150.983 42.0834 151.667 42.0834H168.333C169.017 42.0834 169.583 42.65 169.583 43.3334C169.583 44.0167 169.017 44.5834 168.333 44.5834Z"
      fill="#FF99A4"
    />
    <path
      d="M161.667 52.9166H151.667C150.983 52.9166 150.417 52.35 150.417 51.6666C150.417 50.9833 150.983 50.4166 151.667 50.4166H161.667C162.35 50.4166 162.917 50.9833 162.917 51.6666C162.917 52.35 162.35 52.9166 161.667 52.9166Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2476"
        x1="3.5"
        y1="53.5"
        x2="200"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FB6B7A"/>
        <stop offset="1" stop-color="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const WaitingCommentBg = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="200"
      height="100"
      rx="10"
      fill="url(#paint0_linear_869_2474)"
    />
    <mask
      id="mask0_869_2474"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_869_2474)">
      <ellipse
        cx="115"
        cy="8.5"
        rx="100"
        ry="78.5"
        fill="white"
        fill-opacity="0.1"
      />
    </g>
    <path
      d="M166.666 67.1998C166.1 67.1998 165.55 67.0333 165.066 66.7166L157.966 61.9831H154.816C154.433 61.9831 154.066 61.8 153.833 61.5C153.6 61.1833 153.516 60.7831 153.616 60.4165C153.716 60.0165 153.766 59.6165 153.766 59.1831C153.766 57.8498 153.266 56.5666 152.366 55.5666C151.35 54.4166 149.9 53.7665 148.35 53.7665C146.866 53.7665 145.5 54.3498 144.466 55.3998C144.15 55.7331 143.666 55.8498 143.233 55.7331C142.8 55.5998 142.45 55.2498 142.35 54.7998C142.183 54.0665 142.1 53.2665 142.1 52.3998V42.3999C142.1 36.6665 145.95 32.8165 151.683 32.8165H168.35C174.083 32.8165 177.933 36.6665 177.933 42.3999V52.3998C177.933 55.1831 177.016 57.5831 175.266 59.3331C173.8 60.7998 171.85 61.6833 169.6 61.9166V64.2831C169.6 65.3665 168.999 66.3498 168.049 66.8665C167.599 67.0831 167.133 67.1998 166.666 67.1998ZM156.25 59.4665H158.333C158.583 59.4665 158.816 59.5331 159.033 59.6831L166.45 64.6333C166.633 64.75 166.783 64.6998 166.866 64.6498C166.95 64.5998 167.1 64.4998 167.1 64.2665V60.7165C167.1 60.0331 167.666 59.4665 168.35 59.4665C170.466 59.4665 172.25 58.8 173.5 57.55C174.766 56.2833 175.433 54.4998 175.433 52.3831V42.3832C175.433 38.0832 172.65 35.2998 168.35 35.2998H151.683C147.383 35.2998 144.6 38.0832 144.6 42.3832V52.1831C145.733 51.5665 147.016 51.2498 148.35 51.2498C150.616 51.2498 152.766 52.2166 154.233 53.8833C155.533 55.3333 156.266 57.1998 156.266 59.1665C156.25 59.2665 156.25 59.3665 156.25 59.4665Z"
      fill="#FF99A4"
    />
    <path
      d="M148.333 67.0833C143.967 67.0833 140.417 63.5333 140.417 59.1667C140.417 56.7333 141.5 54.4833 143.383 52.9833C144.783 51.8667 146.55 51.25 148.333 51.25C152.7 51.25 156.25 54.8 156.25 59.1667C156.25 61.4333 155.267 63.6 153.55 65.1C152.1 66.3833 150.25 67.0833 148.333 67.0833ZM148.333 53.75C147.1 53.75 145.933 54.1667 144.95 54.95C143.667 55.9667 142.917 57.5167 142.917 59.1667C142.917 62.15 145.35 64.5833 148.333 64.5833C149.633 64.5833 150.9 64.1 151.917 63.2333C153.083 62.2 153.75 60.7333 153.75 59.1667C153.75 56.1833 151.317 53.75 148.333 53.75Z"
      fill="#FF99A4"
    />
    <path
      d="M146.666 62.0834C146.25 62.0834 145.833 61.8667 145.6 61.4834C145.25 60.8834 145.433 60.1167 146.033 59.7667L147.517 58.8834V57.0834C147.517 56.4 148.083 55.8334 148.767 55.8334C149.45 55.8334 150.017 56.4 150.017 57.0834V59.5834C150.017 60.0167 149.783 60.4334 149.416 60.65L147.333 61.9C147.1 62.0334 146.883 62.0834 146.666 62.0834Z"
      fill="#FF99A4"
    />
    <path
      d="M165.833 48.75H154.167C153.483 48.75 152.917 48.1833 152.917 47.5C152.917 46.8167 153.483 46.25 154.167 46.25H165.833C166.517 46.25 167.083 46.8167 167.083 47.5C167.083 48.1833 166.517 48.75 165.833 48.75Z"
      fill="#FF99A4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_2474"
        x1="3.5"
        y1="53.5"
        x2="200"
        y2="56.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FB6B7A"/>
        <stop offset="1" stop-color="#FA4659"/>
      </linearGradient>
    </defs>
  </svg>
);

const DashboardIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.77 13.75H15.73C13.72 13.75 12.75 12.82 12.75 10.9V4.1C12.75 2.18 13.73 1.25 15.73 1.25H19.77C21.78 1.25 22.75 2.18 22.75 4.1V10.9C22.75 12.82 21.77 13.75 19.77 13.75ZM15.73 2.75C14.46 2.75 14.25 3.09 14.25 4.1V10.9C14.25 11.91 14.46 12.25 15.73 12.25H19.77C21.04 12.25 21.25 11.91 21.25 10.9V4.1C21.25 3.09 21.04 2.75 19.77 2.75H15.73Z"
      fill="white"
    />
    <path
      d="M19.77 22.75H15.73C13.72 22.75 12.75 21.82 12.75 19.9V18.1C12.75 16.18 13.73 15.25 15.73 15.25H19.77C21.78 15.25 22.75 16.18 22.75 18.1V19.9C22.75 21.82 21.77 22.75 19.77 22.75ZM15.73 16.75C14.46 16.75 14.25 17.09 14.25 18.1V19.9C14.25 20.91 14.46 21.25 15.73 21.25H19.77C21.04 21.25 21.25 20.91 21.25 19.9V18.1C21.25 17.09 21.04 16.75 19.77 16.75H15.73Z"
      fill="#FFE656"
    />
    <path
      d="M8.27 22.75H4.23C2.22 22.75 1.25 21.82 1.25 19.9V13.1C1.25 11.18 2.23 10.25 4.23 10.25H8.27C10.28 10.25 11.25 11.18 11.25 13.1V19.9C11.25 21.82 10.27 22.75 8.27 22.75ZM4.23 11.75C2.96 11.75 2.75 12.09 2.75 13.1V19.9C2.75 20.91 2.96 21.25 4.23 21.25H8.27C9.54 21.25 9.75 20.91 9.75 19.9V13.1C9.75 12.09 9.54 11.75 8.27 11.75H4.23Z"
      fill="white"
    />
    <path
      d="M8.27 8.75H4.23C2.22 8.75 1.25 7.82 1.25 5.9V4.1C1.25 2.18 2.23 1.25 4.23 1.25H8.27C10.28 1.25 11.25 2.18 11.25 4.1V5.9C11.25 7.82 10.27 8.75 8.27 8.75ZM4.23 2.75C2.96 2.75 2.75 3.09 2.75 4.1V5.9C2.75 6.91 2.96 7.25 4.23 7.25H8.27C9.54 7.25 9.75 6.91 9.75 5.9V4.1C9.75 3.09 9.54 2.75 8.27 2.75H4.23Z"
      fill="#FFE656"
    />
  </svg>
);

const GalleryIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill="white"
    />
    <path
      d="M9 10.75C7.48 10.75 6.25 9.52 6.25 8C6.25 6.48 7.48 5.25 9 5.25C10.52 5.25 11.75 6.48 11.75 8C11.75 9.52 10.52 10.75 9 10.75ZM9 6.75C8.31 6.75 7.75 7.31 7.75 8C7.75 8.69 8.31 9.25 9 9.25C9.69 9.25 10.25 8.69 10.25 8C10.25 7.31 9.69 6.75 9 6.75Z"
      fill="#FFE656"
    />
    <path
      d="M2.67075 19.7001C2.43075 19.7001 2.19075 19.5801 2.05075 19.3701C1.82075 19.0301 1.91075 18.5601 2.26075 18.3301L7.19075 15.0201C8.27075 14.2901 9.76075 14.3801 10.7407 15.2101L11.0707 15.5001C11.5707 15.9301 12.4207 15.9301 12.9107 15.5001L17.0707 11.9301C18.1307 11.0201 19.8007 11.0201 20.8707 11.9301L22.5007 13.3301C22.8107 13.6001 22.8507 14.0701 22.5807 14.3901C22.3107 14.7001 21.8407 14.7401 21.5207 14.4701L19.8907 13.0701C19.3907 12.6401 18.5407 12.6401 18.0407 13.0701L13.8807 16.6401C12.8207 17.5501 11.1507 17.5501 10.0807 16.6401L9.75075 16.3501C9.29075 15.9601 8.53075 15.9201 8.02075 16.2701L3.09075 19.5801C2.96075 19.6601 2.81075 19.7001 2.67075 19.7001Z"
      fill="white"
    />
  </svg>
);

const GroupIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.27 22.75H4.23C2.22 22.75 1.25 21.82 1.25 19.9V4.1C1.25 2.18 2.23 1.25 4.23 1.25H8.27C10.28 1.25 11.25 2.18 11.25 4.1V19.9C11.25 21.82 10.27 22.75 8.27 22.75ZM4.23 2.75C2.96 2.75 2.75 3.09 2.75 4.1V19.9C2.75 20.91 2.96 21.25 4.23 21.25H8.27C9.54 21.25 9.75 20.91 9.75 19.9V4.1C9.75 3.09 9.54 2.75 8.27 2.75H4.23Z"
      fill="white"
    />
    <path
      d="M19.77 13.75H15.73C13.72 13.75 12.75 12.82 12.75 10.9V4.1C12.75 2.18 13.73 1.25 15.73 1.25H19.77C21.78 1.25 22.75 2.18 22.75 4.1V10.9C22.75 12.82 21.77 13.75 19.77 13.75ZM15.73 2.75C14.46 2.75 14.25 3.09 14.25 4.1V10.9C14.25 11.91 14.46 12.25 15.73 12.25H19.77C21.04 12.25 21.25 11.91 21.25 10.9V4.1C21.25 3.09 21.04 2.75 19.77 2.75H15.73Z"
      fill="white"
    />
    <path
      d="M19.77 22.75H15.73C13.72 22.75 12.75 21.82 12.75 19.9V18.1C12.75 16.18 13.73 15.25 15.73 15.25H19.77C21.78 15.25 22.75 16.18 22.75 18.1V19.9C22.75 21.82 21.77 22.75 19.77 22.75ZM15.73 16.75C14.46 16.75 14.25 17.09 14.25 18.1V19.9C14.25 20.91 14.46 21.25 15.73 21.25H19.77C21.04 21.25 21.25 20.91 21.25 19.9V18.1C21.25 17.09 21.04 16.75 19.77 16.75H15.73Z"
      fill="#FFE656"
    />
  </svg>
);

const LocationIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0009 14.1699C9.87086 14.1699 8.13086 12.4399 8.13086 10.2999C8.13086 8.15994 9.87086 6.43994 12.0009 6.43994C14.1309 6.43994 15.8709 8.16994 15.8709 10.3099C15.8709 12.4499 14.1309 14.1699 12.0009 14.1699ZM12.0009 7.93994C10.7009 7.93994 9.63086 8.99994 9.63086 10.3099C9.63086 11.6199 10.6909 12.6799 12.0009 12.6799C13.3109 12.6799 14.3709 11.6199 14.3709 10.3099C14.3709 8.99994 13.3009 7.93994 12.0009 7.93994Z"
      fill="#FFE656"
    />
    <path
      d="M11.9997 22.76C10.5197 22.76 9.02969 22.2 7.86969 21.09C4.91969 18.25 1.65969 13.72 2.88969 8.33C3.99969 3.44 8.26969 1.25 11.9997 1.25C11.9997 1.25 11.9997 1.25 12.0097 1.25C15.7397 1.25 20.0097 3.44 21.1197 8.34C22.3397 13.73 19.0797 18.25 16.1297 21.09C14.9697 22.2 13.4797 22.76 11.9997 22.76ZM11.9997 2.75C9.08969 2.75 5.34969 4.3 4.35969 8.66C3.27969 13.37 6.23969 17.43 8.91969 20C10.6497 21.67 13.3597 21.67 15.0897 20C17.7597 17.43 20.7197 13.37 19.6597 8.66C18.6597 4.3 14.9097 2.75 11.9997 2.75Z"
      fill="white"
    />
  </svg>
);

const BlogIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8101 20.18C15.5501 20.18 15.2801 20.17 14.9901 20.14C14.4701 20.1 13.8801 20 13.2701 19.85L11.5901 19.45C6.98007 18.36 5.47007 15.92 6.55007 11.32L7.53007 7.13001C7.75007 6.18002 8.01007 5.41002 8.33007 4.77002C10.0501 1.22002 13.3401 1.54001 15.6801 2.09001L17.3501 2.48001C19.6901 3.03001 21.1701 3.90001 22.0001 5.23002C22.8201 6.56002 22.9501 8.27001 22.4001 10.61L21.4201 14.79C20.5601 18.45 18.7701 20.18 15.8101 20.18ZM13.1201 3.25001C11.4501 3.25001 10.3901 3.94002 9.68007 5.42002C9.42007 5.96002 9.19007 6.63001 8.99007 7.47001L8.01007 11.66C7.12007 15.44 8.15007 17.09 11.9301 17.99L13.6101 18.39C14.1501 18.52 14.6601 18.6 15.1201 18.64C17.8401 18.91 19.1901 17.72 19.9501 14.45L20.9301 10.27C21.3801 8.34002 21.3201 6.99002 20.7201 6.02001C20.1201 5.05001 18.9401 4.39002 17.0001 3.94002L15.3301 3.55001C14.5001 3.35001 13.7601 3.25001 13.1201 3.25001Z"
      fill="white"
    />
    <path
      d="M8.32907 22.2499C5.75908 22.2499 4.11907 20.7099 3.06907 17.4599L1.78907 13.5099C0.369078 9.10993 1.63907 6.62993 6.01907 5.20993L7.59907 4.69993C8.11907 4.53993 8.50907 4.42993 8.85907 4.36993C9.14907 4.30993 9.42908 4.41993 9.59908 4.64993C9.76908 4.87993 9.79908 5.17993 9.67908 5.43993C9.41908 5.96993 9.18907 6.63993 8.99907 7.47993L8.01908 11.6699C7.12908 15.4499 8.15907 17.0999 11.9391 17.9999L13.6191 18.3999C14.1591 18.5299 14.6691 18.6099 15.1291 18.6499C15.4491 18.6799 15.7091 18.8999 15.7991 19.2099C15.8791 19.5199 15.7591 19.8399 15.4991 20.0199C14.8391 20.4699 14.0091 20.8499 12.9591 21.1899L11.3791 21.7099C10.2291 22.0699 9.22907 22.2499 8.32907 22.2499ZM7.77908 6.21993L6.48907 6.63993C2.91907 7.78993 2.06907 9.46993 3.21907 13.0499L4.49907 16.9999C5.65907 20.5699 7.33908 21.4299 10.9091 20.2799L12.4891 19.7599C12.5491 19.7399 12.5991 19.7199 12.6591 19.6999L11.5991 19.4499C6.98908 18.3599 5.47907 15.9199 6.55907 11.3199L7.53907 7.12993C7.60908 6.80993 7.68907 6.49993 7.77908 6.21993Z"
      fill="white"
    />
    <path
      d="M17.4894 10.51C17.4294 10.51 17.3694 10.5 17.2994 10.49L12.4494 9.26002C12.0494 9.16002 11.8094 8.75002 11.9094 8.35002C12.0094 7.95002 12.4194 7.71002 12.8194 7.81002L17.6694 9.04002C18.0694 9.14002 18.3094 9.55002 18.2094 9.95002C18.1294 10.28 17.8194 10.51 17.4894 10.51Z"
      fill="#FFE656"
    />
    <path
      d="M14.5592 13.8899C14.4992 13.8899 14.4392 13.8799 14.3692 13.8699L11.4592 13.1299C11.0592 13.0299 10.8192 12.6199 10.9192 12.2199C11.0192 11.8199 11.4292 11.5799 11.8292 11.6799L14.7392 12.4199C15.1392 12.5199 15.3792 12.9299 15.2792 13.3299C15.1992 13.6699 14.8992 13.8899 14.5592 13.8899Z"
      fill="#FFE656"
    />
  </svg>
);

const MessageTextBubbleNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.81C11.31 22.81 10.66 22.46 10.2 21.85L8.7 19.85C8.67 19.81 8.55 19.76 8.5 19.75H8C3.83 19.75 1.25 18.62 1.25 13V8C1.25 3.58 3.58 1.25 8 1.25H16C20.42 1.25 22.75 3.58 22.75 8V13C22.75 17.42 20.42 19.75 16 19.75H15.5C15.42 19.75 15.35 19.79 15.3 19.85L13.8 21.85C13.34 22.46 12.69 22.81 12 22.81ZM8 2.75C4.42 2.75 2.75 4.42 2.75 8V13C2.75 17.52 4.3 18.25 8 18.25H8.5C9.01 18.25 9.59 18.54 9.9 18.95L11.4 20.95C11.75 21.41 12.25 21.41 12.6 20.95L14.1 18.95C14.43 18.51 14.95 18.25 15.5 18.25H16C19.58 18.25 21.25 16.58 21.25 13V8C21.25 4.42 19.58 2.75 16 2.75H8Z"
      fill="white"
    />
    <path
      d="M17 8.75H7C6.59 8.75 6.25 8.41 6.25 8C6.25 7.59 6.59 7.25 7 7.25H17C17.41 7.25 17.75 7.59 17.75 8C17.75 8.41 17.41 8.75 17 8.75Z"
      fill="#FFE656"
    />
    <path
      d="M13 13.75H7C6.59 13.75 6.25 13.41 6.25 13C6.25 12.59 6.59 12.25 7 12.25H13C13.41 12.25 13.75 12.59 13.75 13C13.75 13.41 13.41 13.75 13 13.75Z"
      fill="#FFE656"
    />
  </svg>
);

const MessageTextNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 22.75H3C2.04 22.75 1.25 21.96 1.25 21V8C1.25 3.58 3.58 1.25 8 1.25H16C20.42 1.25 22.75 3.58 22.75 8V16C22.75 20.42 20.42 22.75 16 22.75ZM8 2.75C4.42 2.75 2.75 4.42 2.75 8V21C2.75 21.14 2.86 21.25 3 21.25H16C19.58 21.25 21.25 19.58 21.25 16V8C21.25 4.42 19.58 2.75 16 2.75H8Z"
      fill="white"
    />
    <path
      d="M17 10.25H7C6.59 10.25 6.25 9.91 6.25 9.5C6.25 9.09 6.59 8.75 7 8.75H17C17.41 8.75 17.75 9.09 17.75 9.5C17.75 9.91 17.41 10.25 17 10.25Z"
      fill="#FFE656"
    />
    <path
      d="M14 15.25H7C6.59 15.25 6.25 14.91 6.25 14.5C6.25 14.09 6.59 13.75 7 13.75H14C14.41 13.75 14.75 14.09 14.75 14.5C14.75 14.91 14.41 15.25 14 15.25Z"
      fill="#FFE656"
    />
  </svg>
);

const MoneysNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8892 18.2197H6.09921C5.57921 18.2197 5.0892 18.1698 4.6492 18.0698C4.4192 18.0398 4.13921 17.9597 3.84921 17.8497C2.51921 17.3497 0.949219 16.1198 0.949219 13.0598V7.90973C0.949219 4.63973 2.82921 2.75977 6.09921 2.75977H14.8892C17.6492 2.75977 19.4292 4.07974 19.9092 6.47974C19.9992 6.91974 20.0392 7.38973 20.0392 7.90973V13.0598C20.0392 16.3498 18.1692 18.2197 14.8892 18.2197ZM6.10919 4.27979C3.64919 4.27979 2.4592 5.46975 2.4592 7.92975V13.0798C2.4592 14.8698 3.08921 15.9698 4.37921 16.4598C4.57921 16.5298 4.76922 16.5797 4.94922 16.6097C5.32922 16.6897 5.69919 16.7297 6.10919 16.7297H14.8992C17.3592 16.7297 18.5492 15.5398 18.5492 13.0798V7.92975C18.5492 7.50975 18.5192 7.13974 18.4492 6.79974C18.1092 5.09974 16.9492 4.27979 14.8992 4.27979H6.10919Z"
      fill="white"
    />
    <path
      d="M17.8911 21.2198H9.10107C8.25107 21.2198 7.49106 21.0998 6.84106 20.8498C5.37106 20.2998 4.41105 19.1398 4.08105 17.4798C4.03105 17.2298 4.11107 16.9698 4.29107 16.7998C4.47107 16.6198 4.73107 16.5498 4.98107 16.6098C5.31107 16.6798 5.68107 16.7198 6.10107 16.7198H14.8911C17.3511 16.7198 18.5411 15.5299 18.5411 13.0699V7.91984C18.5411 7.49984 18.5111 7.12984 18.4411 6.78984C18.3911 6.53984 18.4711 6.28985 18.6411 6.10985C18.8211 5.92985 19.0711 5.84983 19.3211 5.90983C21.7211 6.39983 23.0411 8.17984 23.0411 10.9198V16.0699C23.0411 19.3499 21.1711 21.2198 17.8911 21.2198ZM5.92107 18.2198C6.24107 18.7998 6.72107 19.2099 7.38107 19.4499C7.86107 19.6299 8.44105 19.7198 9.11105 19.7198H17.9011C20.3611 19.7198 21.551 18.5299 21.551 16.0699V10.9198C21.551 9.33984 21.061 8.28985 20.051 7.73985C20.051 7.79985 20.051 7.85984 20.051 7.91984V13.0699C20.051 16.3399 18.1711 18.2198 14.9011 18.2198H6.11105C6.04105 18.2198 5.98107 18.2198 5.92107 18.2198Z"
      fill="white"
    />
    <path
      d="M10.4994 13.8899C8.62939 13.8899 7.10938 12.3699 7.10938 10.4999C7.10938 8.62988 8.62939 7.10986 10.4994 7.10986C12.3694 7.10986 13.8894 8.62988 13.8894 10.4999C13.8894 12.3699 12.3694 13.8899 10.4994 13.8899ZM10.4994 8.60986C9.45939 8.60986 8.60938 9.45988 8.60938 10.4999C8.60938 11.5399 9.45939 12.3899 10.4994 12.3899C11.5394 12.3899 12.3894 11.5399 12.3894 10.4999C12.3894 9.45988 11.5394 8.60986 10.4994 8.60986Z"
      fill="white"
    />
    <path
      d="M4.78125 13.4498C4.37125 13.4498 4.03125 13.1098 4.03125 12.6998V8.2998C4.03125 7.8898 4.37125 7.5498 4.78125 7.5498C5.19125 7.5498 5.53125 7.8898 5.53125 8.2998V12.6998C5.53125 13.1098 5.20125 13.4498 4.78125 13.4498Z"
      fill="#FFE656"
    />
    <path
      d="M16.2109 13.4498C15.8009 13.4498 15.4609 13.1098 15.4609 12.6998V8.2998C15.4609 7.8898 15.8009 7.5498 16.2109 7.5498C16.6209 7.5498 16.9609 7.8898 16.9609 8.2998V12.6998C16.9609 13.1098 16.6309 13.4498 16.2109 13.4498Z"
      fill="#FFE656"
    />
  </svg>
);

const NoteIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8101 20.18C15.5501 20.18 15.2801 20.17 14.9901 20.14C14.4701 20.1 13.8801 20 13.2701 19.85L11.5901 19.45C6.98007 18.36 5.47007 15.92 6.55007 11.32L7.53007 7.13001C7.75007 6.18002 8.01007 5.41002 8.33007 4.77002C10.0501 1.22002 13.3401 1.54001 15.6801 2.09001L17.3501 2.48001C19.6901 3.03001 21.1701 3.90001 22.0001 5.23002C22.8201 6.56002 22.9501 8.27001 22.4001 10.61L21.4201 14.79C20.5601 18.45 18.7701 20.18 15.8101 20.18ZM13.1201 3.25001C11.4501 3.25001 10.3901 3.94002 9.68007 5.42002C9.42007 5.96002 9.19007 6.63001 8.99007 7.47001L8.01007 11.66C7.12007 15.44 8.15007 17.09 11.9301 17.99L13.6101 18.39C14.1501 18.52 14.6601 18.6 15.1201 18.64C17.8401 18.91 19.1901 17.72 19.9501 14.45L20.9301 10.27C21.3801 8.34002 21.3201 6.99002 20.7201 6.02001C20.1201 5.05001 18.9401 4.39002 17.0001 3.94002L15.3301 3.55001C14.5001 3.35001 13.7601 3.25001 13.1201 3.25001Z"
      fill="white"
    />
    <path
      d="M8.32907 22.2499C5.75908 22.2499 4.11907 20.7099 3.06907 17.4599L1.78907 13.5099C0.369078 9.10993 1.63907 6.62993 6.01907 5.20993L7.59907 4.69993C8.11907 4.53993 8.50907 4.42993 8.85907 4.36993C9.14907 4.30993 9.42908 4.41993 9.59908 4.64993C9.76908 4.87993 9.79908 5.17993 9.67908 5.43993C9.41908 5.96993 9.18907 6.63993 8.99907 7.47993L8.01908 11.6699C7.12908 15.4499 8.15907 17.0999 11.9391 17.9999L13.6191 18.3999C14.1591 18.5299 14.6691 18.6099 15.1291 18.6499C15.4491 18.6799 15.7091 18.8999 15.7991 19.2099C15.8791 19.5199 15.7591 19.8399 15.4991 20.0199C14.8391 20.4699 14.0091 20.8499 12.9591 21.1899L11.3791 21.7099C10.2291 22.0699 9.22907 22.2499 8.32907 22.2499ZM7.77908 6.21993L6.48907 6.63993C2.91907 7.78993 2.06907 9.46993 3.21907 13.0499L4.49907 16.9999C5.65907 20.5699 7.33908 21.4299 10.9091 20.2799L12.4891 19.7599C12.5491 19.7399 12.5991 19.7199 12.6591 19.6999L11.5991 19.4499C6.98908 18.3599 5.47907 15.9199 6.55907 11.3199L7.53907 7.12993C7.60908 6.80993 7.68907 6.49993 7.77908 6.21993Z"
      fill="white"
    />
    <path
      d="M17.4894 10.51C17.4294 10.51 17.3694 10.5 17.2994 10.49L12.4494 9.26002C12.0494 9.16002 11.8094 8.75002 11.9094 8.35002C12.0094 7.95002 12.4194 7.71002 12.8194 7.81002L17.6694 9.04002C18.0694 9.14002 18.3094 9.55002 18.2094 9.95002C18.1294 10.28 17.8194 10.51 17.4894 10.51Z"
      fill="#FFE656"
    />
    <path
      d="M14.5592 13.8899C14.4992 13.8899 14.4392 13.8799 14.3692 13.8699L11.4592 13.1299C11.0592 13.0299 10.8192 12.6199 10.9192 12.2199C11.0192 11.8199 11.4292 11.5799 11.8292 11.6799L14.7392 12.4199C15.1392 12.5199 15.3792 12.9299 15.2792 13.3299C15.1992 13.6699 14.8992 13.8899 14.5592 13.8899Z"
      fill="#FFE656"
    />
  </svg>
);

const Profile2usersNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16055 11.62C9.13055 11.62 9.11055 11.62 9.08055 11.62C9.03055 11.61 8.96055 11.61 8.90055 11.62C6.00055 11.53 3.81055 9.25 3.81055 6.44C3.81055 3.58 6.14055 1.25 9.00055 1.25C11.8605 1.25 14.1905 3.58 14.1905 6.44C14.1805 9.25 11.9805 11.53 9.19055 11.62C9.18055 11.62 9.17055 11.62 9.16055 11.62ZM9.00055 2.75C6.97055 2.75 5.31055 4.41 5.31055 6.44C5.31055 8.44 6.87055 10.05 8.86055 10.12C8.92055 10.11 9.05055 10.11 9.18055 10.12C11.1405 10.03 12.6805 8.42 12.6905 6.44C12.6905 4.41 11.0305 2.75 9.00055 2.75Z"
      fill="white"
    />
    <path
      d="M16.5404 11.75C16.5104 11.75 16.4804 11.75 16.4504 11.74C16.0404 11.78 15.6204 11.49 15.5804 11.08C15.5404 10.67 15.7904 10.3 16.2004 10.25C16.3204 10.24 16.4504 10.24 16.5604 10.24C18.0204 10.16 19.1604 8.96 19.1604 7.49C19.1604 5.97 17.9304 4.74 16.4104 4.74C16.0004 4.75 15.6604 4.41 15.6604 4C15.6604 3.59 16.0004 3.25 16.4104 3.25C18.7504 3.25 20.6604 5.16 20.6604 7.5C20.6604 9.8 18.8604 11.66 16.5704 11.75C16.5604 11.75 16.5504 11.75 16.5404 11.75Z"
      fill="#FFE656"
    />
    <path
      d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
      fill="white"
    />
    <path
      d="M18.3402 20.75C17.9902 20.75 17.6802 20.51 17.6102 20.15C17.5302 19.74 17.7902 19.35 18.1902 19.26C18.8202 19.13 19.4002 18.88 19.8502 18.53C20.4202 18.1 20.7302 17.56 20.7302 16.99C20.7302 16.42 20.4202 15.88 19.8602 15.46C19.4202 15.12 18.8702 14.88 18.2202 14.73C17.8202 14.64 17.5602 14.24 17.6502 13.83C17.7402 13.43 18.1402 13.17 18.5502 13.26C19.4102 13.45 20.1602 13.79 20.7702 14.26C21.7002 14.96 22.2302 15.95 22.2302 16.99C22.2302 18.03 21.6902 19.02 20.7602 19.73C20.1402 20.21 19.3602 20.56 18.5002 20.73C18.4402 20.75 18.3902 20.75 18.3402 20.75Z"
      fill="#FFE656"
    />
  </svg>
);

const SettingNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
      fill="#FFE656"
    />
    <path
      d="M15.21 22.1898C15 22.1898 14.79 22.1598 14.58 22.1098C13.96 21.9398 13.44 21.5498 13.11 20.9998L12.99 20.7998C12.4 19.7798 11.59 19.7798 11 20.7998L10.89 20.9898C10.56 21.5498 10.04 21.9498 9.42 22.1098C8.79 22.2798 8.14 22.1898 7.59 21.8598L5.87 20.8698C5.26 20.5198 4.82 19.9498 4.63 19.2598C4.45 18.5698 4.54 17.8598 4.89 17.2498C5.18 16.7398 5.26 16.2798 5.09 15.9898C4.92 15.6998 4.49 15.5298 3.9 15.5298C2.44 15.5298 1.25 14.3398 1.25 12.8798V11.1198C1.25 9.6598 2.44 8.4698 3.9 8.4698C4.49 8.4698 4.92 8.2998 5.09 8.0098C5.26 7.7198 5.19 7.2598 4.89 6.7498C4.54 6.1398 4.45 5.4198 4.63 4.7398C4.81 4.0498 5.25 3.4798 5.87 3.1298L7.6 2.1398C8.73 1.4698 10.22 1.8598 10.9 3.0098L11.02 3.2098C11.61 4.2298 12.42 4.2298 13.01 3.2098L13.12 3.0198C13.8 1.8598 15.29 1.4698 16.43 2.1498L18.15 3.1398C18.76 3.4898 19.2 4.0598 19.39 4.7498C19.57 5.4398 19.48 6.1498 19.13 6.7598C18.84 7.2698 18.76 7.7298 18.93 8.0198C19.1 8.3098 19.53 8.4798 20.12 8.4798C21.58 8.4798 22.77 9.6698 22.77 11.1298V12.8898C22.77 14.3498 21.58 15.5398 20.12 15.5398C19.53 15.5398 19.1 15.7098 18.93 15.9998C18.76 16.2898 18.83 16.7498 19.13 17.2598C19.48 17.8698 19.58 18.5898 19.39 19.2698C19.21 19.9598 18.77 20.5298 18.15 20.8798L16.42 21.8698C16.04 22.0798 15.63 22.1898 15.21 22.1898ZM12 18.4898C12.89 18.4898 13.72 19.0498 14.29 20.0398L14.4 20.2298C14.52 20.4398 14.72 20.5898 14.96 20.6498C15.2 20.7098 15.44 20.6798 15.64 20.5598L17.37 19.5598C17.63 19.4098 17.83 19.1598 17.91 18.8598C17.99 18.5598 17.95 18.2498 17.8 17.9898C17.23 17.0098 17.16 15.9998 17.6 15.2298C18.04 14.4598 18.95 14.0198 20.09 14.0198C20.73 14.0198 21.24 13.5098 21.24 12.8698V11.1098C21.24 10.4798 20.73 9.9598 20.09 9.9598C18.95 9.9598 18.04 9.5198 17.6 8.7498C17.16 7.9798 17.23 6.9698 17.8 5.9898C17.95 5.7298 17.99 5.4198 17.91 5.1198C17.83 4.8198 17.64 4.5798 17.38 4.4198L15.65 3.4298C15.22 3.1698 14.65 3.3198 14.39 3.7598L14.28 3.9498C13.71 4.9398 12.88 5.4998 11.99 5.4998C11.1 5.4998 10.27 4.9398 9.7 3.9498L9.59 3.7498C9.34 3.3298 8.78 3.1798 8.35 3.4298L6.62 4.4298C6.36 4.5798 6.16 4.8298 6.08 5.1298C6 5.4298 6.04 5.7398 6.19 5.9998C6.76 6.9798 6.83 7.9898 6.39 8.7598C5.95 9.5298 5.04 9.9698 3.9 9.9698C3.26 9.9698 2.75 10.4798 2.75 11.1198V12.8798C2.75 13.5098 3.26 14.0298 3.9 14.0298C5.04 14.0298 5.95 14.4698 6.39 15.2398C6.83 16.0098 6.76 17.0198 6.19 17.9998C6.04 18.2598 6 18.5698 6.08 18.8698C6.16 19.1698 6.35 19.4098 6.61 19.5698L8.34 20.5598C8.55 20.6898 8.8 20.7198 9.03 20.6598C9.27 20.5998 9.47 20.4398 9.6 20.2298L9.71 20.0398C10.28 19.0598 11.11 18.4898 12 18.4898Z"
      fill="white"
    />
  </svg>
);

const ThreeDCubeIconNiko = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.2501C11.56 12.2501 11.12 12.1401 10.72 11.9301L4.21 8.4201C3.62 8.1001 3.25 7.4701 3.25 6.7701C3.25 6.0701 3.62 5.4401 4.21 5.1201L10.72 1.6101C11.52 1.1801 12.48 1.1801 13.27 1.6101L19.78 5.1201C20.37 5.4401 20.74 6.0701 20.74 6.7701C20.74 7.4701 20.37 8.1001 19.78 8.4201L13.27 11.9301C12.88 12.1501 12.44 12.2501 12 12.2501ZM12 2.7801C11.81 2.7801 11.61 2.8301 11.43 2.9301L4.93 6.4301C4.76 6.5201 4.75 6.7101 4.75 6.7701C4.75 6.8301 4.76 7.0201 4.93 7.1001L11.44 10.6101C11.8 10.8001 12.21 10.8001 12.57 10.6101L19.08 7.1001C19.24 7.0101 19.26 6.8201 19.26 6.7701C19.26 6.7101 19.25 6.5201 19.08 6.4401L12.57 2.9301C12.39 2.8301 12.19 2.7801 12 2.7801Z"
      fill="#FFE656"
    />
    <path
      d="M9.78 22.72C9.5 22.72 9.21 22.65 8.95 22.52L2.89 19.5C1.88 18.99 1.25 17.97 1.25 16.84V11.12C1.25 10.47 1.58 9.88001 2.13 9.54001C2.69 9.20001 3.36 9.17001 3.94 9.46001L10 12.48C11.01 12.99 11.64 14 11.64 15.14V20.86C11.64 21.51 11.31 22.1 10.76 22.44C10.46 22.63 10.12 22.72 9.78 22.72ZM3.11 10.76C3.03 10.76 2.96 10.79 2.92 10.81C2.86 10.85 2.75 10.94 2.75 11.12V16.84C2.75 17.4 3.06 17.91 3.56 18.16L9.61 21.19C9.77 21.27 9.9 21.21 9.96 21.18C10.02 21.14 10.13 21.05 10.13 20.87V15.15C10.13 14.59 9.82 14.08 9.32 13.83L3.27 10.8C3.21 10.77 3.16 10.76 3.11 10.76Z"
      fill="white"
    />
    <path
      d="M14.2194 22.72C13.8794 22.72 13.5394 22.63 13.2394 22.44C12.6894 22.1 12.3594 21.51 12.3594 20.86V15.14C12.3594 14.01 12.9894 12.99 13.9994 12.48L20.0494 9.45C20.6294 9.16 21.3094 9.19 21.8594 9.53C22.4094 9.87 22.7394 10.46 22.7394 11.11V16.83C22.7394 17.96 22.1094 18.98 21.0994 19.49L15.0494 22.52C14.7894 22.66 14.4994 22.72 14.2194 22.72ZM20.8894 10.76C20.8394 10.76 20.7894 10.77 20.7294 10.8L14.6794 13.83C14.1794 14.08 13.8694 14.58 13.8694 15.15V20.87C13.8694 21.05 13.9794 21.14 14.0394 21.18C14.0994 21.22 14.2294 21.27 14.3894 21.19L20.4394 18.16C20.9394 17.91 21.2494 17.4 21.2494 16.84V11.12C21.2494 10.94 21.1394 10.85 21.0794 10.81C21.0394 10.79 20.9694 10.76 20.8894 10.76Z"
      fill="white"
    />
  </svg>
);
const NikoGolestanIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24.7397C0.000747642 26.1176 0.54864 27.4388 1.52323 28.4129C2.49782 29.387 3.81933 29.9341 5.19723 29.9341H24.7313C25.4134 29.9341 26.0889 29.7998 26.7191 29.5387C27.3493 29.2777 27.9219 28.8951 28.4043 28.4127C28.8866 27.9304 29.2692 27.3578 29.5303 26.7275C29.7913 26.0973 29.9257 25.4219 29.9257 24.7397V5.18595C29.9234 3.80978 29.3752 2.49073 28.4013 1.51842C27.4274 0.546104 26.1074 -1.82519e-06 24.7313 0C23.3566 0.00223713 22.0388 0.549331 21.0667 1.5214C20.0946 2.49347 19.5475 3.81124 19.5453 5.18595V16.4659C19.5446 17.2776 19.2216 18.0559 18.6473 18.6296C18.0731 19.2033 17.2945 19.5256 16.4828 19.5256H5.20287C3.82448 19.5256 2.50254 20.0731 1.52787 21.0478C0.553202 22.0225 0.00564117 23.3444 0.00564117 24.7228L0 24.7397Z"
      fill="#FA4659"
    />
    <path
      d="M5.19723 17.1625H15.3689C15.7873 17.1625 16.1885 16.9965 16.4846 16.7009C16.7807 16.4054 16.9474 16.0044 16.9481 15.5861V5.41158C16.9474 4.03514 16.4006 2.71521 15.4279 1.74139C14.4551 0.767576 13.1358 0.21941 11.7593 0.21717C11.0765 0.216058 10.4001 0.349595 9.76892 0.61014C9.13773 0.870686 8.5641 1.25313 8.08086 1.73558C7.59762 2.21804 7.21425 2.79104 6.95267 3.42181C6.6911 4.05258 6.55646 4.72873 6.55647 5.41158V6.77081H5.19723C3.81884 6.77081 2.49691 7.31838 1.52224 8.29305C0.547565 9.26772 0 10.5897 0 11.968C0.000747642 13.346 0.54864 14.6672 1.52323 15.6412C2.49782 16.6153 3.81933 17.1625 5.19723 17.1625Z"
      fill="white"
    />
  </svg>
);

const EnvelopeIconAutoC = () => (
  <>
    <svg
      width={44}
      height={44}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_88_22)">
        <rect x={2} width={40} height={40} rx={10} fill="#8DCDDA"/>
        <rect
          x="2.5"
          y="0.5"
          width={39}
          height={39}
          rx="9.5"
          stroke="#BAE1E9"
        />
      </g>
      <path
        d="M27 11.5H17C14 11.5 12 13 12 16.5V23.5C12 27 14 28.5 17 28.5H27C30 28.5 32 27 32 23.5V16.5C32 13 30 11.5 27 11.5ZM27.47 17.59L24.34 20.09C23.68 20.62 22.84 20.88 22 20.88C21.16 20.88 20.31 20.62 19.66 20.09L16.53 17.59C16.21 17.33 16.16 16.85 16.41 16.53C16.67 16.21 17.14 16.15 17.46 16.41L20.59 18.91C21.35 19.52 22.64 19.52 23.4 18.91L26.53 16.41C26.85 16.15 27.33 16.2 27.58 16.53C27.84 16.85 27.79 17.33 27.47 17.59Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_88_22"
          x={0}
          y={0}
          width={44}
          height={44}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix"/>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2}/>
          <feGaussianBlur stdDeviation={1}/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_88_22"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_88_22"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </>
);

const NotificationBellIconAutoC = () => (
  <svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_88_22)">
      <rect x={2} width={40} height={40} rx={10} fill="#8DCDDA"/>
      <rect x="2.5" y="0.5" width={39} height={39} rx="9.5" stroke="#BAE1E9"/>
    </g>
    <path
      d="M27 11.5H17C14 11.5 12 13 12 16.5V23.5C12 27 14 28.5 17 28.5H27C30 28.5 32 27 32 23.5V16.5C32 13 30 11.5 27 11.5ZM27.47 17.59L24.34 20.09C23.68 20.62 22.84 20.88 22 20.88C21.16 20.88 20.31 20.62 19.66 20.09L16.53 17.59C16.21 17.33 16.16 16.85 16.41 16.53C16.67 16.21 17.14 16.15 17.46 16.41L20.59 18.91C21.35 19.52 22.64 19.52 23.4 18.91L26.53 16.41C26.85 16.15 27.33 16.2 27.58 16.53C27.84 16.85 27.79 17.33 27.47 17.59Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_88_22"
        x={0}
        y={0}
        width={44}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix"/>
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2}/>
        <feGaussianBlur stdDeviation={1}/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_88_22"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_88_22"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const PersonIconAutoC = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_88_20)">
      <rect x="2" width="40" height="40" rx="10" fill="#8DCDDA"/>
      <rect x="2.5" y="0.5" width="39" height="39" rx="9.5" stroke="#BAE1E9"/>
    </g>
    <path
      d="M22 10C19.38 10 17.25 12.13 17.25 14.75C17.25 17.32 19.26 19.4 21.88 19.49C21.96 19.48 22.04 19.48 22.1 19.49C22.12 19.49 22.13 19.49 22.15 19.49C22.16 19.49 22.16 19.49 22.17 19.49C24.73 19.4 26.74 17.32 26.75 14.75C26.75 12.13 24.62 10 22 10Z"
      fill="white"
    />
    <path
      d="M27.0809 22.1606C24.2909 20.3006 19.7409 20.3006 16.9309 22.1606C15.6609 23.0006 14.9609 24.1506 14.9609 25.3806C14.9609 26.6106 15.6609 27.7506 16.9209 28.5906C18.3209 29.5306 20.1609 30.0006 22.0009 30.0006C23.8409 30.0006 25.6809 29.5306 27.0809 28.5906C28.3409 27.7406 29.0409 26.6006 29.0409 25.3606C29.0309 24.1406 28.3409 22.9906 27.0809 22.1606Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_88_20"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2"/>
        <feGaussianBlur stdDeviation="1"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_88_20"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_88_20"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const LogoAutoC = () => (
  <svg
    width="40"
    height="39"
    viewBox="0 0 40 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.3111 14.2308C38.5294 11.695 37.2587 9.33895 35.5714 7.297C33.8841 5.25506 31.8133 3.56725 29.4772 2.32995C27.1412 1.09264 24.5856 0.330072 21.9564 0.0857774C19.3272 -0.158518 16.6759 0.120246 14.1539 0.906153C11.6319 1.69206 9.28851 2.96972 7.25759 4.66618C5.22668 6.36264 3.54798 8.44468 2.31736 10.7934C1.08674 13.1422 0.32829 15.7116 0.0853141 18.3551C-0.157661 20.9985 0.119597 23.6642 0.901259 26.1999C1.12341 26.8469 1.37867 27.4818 1.66599 28.1023C1.78424 28.3665 1.90644 28.6202 2.03258 28.8633C2.22573 29.2596 2.42677 29.6123 2.64752 29.9769C2.71059 30.08 2.76972 30.1791 2.83673 30.2821C2.90374 30.3852 2.99835 30.5437 3.08113 30.6785C3.16391 30.8132 3.23486 30.9123 3.3137 31.0233L3.44378 31.2135C3.55021 31.3641 3.72365 31.6098 3.83797 31.7525C3.89316 31.8318 3.95229 31.9071 4.01141 31.9824C4.07054 32.0577 4.05872 32.0418 4.08237 32.0735C4.15727 32.1726 4.23216 32.2638 4.311 32.3589C4.38983 32.4659 4.47261 32.565 4.55934 32.6641L4.74461 32.8781C4.82739 32.9811 4.91805 33.0802 5.00477 33.1793L5.30042 33.4964C5.39896 33.6034 5.49751 33.7064 5.6 33.8095L5.88381 34.0948L5.91535 34.1265L6.21888 34.4158L6.52634 34.6972C6.63278 34.7963 6.7392 34.8875 6.84958 34.9826C6.95995 35.0777 7.07032 35.1689 7.18069 35.26C7.62481 35.6273 8.08602 35.9761 8.5643 36.3063C8.80476 36.4688 9.04521 36.6274 9.29355 36.7819L9.68774 37.0356C9.79417 37.099 9.9006 37.1624 10.011 37.2219C10.2278 37.3447 10.4485 37.4676 10.6693 37.5825C10.8105 37.6585 10.9683 37.6983 11.1285 37.6983C11.2887 37.6983 11.4465 37.6585 11.5877 37.5825H11.6153L11.6469 37.5587C11.6981 37.527 11.7454 37.4914 11.7927 37.4557L11.844 37.42L11.9819 37.317L12.1159 37.21L12.1672 37.1664L12.3328 37.0237L12.4077 36.9563C12.4733 36.8955 12.5404 36.8321 12.6087 36.7661C12.6796 36.6987 12.7467 36.6274 12.8176 36.5521C12.9481 36.4154 13.0706 36.2712 13.1842 36.1201C13.2191 36.0832 13.2507 36.0434 13.2788 36.0012C13.3279 35.9581 13.374 35.9118 13.4168 35.8624L13.4562 35.803C13.4663 35.7919 13.4756 35.7799 13.4838 35.7673C13.4845 35.7581 13.4845 35.7488 13.4838 35.7396C13.5522 35.6223 13.5954 35.4918 13.6105 35.3566C13.6255 35.2215 13.6122 35.0846 13.5713 34.955C13.5304 34.8253 13.4629 34.7057 13.3732 34.604C13.2834 34.5022 13.1733 34.4206 13.0502 34.3643C13.0108 34.3643 12.9713 34.3287 12.9319 34.3049C12.8294 34.2573 12.7269 34.2098 12.6245 34.1543L12.3761 34.0274C12.1475 33.9046 11.9267 33.7817 11.706 33.6311C11.5877 33.5637 11.4734 33.4924 11.3591 33.4171C11.0871 33.2506 10.823 33.0723 10.5707 32.886C10.484 32.8266 10.3933 32.7631 10.3106 32.6958L9.97156 32.4382L9.68774 32.2122L9.48277 32.0418L9.40393 31.9745L9.21077 31.808C9.16741 31.7684 9.12405 31.7248 9.07675 31.6891L8.89542 31.5187C8.81264 31.4394 8.72986 31.3641 8.64708 31.2769C8.5643 31.1897 8.51306 31.1501 8.44605 31.0827C8.27654 30.9123 8.11493 30.7419 7.95331 30.5635L7.75621 30.3416C7.32052 29.8379 6.9151 29.3085 6.54211 28.7563L6.35684 28.4788L6.32925 28.4313C6.26618 28.3361 6.20705 28.241 6.15187 28.1499L6.10456 28.0746L5.9666 27.8407L5.89564 27.7258L5.73008 27.4246L5.56058 27.1075L5.52116 27.0243C5.46992 26.9292 5.41867 26.8301 5.37137 26.731V26.7033C5.31618 26.5923 5.26099 26.4774 5.20975 26.3624C5.04419 26.0018 4.89046 25.6292 4.75249 25.2527C4.6697 25.0297 4.63603 24.7913 4.6538 24.554C4.67157 24.3167 4.74035 24.086 4.85541 23.878C4.97047 23.67 5.12906 23.4896 5.32022 23.3492C5.51139 23.2089 5.73057 23.1119 5.96265 23.065C6.54753 22.9435 7.14322 22.8824 7.74045 22.8826C7.83042 22.8816 7.91647 22.8455 7.98046 22.7819C8.04445 22.7183 8.08135 22.6322 8.08339 22.5418C8.08691 22.5155 8.08691 22.4888 8.08339 22.4625C7.8615 21.525 7.74905 20.5647 7.74833 19.601C7.74747 18.8026 7.82538 18.006 7.9809 17.2231C8.03119 16.971 7.98082 16.7091 7.84069 16.4941C7.70055 16.279 7.48189 16.128 7.23194 16.0737L6.40415 15.8874C6.12771 15.8184 5.86944 15.69 5.64712 15.5109C5.4248 15.3319 5.24372 15.1066 5.11634 14.8504C4.98896 14.5943 4.91831 14.3134 4.90926 14.0272C4.9002 13.741 4.95296 13.4561 5.0639 13.1924C6.31245 10.2654 8.3876 7.77101 11.0323 6.01815C13.677 4.2653 16.775 3.331 19.9426 3.331C23.1102 3.331 26.2082 4.2653 28.8529 6.01815C31.4976 7.77101 33.5727 10.2654 34.8213 13.1924C34.9322 13.4561 34.985 13.741 34.9759 14.0272C34.9668 14.3134 34.8962 14.5943 34.7688 14.8504C34.6414 15.1066 34.4604 15.3319 34.238 15.5109C34.0157 15.69 33.7575 15.8184 33.481 15.8874L32.6532 16.0737C32.4033 16.128 32.1846 16.279 32.0445 16.4941C31.9043 16.7091 31.854 16.971 31.9043 17.2231C32.2469 18.958 32.2106 20.7471 31.7978 22.4665C31.7961 22.4929 31.7961 22.5194 31.7978 22.5458C31.7999 22.6362 31.8368 22.7223 31.9008 22.7859C31.9647 22.8495 32.0508 22.8856 32.1408 22.8866C32.738 22.8864 33.3337 22.9475 33.9186 23.0689C34.1498 23.1192 34.3674 23.2194 34.5564 23.3624C34.7453 23.5054 34.9012 23.688 35.0133 23.8975C35.1253 24.1069 35.1908 24.3383 35.2053 24.5757C35.2198 24.8131 35.1829 25.0508 35.0972 25.2725C34.9592 25.6688 34.8055 26.0216 34.6399 26.3822C34.5847 26.4972 34.5335 26.6121 34.4783 26.7231V26.7508C34.431 26.8499 34.3798 26.949 34.3285 27.0441L34.2891 27.1273L34.1196 27.4444L33.954 27.7456L33.8831 27.8605L33.7451 28.0944L33.6978 28.1697C33.6426 28.2608 33.5835 28.356 33.5204 28.4511C33.5098 28.466 33.5006 28.482 33.4928 28.4986L33.3076 28.7761C32.9346 29.3283 32.5292 29.8577 32.0935 30.3614L31.8964 30.5833C31.7348 30.7617 31.5731 30.9321 31.4036 31.1025C31.3366 31.1699 31.2696 31.2373 31.2026 31.2967C31.1356 31.3562 31.037 31.4592 30.9543 31.5385L30.7729 31.7089C30.7256 31.7446 30.6823 31.7882 30.6389 31.8278L30.4458 31.9943L30.3669 32.0616L30.1619 32.2321C30.0673 32.3113 29.9727 32.3866 29.8781 32.458L29.5391 32.7156L29.279 32.9058C29.0188 33.0921 28.7547 33.2705 28.4906 33.4369C28.3763 33.5122 28.262 33.5836 28.1437 33.6509C27.9229 33.7817 27.7022 33.9046 27.4736 34.0473L27.2252 34.1741C27.1227 34.2296 27.0203 34.2771 26.9178 34.3247C26.8782 34.3468 26.8374 34.3667 26.7956 34.3841C26.6732 34.4412 26.5639 34.5234 26.4749 34.6254C26.3859 34.7274 26.319 34.8469 26.2786 34.9763C26.2382 35.1058 26.225 35.2423 26.2401 35.3771C26.2551 35.512 26.298 35.6422 26.3659 35.7594C26.3652 35.7686 26.3652 35.7779 26.3659 35.7871C26.3741 35.7998 26.3834 35.8117 26.3935 35.8228L26.4329 35.8823C26.4622 35.9249 26.4938 35.9659 26.5275 36.0051C26.5556 36.0474 26.5873 36.0872 26.6221 36.124C26.7358 36.2752 26.8582 36.4194 26.9887 36.556C27.0597 36.6313 27.1267 36.7027 27.1976 36.77L27.3987 36.9603L27.4736 37.0277L27.6391 37.1703L27.6904 37.2139L27.8244 37.3209L27.9624 37.424L28.0018 37.4478C28.0491 37.4834 28.0964 37.5191 28.1476 37.5508L28.1752 37.5746H28.2068C28.3473 37.6506 28.5044 37.6903 28.664 37.6903C28.8236 37.6903 28.9807 37.6506 29.1213 37.5746C29.342 37.4597 29.5628 37.3368 29.7796 37.2139L30.1028 37.0277L30.5167 36.774C30.7651 36.6194 31.0055 36.4609 31.246 36.2984C31.7243 35.9681 32.1854 35.6194 32.6296 35.2521L32.9607 34.9747C33.0711 34.8796 33.1775 34.7884 33.2839 34.6893L33.5914 34.4079L33.8949 34.1186L33.9265 34.0869C34.0211 33.9957 34.1157 33.8967 34.2103 33.8015C34.3049 33.7064 34.4113 33.5954 34.5099 33.4884L34.8055 33.1714C34.8922 33.0723 34.9829 32.9732 35.0657 32.8702L35.2509 32.6561C35.3337 32.5571 35.4204 32.458 35.4993 32.351C35.5781 32.2558 35.653 32.1647 35.7279 32.0656C35.7516 32.0339 35.7791 32.0062 35.7989 31.9745C35.8186 31.9427 35.9171 31.8238 35.9723 31.7446C36.0827 31.5979 36.2561 31.3483 36.3665 31.2056L36.4966 31.0153L36.7252 30.6705C36.8119 30.5384 36.8947 30.4063 36.9735 30.2742L37.1627 29.969C37.3756 29.6044 37.5845 29.2319 37.7777 28.8553C37.9038 28.6043 38.026 28.3507 38.1443 28.0944C38.432 27.4746 38.686 26.8395 38.9051 26.192C40.2216 22.3303 40.3507 18.1594 39.2756 14.2228L39.3111 14.2308Z"
      fill="white"
    />
    <path
      d="M23.2439 30.8568C23.2439 30.9598 23.2439 31.0629 23.2439 31.1659C23.2426 32.3715 23.4979 33.5635 23.9929 34.6616C24.5625 35.9048 25.421 36.9923 26.496 37.8322C22.2518 39.3645 17.6097 39.3645 13.3655 37.8322C14.4405 36.9923 15.299 35.9048 15.8686 34.6616C16.3636 33.5635 16.6189 32.3715 16.6176 31.1659C16.6176 31.0629 16.6176 30.9598 16.6176 30.8568C16.6081 30.5529 16.5805 30.2498 16.5348 29.9492C16.4896 29.6191 16.4238 29.2921 16.3377 28.9703C15.9898 27.6765 15.3424 26.484 14.4483 25.49C13.5543 24.496 12.439 23.7288 11.1935 23.2512C10.9724 23.1716 10.7729 23.0408 10.6113 22.8694C10.4497 22.6979 10.3305 22.4907 10.2633 22.2644C9.80353 20.6076 9.77097 18.8603 10.1686 17.1874C10.2035 17.0404 10.2924 16.9122 10.4174 16.8284C10.5425 16.7446 10.6944 16.7114 10.8427 16.7356C13.851 17.2104 16.8915 17.4489 19.9367 17.449C22.9831 17.449 26.0249 17.2105 29.0346 16.7356C29.1829 16.7114 29.3348 16.7446 29.4598 16.8284C29.5849 16.9122 29.6737 17.0404 29.7086 17.1874C30.1063 18.8603 30.0737 20.6076 29.614 22.2644C29.5468 22.4907 29.4275 22.6979 29.2659 22.8694C29.1043 23.0408 28.9049 23.1716 28.6837 23.2512C27.4383 23.7288 26.323 24.496 25.4289 25.49C24.5349 26.484 23.8874 27.6765 23.5396 28.9703C23.4535 29.2921 23.3876 29.6191 23.3425 29.9492C23.2915 30.2495 23.2586 30.5525 23.2439 30.8568Z"
      fill="#FED246"
    />
  </svg>
);

const DashboardIconAutoC = () => (
  <>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H21C21.41 14.75 21.75 15.09 21.75 15.5C21.75 15.91 21.41 16.25 21 16.25Z"
        fill="#09859D"
      />
      <path
        d="M21 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z"
        fill="#09859D"
      />
      <path
        opacity="0.4"
        d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
        fill="#09859D"
      />
      <path
        d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
        fill="#09859D"
      />
      <path
        opacity="0.4"
        d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
        fill="#09859D"
      />
    </svg>
  </>
);
const PaymentAutoCIcon = () => (
  <>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
        fill="#09859D"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="#09859D"
      />
      <path
        d="M5.5 15.25C5.09 15.25 4.75 14.91 4.75 14.5V9.5C4.75 9.09 5.09 8.75 5.5 8.75C5.91 8.75 6.25 9.09 6.25 9.5V14.5C6.25 14.91 5.91 15.25 5.5 15.25Z"
        fill="#09859D"
      />
      <path
        d="M18.5 15.25C18.09 15.25 17.75 14.91 17.75 14.5V9.5C17.75 9.09 18.09 8.75 18.5 8.75C18.91 8.75 19.25 9.09 19.25 9.5V14.5C19.25 14.91 18.91 15.25 18.5 15.25Z"
        fill="#09859D"
      />
    </svg>
  </>
);
const SupportAutoCIcon = () => (
  <>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M2 12.97V6.99C2 4.23 4.24 2 7 2H17C19.76 2 22 4.23 22 6.99V13.97C22 16.72 19.76 18.95 17 18.95H15.5C15.19 18.95 14.89 19.1 14.7 19.35L13.2 21.34C12.54 22.22 11.46 22.22 10.8 21.34L9.3 19.35C9.14 19.13 8.78 18.95 8.5 18.95H7C4.24 18.95 2 16.72 2 13.97V12.97Z"
        fill="#09859D"
      />
      <path
        d="M12 12C11.44 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.56 12 12 12Z"
        fill="#09859D"
      />
      <path
        d="M16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z"
        fill="#09859D"
      />
      <path
        d="M8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12Z"
        fill="#09859D"
      />
    </svg>
  </>
);
const BusAutoCIcon = () => (
  <>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.9 22H7.10001C5.40001 22 4 20.61 4 18.9V5.10001C4 3.40001 5.39001 2 7.10001 2H16.9C18.6 2 20 3.39001 20 5.10001V18.9C20 20.61 18.61 22 16.9 22Z"
        fill="#09859D"
      />
      <path d="M20 8H4V13H20V8Z" fill="#09859D"/>
      <path
        d="M8 18.7501C7.92 18.7501 7.83999 18.7401 7.75999 18.7301C7.67999 18.7101 7.6 18.6901 7.52 18.6501C7.45 18.6201 7.37 18.5801 7.31 18.5401C7.24 18.4901 7.17 18.4401 7.12 18.3801C6.88 18.1501 6.75 17.8301 6.75 17.5001C6.75 17.1701 6.88 16.8501 7.12 16.6201C7.17 16.5601 7.24 16.5101 7.31 16.4601C7.37 16.4201 7.45 16.3801 7.52 16.3501C7.6 16.3101 7.67999 16.2901 7.75999 16.2701C8.15999 16.1901 8.59 16.3301 8.88 16.6201C9.12 16.8501 9.25 17.1701 9.25 17.5001C9.25 17.8301 9.12 18.1501 8.88 18.3801C8.65 18.6201 8.33 18.7501 8 18.7501Z"
        fill="#09859D"
      />
      <path
        d="M16 18.7501C15.92 18.7501 15.84 18.7401 15.76 18.7301C15.68 18.7101 15.6 18.6901 15.52 18.6501C15.45 18.6201 15.37 18.5801 15.31 18.5401C15.24 18.4901 15.17 18.4401 15.12 18.3801C14.88 18.1501 14.75 17.8301 14.75 17.5001C14.75 17.1701 14.88 16.8501 15.12 16.6201C15.17 16.5601 15.24 16.5101 15.31 16.4601C15.37 16.4201 15.45 16.3801 15.52 16.3501C15.6 16.3101 15.68 16.2901 15.76 16.2701C15.92 16.2401 16.08 16.2401 16.25 16.2701C16.32 16.2901 16.4 16.3101 16.48 16.3501C16.55 16.3801 16.63 16.4201 16.69 16.4601C16.76 16.5101 16.83 16.5601 16.88 16.6201C17.12 16.8501 17.25 17.1701 17.25 17.5001C17.25 17.8301 17.12 18.1501 16.88 18.3801C16.83 18.4401 16.76 18.4901 16.69 18.5401C16.63 18.5801 16.55 18.6201 16.48 18.6501C16.4 18.6901 16.32 18.7101 16.25 18.7301C16.16 18.7401 16.08 18.7501 16 18.7501Z"
        fill="#09859D"
      />
      <path
        d="M14.5 5.75H9.5C9.09 5.75 8.75 5.41 8.75 5C8.75 4.59 9.09 4.25 9.5 4.25H14.5C14.91 4.25 15.25 4.59 15.25 5C15.25 5.41 14.91 5.75 14.5 5.75Z"
        fill="#09859D"
      />
    </svg>
  </>
);
const SettingAutoCIcon = () => (
  <>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M2 12.8799V11.1199C2 10.0799 2.85 9.21994 3.9 9.21994C5.71 9.21994 6.45 7.93994 5.54 6.36994C5.02 5.46994 5.33 4.29994 6.24 3.77994L7.97 2.78994C8.76 2.31994 9.78 2.59994 10.25 3.38994L10.36 3.57994C11.26 5.14994 12.74 5.14994 13.65 3.57994L13.76 3.38994C14.23 2.59994 15.25 2.31994 16.04 2.78994L17.77 3.77994C18.68 4.29994 18.99 5.46994 18.47 6.36994C17.56 7.93994 18.3 9.21994 20.11 9.21994C21.15 9.21994 22.01 10.0699 22.01 11.1199V12.8799C22.01 13.9199 21.16 14.7799 20.11 14.7799C18.3 14.7799 17.56 16.0599 18.47 17.6299C18.99 18.5399 18.68 19.6999 17.77 20.2199L16.04 21.2099C15.25 21.6799 14.23 21.3999 13.76 20.6099L13.65 20.4199C12.75 18.8499 11.27 18.8499 10.36 20.4199L10.25 20.6099C9.78 21.3999 8.76 21.6799 7.97 21.2099L6.24 20.2199C5.33 19.6999 5.02 18.5299 5.54 17.6299C6.45 16.0599 5.71 14.7799 3.9 14.7799C2.85 14.7799 2 13.9199 2 12.8799Z"
        fill="#09859D"
      />
      <path
        d="M12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25Z"
        fill="#09859D"
      />
    </svg>
  </>
);
const TaxiAutoCIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M22.1796 13.66C22.0296 12.01 21.5896 10.25 18.3796 10.25H5.6196C2.4096 10.25 1.9796 12.01 1.8196 13.66L1.2596 19.75C1.1896 20.51 1.4396 21.27 1.9596 21.84C2.4896 22.42 3.2396 22.75 4.0396 22.75H5.9196C7.5396 22.75 7.8496 21.82 8.0496 21.21L8.2496 20.61C8.4796 19.92 8.5396 19.75 9.4396 19.75H14.5596C15.4596 19.75 15.4896 19.85 15.7496 20.61L15.9496 21.21C16.1496 21.82 16.4596 22.75 18.0796 22.75H19.9596C20.7496 22.75 21.5096 22.42 22.0396 21.84C22.5596 21.27 22.8096 20.51 22.7396 19.75L22.1796 13.66Z"
      fill="#09859D"
    />
    <path
      d="M21 7.25008H20C19.99 7.25008 19.99 7.25008 19.98 7.25008L19.6 5.44008C19.24 3.69008 18.49 2.08008 15.51 2.08008H12.75H11.25H8.49C5.51 2.08008 4.76 3.69008 4.4 5.44008L4.02 7.25008C4.01 7.25008 4.01 7.25008 4 7.25008H3C2.59 7.25008 2.25 7.59008 2.25 8.00008C2.25 8.41008 2.59 8.75008 3 8.75008H3.71L3.29 10.7501C3.83 10.4401 4.58 10.2501 5.62 10.2501H18.38C19.42 10.2501 20.17 10.4401 20.71 10.7501L20.29 8.75008H21C21.41 8.75008 21.75 8.41008 21.75 8.00008C21.75 7.59008 21.41 7.25008 21 7.25008Z"
      fill="#09859D"
    />
    <path
      d="M9 15.75H6C5.59 15.75 5.25 15.41 5.25 15C5.25 14.59 5.59 14.25 6 14.25H9C9.41 14.25 9.75 14.59 9.75 15C9.75 15.41 9.41 15.75 9 15.75Z"
      fill="#09859D"
    />
    <path
      d="M18 15.75H15C14.59 15.75 14.25 15.41 14.25 15C14.25 14.59 14.59 14.25 15 14.25H18C18.41 14.25 18.75 14.59 18.75 15C18.75 15.41 18.41 15.75 18 15.75Z"
      fill="#09859D"
    />
  </svg>
);

const CoinCardSvgBus = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="100" rx="10" fill="#FED246"/>
    <mask
      id="mask0_103_259"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_103_259)">
      <circle cx="192" cy="9" r="58" fill="white" fill-opacity="0.15"/>
    </g>
    <g clip-path="url(#clip0_103_259)">
      <path
        d="M166.394 46.0662C165.209 46.0662 164.245 45.232 164.245 44.2067C164.245 43.1813 165.209 42.3471 166.394 42.3471C167.579 42.3471 168.542 43.1813 168.542 44.2067C168.542 44.7459 168.98 45.1833 169.519 45.1833C170.058 45.1833 170.495 44.7459 170.495 44.2067C170.495 42.4171 169.162 40.9125 167.37 40.5041V39.9962C167.37 39.4569 166.933 39.0196 166.394 39.0196C165.855 39.0196 165.417 39.4569 165.417 39.9962V40.5041C163.626 40.9125 162.292 42.4171 162.292 44.2067C162.292 46.3089 164.132 48.0193 166.394 48.0193C167.579 48.0193 168.542 48.8535 168.542 49.8788C168.542 50.9042 167.579 51.7384 166.394 51.7384C165.209 51.7384 164.245 50.9042 164.245 49.8788C164.245 49.3396 163.808 48.9023 163.269 48.9023C162.73 48.9023 162.292 49.3396 162.292 49.8788C162.292 51.6684 163.626 53.1731 165.417 53.5815V54.0034C165.417 54.5426 165.855 54.9799 166.394 54.9799C166.933 54.9799 167.37 54.5426 167.37 54.0034V53.5815C169.162 53.1731 170.495 51.6684 170.495 49.8788C170.495 47.7765 168.656 46.0662 166.394 46.0662Z"
        fill="#FEE490"
      />
      <path
        d="M177.09 40.2574C175.814 38.2696 174.017 36.679 171.893 35.6577C171.406 35.4239 170.823 35.6286 170.589 36.1147C170.356 36.6008 170.56 37.1842 171.046 37.4179C174.748 39.1976 177.141 43.0002 177.141 47.1055C177.141 48.8621 176.708 50.6042 175.889 52.1437C175.635 52.6198 175.816 53.2112 176.292 53.4645C176.438 53.5422 176.595 53.5791 176.75 53.5791C177.099 53.5791 177.437 53.391 177.613 53.0611C178.582 51.2404 179.094 49.1809 179.094 47.1055C179.094 44.668 178.401 42.2999 177.09 40.2574Z"
        fill="#FEE490"
      />
      <path
        d="M167.929 34.4103L167.863 34.4102C167.324 34.4102 166.887 34.8474 166.887 35.3868C166.887 35.9261 167.324 36.3633 167.863 36.3633L167.92 36.3634C167.921 36.3634 167.923 36.3634 167.924 36.3634C168.462 36.3634 168.898 35.9293 168.901 35.3915C168.903 34.8521 168.468 34.4129 167.929 34.4103Z"
        fill="#FEE490"
      />
      <path
        d="M161.751 56.7931C158.049 55.0133 155.656 51.2107 155.656 47.1055C155.656 45.3489 156.089 43.6068 156.908 42.0673C157.162 41.5913 156.981 40.9998 156.505 40.7465C156.029 40.4932 155.437 40.6738 155.184 41.1499C154.215 42.9707 153.703 45.0301 153.703 47.1055C153.703 49.543 154.396 51.911 155.707 53.9536C156.983 55.9414 158.78 57.532 160.904 58.5534C161.041 58.619 161.185 58.65 161.327 58.65C161.691 58.65 162.04 58.446 162.208 58.0964C162.441 57.6103 162.237 57.0268 161.751 56.7931Z"
        fill="#FEE490"
      />
      <path
        d="M164.934 57.8477L164.877 57.8475C164.335 57.8465 163.899 58.28 163.896 58.8194C163.894 59.3588 164.329 59.7981 164.868 59.8006L164.934 59.8008C165.473 59.8008 165.91 59.3635 165.91 58.8242C165.91 58.285 165.473 57.8477 164.934 57.8477Z"
        fill="#FEE490"
      />
      <path
        d="M170.833 31.1062C170.714 30.823 170.568 30.5561 170.399 30.3086H172.941C175.418 30.3086 177.434 28.2933 177.434 25.8164C177.434 23.3394 175.418 21.3242 172.941 21.3242H165.121C165.618 20.6014 165.91 19.7268 165.91 18.7851C165.91 16.3082 163.895 14.293 161.418 14.293H137.492C135.015 14.293 133 16.3082 133 18.7851C133 21.2621 135.015 23.2773 137.492 23.2773H145.312C144.815 24.0002 144.523 24.8747 144.523 25.8164C144.523 26.7581 144.815 27.6326 145.312 28.3554H142.766C140.289 28.3554 138.273 30.3707 138.273 32.8476C138.273 34.2702 138.939 35.5396 139.974 36.3632C138.939 37.1869 138.273 38.4563 138.273 39.8789C138.273 41.3014 138.939 42.5708 139.974 43.3945C138.939 44.2181 138.273 45.4875 138.273 46.9101C138.273 48.3326 138.939 49.6021 139.974 50.4257C138.939 51.2493 138.273 52.5188 138.273 53.9413C138.273 56.4183 140.289 58.4335 142.766 58.4335H154.274C157.306 61.6764 161.619 63.707 166.398 63.707C175.553 63.707 183 56.2596 183 47.1055C183 39.4867 177.841 33.051 170.833 31.1062ZM172.941 23.2773C174.341 23.2773 175.48 24.4164 175.48 25.8164C175.48 27.2164 174.341 28.3554 172.941 28.3554H166.691H149.016C147.615 28.3554 146.477 27.2164 146.477 25.8164C146.477 24.4164 147.615 23.2773 149.016 23.2773H172.941ZM137.492 21.3242C136.092 21.3242 134.953 20.1851 134.953 18.7851C134.953 17.3852 136.092 16.2461 137.492 16.2461H161.418C162.818 16.2461 163.957 17.3852 163.957 18.7851C163.957 20.1851 162.818 21.3242 161.418 21.3242H137.492ZM142.766 30.3086H166.691C167.085 30.3086 167.461 30.4 167.799 30.5636C167.337 30.5249 166.87 30.504 166.398 30.504C161.814 30.504 157.658 32.372 154.651 35.3867H142.766C141.366 35.3867 140.227 34.2476 140.227 32.8476C140.227 31.4476 141.366 30.3086 142.766 30.3086ZM142.766 37.3398H152.982C151.873 38.8586 151.016 40.5717 150.472 42.4179H142.766C141.366 42.4179 140.227 41.279 140.227 39.8789C140.227 38.4789 141.366 37.3398 142.766 37.3398ZM142.766 44.371H150.023C149.875 45.261 149.797 46.1742 149.797 47.1055C149.797 47.901 149.854 48.6832 149.963 49.4492H142.766C141.366 49.4492 140.227 48.3102 140.227 46.9101C140.227 45.51 141.366 44.371 142.766 44.371ZM142.766 56.4804C141.366 56.4804 140.227 55.3414 140.227 53.9413C140.227 52.5412 141.366 51.4023 142.766 51.4023H150.362C150.855 53.2395 151.655 54.9517 152.705 56.4804H142.766ZM166.398 61.7539C158.321 61.7539 151.75 55.1826 151.75 47.1055C151.75 39.0284 158.321 32.4571 166.398 32.4571C174.476 32.4571 181.047 39.0284 181.047 47.1055C181.047 55.1826 174.476 61.7539 166.398 61.7539Z"
        fill="#FEE490"
      />
    </g>
    <defs>
      <clipPath id="clip0_103_259">
        <rect
          width="50"
          height="50"
          fill="white"
          transform="translate(133 14)"
        />
      </clipPath>
    </defs>
  </svg>
);

const CustomServiceCardBus = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="100" rx="10" fill="#FED246"/>
    <mask
      id="mask0_103_254"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_103_254)">
      <circle cx="192" cy="9" r="58" fill="white" fill-opacity="0.15"/>
    </g>
    <path
      d="M177.75 31.8437C177.756 31.7988 177.756 31.7533 177.75 31.7083C177.75 23.0937 170.333 16.0833 161.219 16.0833H156.792C147.667 16.0833 140.25 23.0937 140.25 31.7083C140.244 31.7533 140.244 31.7988 140.25 31.8437C139.356 32.0745 138.564 32.5957 137.999 33.3253C137.433 34.0549 137.126 34.9518 137.125 35.875V41.0833C137.125 42.1884 137.564 43.2482 138.345 44.0296C139.127 44.811 140.187 45.25 141.292 45.25H143.375C143.375 49.1177 144.911 52.827 147.646 55.562C150.381 58.2969 154.091 59.8333 157.958 59.8333H160.042C166.927 59.8333 172.365 55.1666 173.521 50.8125C174.769 50.2762 175.864 49.4387 176.708 48.375C177.445 47.4232 177.848 46.2555 177.854 45.0521C178.718 44.8049 179.48 44.2849 180.024 43.5696C180.568 42.8543 180.867 41.9822 180.875 41.0833V35.875C180.874 34.9518 180.567 34.0549 180.001 33.3253C179.436 32.5957 178.644 32.0745 177.75 31.8437ZM156.792 18.1666H161.219C169.187 18.1666 175.667 24.2396 175.667 31.7083H174.437C173.946 28.7978 172.439 26.1552 170.186 24.2487C167.932 22.3422 165.077 21.2946 162.125 21.2916H155.875C152.923 21.2946 150.068 22.3422 147.814 24.2487C145.561 26.1552 144.054 28.7978 143.563 31.7083H142.333C142.333 24.2396 148.812 18.1666 156.792 18.1666ZM172.542 33.7916H159.104C157.85 33.785 156.637 33.3462 155.67 32.5492C154.702 31.7522 154.039 30.6458 153.792 29.4166C153.778 29.2799 153.737 29.1471 153.673 29.0259C153.608 28.9048 153.519 28.7976 153.413 28.7106C153.307 28.6235 153.184 28.5583 153.052 28.5186C152.921 28.4789 152.783 28.4655 152.646 28.4791C152.509 28.4928 152.376 28.5333 152.255 28.5983C152.134 28.6633 152.027 28.7515 151.94 28.8579C151.853 28.9643 151.787 29.0868 151.748 29.2184C151.708 29.35 151.695 29.4882 151.708 29.625C151.708 30.1775 151.489 30.7074 151.098 31.0981C150.707 31.4888 150.178 31.7083 149.625 31.7083H145.667C146.147 29.3555 147.425 27.2408 149.286 25.7223C151.146 24.2037 153.474 23.3745 155.875 23.375H162.125C164.888 23.375 167.537 24.4724 169.491 26.426C171.444 28.3795 172.542 31.029 172.542 33.7916ZM141.292 43.1666C140.739 43.1666 140.209 42.9472 139.819 42.5565C139.428 42.1657 139.208 41.6358 139.208 41.0833V35.875C139.208 35.3224 139.428 34.7925 139.819 34.4018C140.209 34.0111 140.739 33.7916 141.292 33.7916H143.375V43.1666H141.292ZM164.01 50.4583C163.796 49.8521 163.4 49.3268 162.876 48.9539C162.352 48.5811 161.726 48.3789 161.083 48.375H156.917C156.088 48.375 155.293 48.7042 154.707 49.2903C154.121 49.8763 153.792 50.6712 153.792 51.5C153.792 52.3288 154.121 53.1236 154.707 53.7097C155.293 54.2957 156.088 54.625 156.917 54.625H161.083C161.728 54.6232 162.356 54.422 162.882 54.049C163.408 53.676 163.806 53.1495 164.021 52.5416C166.354 52.5358 168.678 52.2596 170.948 51.7187C169.323 54.8333 165.167 57.75 160.042 57.75H157.958C154.643 57.75 151.464 56.433 149.119 54.0888C146.775 51.7446 145.458 48.5652 145.458 45.25V33.7916H149.625C150.217 33.7909 150.801 33.6642 151.34 33.4199C151.879 33.1756 152.36 32.8194 152.75 32.375C153.43 33.4448 154.369 34.3262 155.479 34.9379C156.59 35.5496 157.836 35.8718 159.104 35.875H172.542V44.2083C172.542 44.4846 172.651 44.7495 172.847 44.9449C173.042 45.1402 173.307 45.25 173.583 45.25H175.75C175.703 45.9391 175.453 46.5989 175.031 47.1458C173.927 48.6041 171.115 50.3125 164.01 50.4583ZM162.125 51.5C162.125 51.7762 162.015 52.0412 161.82 52.2365C161.625 52.4319 161.36 52.5416 161.083 52.5416H156.917C156.64 52.5416 156.375 52.4319 156.18 52.2365C155.985 52.0412 155.875 51.7762 155.875 51.5C155.875 51.2237 155.985 50.9588 156.18 50.7634C156.375 50.5681 156.64 50.4583 156.917 50.4583H161.083C161.36 50.4583 161.625 50.5681 161.82 50.7634C162.015 50.9588 162.125 51.2237 162.125 51.5ZM178.792 41.0833C178.792 41.6358 178.572 42.1657 178.181 42.5565C177.791 42.9472 177.261 43.1666 176.708 43.1666H174.625V33.7916H176.708C177.261 33.7916 177.791 34.0111 178.181 34.4018C178.572 34.7925 178.792 35.3224 178.792 35.875V41.0833Z"
      fill="#FEE490"
    />
  </svg>
);

const MoneyCardSvgBus = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="100" rx="10" fill="#FED246"/>
    <mask
      id="mask0_103_253"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_103_253)">
      <circle cx="192" cy="9" r="58" fill="white" fill-opacity="0.1"/>
    </g>
    <g clip-path="url(#clip0_103_253)">
      <path
        d="M173.049 57.2448H134.042C133.765 57.2448 133.5 57.1351 133.305 56.9397C133.11 56.7444 133 56.4794 133 56.2031V33.876C133 33.5998 133.11 33.3348 133.305 33.1395C133.5 32.9441 133.765 32.8344 134.042 32.8344H173.049C173.325 32.8344 173.59 32.9441 173.786 33.1395C173.981 33.3348 174.091 33.5998 174.091 33.876V56.2031C174.091 56.4794 173.981 56.7444 173.786 56.9397C173.59 57.1351 173.325 57.2448 173.049 57.2448ZM135.083 55.1615H172.007V34.9177H135.083V55.1615Z"
        fill="#FEE490"
      />
      <path
        d="M166.333 54.0885H140.764C140.487 54.0885 140.222 53.9788 140.027 53.7835C139.832 53.5881 139.722 53.3231 139.722 53.0469C139.721 52.4925 139.5 51.961 139.108 51.5691C138.716 51.1772 138.185 50.9568 137.63 50.9563C137.354 50.9563 137.089 50.8465 136.894 50.6512C136.698 50.4558 136.589 50.1909 136.589 49.9146V40.1656C136.589 39.8894 136.698 39.6244 136.894 39.4291C137.089 39.2337 137.354 39.124 137.63 39.124C138.185 39.1231 138.716 38.9025 139.108 38.5104C139.5 38.1183 139.721 37.5868 139.722 37.0323C139.722 36.756 139.832 36.4911 140.027 36.2957C140.222 36.1004 140.487 35.9906 140.764 35.9906H166.333C166.61 35.9906 166.875 36.1004 167.07 36.2957C167.265 36.4911 167.375 36.756 167.375 37.0323C167.376 37.5854 167.595 38.1159 167.985 38.5078C168.376 38.8997 168.905 39.1212 169.458 39.124C169.735 39.124 170 39.2337 170.195 39.4291C170.39 39.6244 170.5 39.8894 170.5 40.1656V49.9146C170.5 50.1909 170.39 50.4558 170.195 50.6512C170 50.8465 169.735 50.9563 169.458 50.9563C168.904 50.9568 168.373 51.1772 167.981 51.5692C167.589 51.9611 167.368 52.4926 167.368 53.0469C167.368 53.3219 167.259 53.5857 167.065 53.7809C166.871 53.976 166.608 54.0866 166.333 54.0885ZM141.678 52.0052H165.428C165.614 51.284 165.989 50.6254 166.515 50.0972C167.04 49.569 167.696 49.1903 168.417 49V41.075C167.695 40.8872 167.036 40.5101 166.508 39.9825C165.981 39.4549 165.603 38.7961 165.416 38.074H141.673C141.485 38.7962 141.108 39.4551 140.581 39.9827C140.053 40.5103 139.394 40.8874 138.672 41.075V49C139.394 49.1881 140.054 49.5659 140.581 50.0943C141.109 50.6226 141.486 51.2824 141.673 52.0052H141.678Z"
        fill="#FEE490"
      />
      <path
        d="M153.546 50.7812C152.41 50.7815 151.3 50.4448 150.355 49.814C149.411 49.1831 148.675 48.2863 148.24 47.2371C147.806 46.1878 147.692 45.0332 147.913 43.9193C148.135 42.8054 148.682 41.7822 149.485 40.9792C150.288 40.1762 151.312 39.6295 152.426 39.4081C153.539 39.1867 154.694 39.3006 155.743 39.7355C156.792 40.1703 157.689 40.9066 158.32 41.8511C158.95 42.7956 159.287 43.9059 159.286 45.0417C159.284 46.5633 158.678 48.0219 157.602 49.0978C156.526 50.1737 155.067 50.779 153.546 50.7812ZM153.546 41.3823C152.822 41.3821 152.115 41.5964 151.513 41.9983C150.911 42.4001 150.442 42.9713 150.165 43.6397C149.888 44.3081 149.816 45.0436 149.957 45.7533C150.097 46.463 150.446 47.1149 150.957 47.6267C151.469 48.1385 152.12 48.4871 152.83 48.6285C153.54 48.7698 154.275 48.6976 154.944 48.4209C155.612 48.1442 156.184 47.6754 156.586 47.074C156.988 46.4725 157.203 45.7652 157.203 45.0417C157.203 44.0717 156.817 43.1415 156.131 42.4554C155.446 41.7694 154.516 41.3834 153.546 41.3823Z"
        fill="#FEE490"
      />
      <path
        d="M175.52 51.2792C175.253 51.2792 174.995 51.1765 174.802 50.9923C174.608 50.8081 174.493 50.5566 174.479 50.2896C174.466 50.0227 174.556 49.7609 174.73 49.5582C174.904 49.3556 175.15 49.2277 175.416 49.201L176.618 49.075L174.503 28.9427L140.969 32.4635C140.694 32.4924 140.419 32.4109 140.204 32.2369C139.989 32.063 139.852 31.8108 139.823 31.5359C139.795 31.261 139.876 30.986 140.05 30.7712C140.224 30.5564 140.476 30.4195 140.751 30.3906L175.318 26.7615C175.454 26.747 175.591 26.7596 175.723 26.7983C175.854 26.8371 175.976 26.9014 176.083 26.9875C176.189 27.0736 176.278 27.1798 176.343 27.3001C176.408 27.4204 176.449 27.5524 176.464 27.6885L178.796 49.8937C178.81 50.0299 178.798 50.1675 178.759 50.2988C178.72 50.4301 178.656 50.5524 178.57 50.6588C178.484 50.7652 178.377 50.8536 178.257 50.919C178.137 50.9843 178.005 51.0253 177.869 51.0396L175.63 51.275C175.593 51.2771 175.556 51.2792 175.52 51.2792Z"
        fill="#FEE490"
      />
      <path
        d="M180.257 45.0917C179.998 45.0915 179.749 44.9947 179.557 44.8203C179.365 44.6459 179.246 44.4063 179.221 44.1484C179.197 43.8905 179.269 43.6327 179.425 43.4253C179.58 43.218 179.807 43.076 180.061 43.0271L180.74 42.8969L176.925 23.0156L144.278 29.2781C144.006 29.3302 143.725 29.2722 143.496 29.1169C143.267 28.9616 143.109 28.7217 143.057 28.45C143.005 28.1783 143.063 27.897 143.219 27.6681C143.374 27.4391 143.614 27.2813 143.885 27.2292L177.556 20.7708C177.827 20.7189 178.108 20.7768 178.337 20.9317C178.565 21.0865 178.723 21.3258 178.775 21.5969L182.981 43.525C183.033 43.7963 182.975 44.0771 182.82 44.3056C182.665 44.5342 182.425 44.6918 182.154 44.7438L180.454 45.0698C180.389 45.0832 180.323 45.0905 180.257 45.0917Z"
        fill="#FEE490"
      />
    </g>
    <defs>
      <clipPath id="clip0_103_253">
        <rect
          width="50"
          height="50"
          fill="white"
          transform="translate(133 14)"
        />
      </clipPath>
    </defs>
  </svg>
);

const MessageCardSvgBus = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="100" rx="10" fill="#FED246"/>
    <mask
      id="mask0_103_255"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_103_255)">
      <circle cx="192" cy="9" r="58" fill="white" fillOpacity="0.15"/>
    </g>
    <g clipPath={"url(#clip0_103_255)"}>
      <mask
        id="mask1_103_255"
        style={{maskType: "luminance"}}
        maskUnits="userSpaceOnUse"
        x="133"
        y="13"
        width="50"
        height="50"
      >
        <path d="M183 13H133V63H183V13Z" fill="white"/>
        <path
          d="M160.441 38C160.441 39.3483 159.348 40.4414 158 40.4414C156.652 40.4414 155.559 39.3483 155.559 38C155.559 36.6517 156.652 35.5586 158 35.5586C159.348 35.5586 160.441 36.6517 160.441 38Z"
          fill="white"
        />
        <path
          d="M170.207 38C170.207 39.3483 169.114 40.4414 167.766 40.4414C166.417 40.4414 165.324 39.3483 165.324 38C165.324 36.6517 166.417 35.5586 167.766 35.5586C169.114 35.5586 170.207 36.6517 170.207 38Z"
          fill="white"
        />
        <path
          d="M150.676 38C150.676 39.3483 149.583 40.4414 148.234 40.4414C146.886 40.4414 145.793 39.3483 145.793 38C145.793 36.6517 146.886 35.5586 148.234 35.5586C149.583 35.5586 150.676 36.6517 150.676 38Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_103_255)">
        <mask
          id="mask2_103_255"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="133"
          y="13"
          width="50"
          height="50"
        >
          <path d="M133 13H183V63H133V13Z" fill="white"/>
        </mask>
        <g mask="url(#mask2_103_255)">
          <path
            d="M158 14.9531C145.272 14.9531 134.953 25.2716 134.953 38C134.953 42.481 136.233 46.6623 138.446 50.2009L134.953 61.0469L145.799 57.5541C149.338 59.7667 153.519 61.0469 158 61.0469C170.728 61.0469 181.047 50.7284 181.047 38C181.047 25.2716 170.728 14.9531 158 14.9531Z"
            stroke="#FEE490"
            stroke-width="3"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M160.441 38C160.441 39.3483 159.348 40.4414 158 40.4414C156.652 40.4414 155.559 39.3483 155.559 38C155.559 36.6517 156.652 35.5586 158 35.5586C159.348 35.5586 160.441 36.6517 160.441 38Z"
            fill="#FEE490"
          />
          <path
            d="M170.207 38C170.207 39.3483 169.114 40.4414 167.766 40.4414C166.417 40.4414 165.324 39.3483 165.324 38C165.324 36.6517 166.417 35.5586 167.766 35.5586C169.114 35.5586 170.207 36.6517 170.207 38Z"
            fill="#FEE490"
          />
          <path
            d="M150.676 38C150.676 39.3483 149.583 40.4414 148.234 40.4414C146.886 40.4414 145.793 39.3483 145.793 38C145.793 36.6517 146.886 35.5586 148.234 35.5586C149.583 35.5586 150.676 36.6517 150.676 38Z"
            fill="#FEE490"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_103_255">
        <rect
          width="50"
          height="50"
          fill="white"
          transform="translate(133 13)"
        />
      </clipPath>
    </defs>
  </svg>
);

const BusStopCardSvgBus = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="100" rx="10" fill="#FED246"/>
    <mask
      id="mask0_103_245"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_103_245)">
      <circle cx="192" cy="9" r="58" fill="white" fill-opacity="0.15"/>
    </g>
    <g clip-path="url(#clip0_103_245)">
      <path
        d="M181.535 57.0802H177.043V28.9249C178.014 29.4512 178.975 29.9952 179.924 30.5584C180.622 30.9729 181.52 30.7394 181.931 30.0465C182.344 29.3508 182.115 28.452 181.419 28.0391C170.316 21.4477 157.897 17.3343 145.039 15.9979C144.234 15.9148 143.514 16.4989 143.43 17.3036C143.347 18.1083 143.931 18.8284 144.736 18.912C146.722 19.1184 148.704 19.3969 150.676 19.7436V57.0803H141.789V45.1164C145.128 44.4359 147.648 41.4766 147.648 37.9395C147.648 33.901 144.363 30.6153 140.324 30.6153C136.286 30.6153 133 33.901 133 37.9395C133 41.4765 135.52 44.4358 138.859 45.1164V57.0802H134.465C133.656 57.0802 133 57.736 133 58.545C133 59.354 133.656 60.0098 134.465 60.0098H181.535C182.344 60.0098 183 59.354 183 58.545C183 57.736 182.344 57.0802 181.535 57.0802ZM135.93 37.9395C135.93 35.5164 137.901 33.545 140.324 33.545C142.747 33.545 144.719 35.5164 144.719 37.9395C144.719 40.3627 142.747 42.3341 140.324 42.3341C137.901 42.3341 135.93 40.3627 135.93 37.9395ZM168.895 25.0489H153.605V20.3118C158.828 21.4174 163.958 23.0079 168.895 25.0489ZM153.605 27.9786H174.113V57.0802H171.184C171.184 55.4466 171.184 42.937 171.184 40.9669C171.184 40.1579 170.528 39.502 169.719 39.502C168.91 39.502 168.254 40.1579 168.254 40.9669V48.2911H162.395C161.586 48.2911 160.93 48.947 160.93 49.7559C160.93 50.5649 161.586 51.2208 162.395 51.2208V57.0802H153.605V27.9786ZM168.254 51.2208V57.0802H165.324V51.2208H168.254Z"
        fill="#FEE490"
      />
    </g>
    <defs>
      <clipPath id="clip0_103_245">
        <rect
          width="50"
          height="50"
          fill="white"
          transform="translate(133 13)"
        />
      </clipPath>
    </defs>
  </svg>
);

const BusCardSvg = () => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="100" rx="10" fill="#FED246"/>
    <mask
      id="mask0_103_246"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="200"
      height="100"
    >
      <rect width="200" height="100" rx="10" fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_103_246)">
      <circle cx="192" cy="9" r="58" fill="white" fill-opacity="0.15"/>
    </g>
    <path
      d="M178.097 24.1233H176.855L174.343 19.3533C173.57 17.8783 172.04 16.955 170.375 16.9583H145.623C143.957 16.955 142.428 17.8783 141.653 19.3533L139.143 24.1233H137.902C135.427 24.1267 133.42 26.1333 133.417 28.6083V32.775C133.417 33.465 133.977 34.025 134.667 34.025C135.357 34.025 135.917 33.465 135.917 32.775V28.6083C135.918 27.5133 136.807 26.625 137.902 26.6233H174.852V53.8633C174.848 56.08 173.05 57.8767 170.833 57.8767H145.167C142.952 57.875 141.155 56.0783 141.153 53.8633V44.53C143.3 46.645 145.823 49.6983 149.167 49.4783H166.833C168.538 49.6117 173.562 47.8583 172.017 45.6283C171.533 45.095 170.687 45.0867 170.19 45.6083C169.295 46.4883 168.088 46.9817 166.833 46.9783H149.167C147.912 46.9817 146.705 46.4883 145.81 45.6083L141.143 41.0367V32.0367C141.143 30.4117 138.647 30.3967 138.643 32.0367V53.8633C138.643 57.51 141.653 60.45 145.297 60.3767C145.298 61.4183 145.053 62.9883 146.547 63.0417C148.04 62.9883 147.795 61.4167 147.797 60.3767H168.213C168.215 61.4183 167.97 62.9883 169.463 63.0417C170.957 62.9883 170.712 61.4167 170.713 60.3767C174.35 60.44 177.348 57.5033 177.348 53.8633V26.6233C178.715 26.4617 180.055 27.085 180.083 28.6083V32.775C180.09 34.4083 182.577 34.4117 182.583 32.775V28.6083C182.575 26.1333 180.572 24.13 178.097 24.1233ZM141.968 24.1233L143.867 20.5183C144.21 19.8667 144.887 19.4583 145.623 19.4583H170.375C171.112 19.4583 171.788 19.8667 172.132 20.5183L174.032 24.1233H141.968Z"
      fill="#FEE490"
    />
    <path
      d="M167.698 53.6783C167.738 55.9916 171.18 55.9916 171.218 53.6783C171.178 51.365 167.737 51.365 167.698 53.6783Z"
      fill="#FEE490"
    />
    <path
      d="M144.782 53.6783C144.822 55.9916 148.263 55.9916 148.302 53.6783C148.262 51.365 144.82 51.365 144.782 53.6783Z"
      fill="#FEE490"
    />
    <path
      d="M154.473 52.4283C152.842 52.435 152.837 54.9217 154.473 54.9283H161.525C163.157 54.9217 163.162 52.435 161.525 52.4283H154.473Z"
      fill="#FEE490"
    />
  </svg>
);

const NumberOfTaxiesBus = () => (
  <svg
    width={200}
    height={100}
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={200} height={100} rx={10} fill="#FED246"/>
    <mask
      id="mask0_123_18"
      style={{maskType: "alpha"}}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={200}
      height={100}
    >
      <rect width={200} height={100} rx={10} fill="#FD6F96"/>
    </mask>
    <g mask="url(#mask0_123_18)">
      <circle cx={192} cy={9} r={58} fill="white" fillOpacity="0.15"/>
    </g>
    <path
      d="M140.792 46.0883C140.943 52.0583 149.695 52.0567 149.845 46.0883C149.692 40.1167 140.948 40.1217 140.792 46.0883ZM147.345 46.0883C147.3 48.7517 143.337 48.7517 143.292 46.0883C143.337 43.4233 147.297 43.4267 147.345 46.0883Z"
      fill="#FEE490"
    />
    <path
      d="M166.203 46.0883C166.355 52.0583 175.107 52.0567 175.257 46.0883C175.103 40.1167 166.36 40.1217 166.203 46.0883ZM172.757 46.0883C172.712 48.7517 168.748 48.7517 168.703 46.0883C168.748 43.4233 172.708 43.4267 172.757 46.0883Z"
      fill="#FEE490"
    />
    <path
      d="M154.6 44.8383C152.967 44.845 152.963 47.3317 154.6 47.3383H161.448C163.08 47.3317 163.085 44.845 161.448 44.8383H154.6Z"
      fill="#FEE490"
    />
    <path
      d="M180.402 42.6667C179.712 42.65 179.138 43.1967 179.122 43.8867C179.08 45.62 179.018 49.0867 178.955 52.4067C165.198 54.455 150.84 54.4567 137.083 52.41C136.965 46.3 136.552 43.3567 138.338 38.4733H178.597C185.06 37.2667 182.793 27.4933 176.445 29.195L174.468 24.7833C172.7 21.015 167.918 21.765 164.462 21.5333V19.2967C164.46 17.6133 163.095 16.2483 161.412 16.2467H154.637C152.953 16.2483 151.588 17.6133 151.587 19.2967V21.5433C150.007 21.8 147.475 20.9283 147.338 22.9617C147.378 23.6483 147.962 24.1783 148.65 24.15C155.753 23.925 163.265 23.7133 170.333 24.4067C171.147 24.5667 171.84 25.0967 172.208 25.84C173.33 28.3433 175.625 33.4617 176.692 35.9733H139.358C140.435 33.46 142.712 28.345 143.845 25.8383C144.507 24.345 142.238 23.325 141.563 24.815L139.603 29.1883C134.418 27.5333 131.008 35.35 135.908 37.8683C133.673 43.79 134.693 49.1917 134.657 56.4733C134.978 63.8617 145.802 63.325 145.437 55.9333C152.827 56.65 163.223 56.655 170.613 55.9333C170.25 63.3217 181.07 63.86 181.39 56.4717C181.458 52.4083 181.557 46.415 181.622 43.9467C181.638 43.2567 181.092 42.6833 180.402 42.6667ZM161.962 21.4917C159.382 21.4567 156.607 21.4567 154.087 21.4933V19.2967C154.082 18.9917 154.332 18.7433 154.637 18.7467H161.412C161.717 18.7417 161.967 18.9917 161.962 19.2967V21.4917ZM178.718 31.6867C180.013 32.415 180.643 34.5817 179.2 35.48L177.482 31.5383C177.9 31.4667 178.328 31.5183 178.718 31.6867ZM136.06 33.5483C136.248 32.3733 137.308 31.2683 138.567 31.5383L136.848 35.48C136.2 35.07 135.883 34.295 136.06 33.5483ZM142.937 56.3733C142.952 57.97 141.672 59.2767 140.075 59.2917C137.633 59.295 136.932 57.005 137.132 54.93L142.937 55.655V56.3733ZM178.89 56.43C178.55 60.7167 172.54 59.9233 173.113 55.6567L178.917 54.935C178.907 55.45 178.898 55.955 178.89 56.43Z"
      fill="#FEE490"
    />
  </svg>
);

const ArrowRightSquareFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-arrow-right-square-fill"
    viewBox="0 0 16 16"
  >
    <path
      d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z"/>
  </svg>
);
const ArrowLeftSquareFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-arrow-left-square-fill"
    viewBox="0 0 16 16"
  >
    <path
      d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"/>
  </svg>
);

const PdfBootstrapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-filetype-pdf"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    />
  </svg>
);

const RavanhesabOmurMaliMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.84 13.5402H9.34C8.19 13.5402 7.26 12.5802 7.26 11.3902C7.26 10.9802 7.6 10.6402 8.01 10.6402C8.42 10.6402 8.76 10.9802 8.76 11.3902C8.76 11.7502 9.02 12.0402 9.34 12.0402H10.84C11.07 12.0402 11.25 11.8302 11.25 11.5702C11.25 11.2202 11.19 11.2002 10.96 11.1202L8.55 10.2802C7.68 9.9802 7.25 9.3702 7.25 8.4202C7.25 7.3402 8.11 6.4502 9.16 6.4502H10.66C11.81 6.4502 12.74 7.41019 12.74 8.60019C12.74 9.0102 12.4 9.35019 11.99 9.35019C11.58 9.35019 11.24 9.0102 11.24 8.60019C11.24 8.24019 10.98 7.9502 10.66 7.9502H9.16C8.93 7.9502 8.75 8.1602 8.75 8.4202C8.75 8.7702 8.81 8.7902 9.04 8.8702L11.45 9.7102C12.32 10.0202 12.74 10.6302 12.74 11.5702C12.75 12.6602 11.89 13.5402 10.84 13.5402Z"
      fill="#F5C364"
    />
    <path
      d="M10 14.3401C9.59 14.3401 9.25 14.0001 9.25 13.5901V12.8501C9.25 12.4401 9.59 12.1001 10 12.1001C10.41 12.1001 10.75 12.4401 10.75 12.8501V13.5901C10.75 14.0101 10.41 14.3401 10 14.3401Z"
      fill="#F5C364"
    />
    <path
      d="M10 7.94016C9.59 7.94016 9.25 7.60016 9.25 7.19016V6.41016C9.25 6.00016 9.59 5.66016 10 5.66016C10.41 5.66016 10.75 6.00016 10.75 6.41016V7.19016C10.75 7.60016 10.41 7.94016 10 7.94016Z"
      fill="#F5C364"
    />
    <path
      d="M9.99 18.7202C5.17 18.7202 1.25 14.8002 1.25 9.98024C1.25 5.16023 5.17 1.24023 9.99 1.24023C14.81 1.24023 18.73 5.16023 18.73 9.98024C18.73 14.8002 14.8 18.7202 9.99 18.7202ZM9.99 2.75023C6 2.75023 2.75 6.00023 2.75 9.99023C2.75 13.9802 6 17.2202 9.99 17.2202C13.98 17.2202 17.23 13.9702 17.23 9.98024C17.23 5.99024 13.98 2.75023 9.99 2.75023Z"
      fill="white"
    />
    <path
      d="M17.019 22.7198C15.169 22.7198 13.429 21.8198 12.359 20.2998C12.119 19.9598 12.199 19.4898 12.539 19.2498C12.879 19.0098 13.349 19.0898 13.589 19.4298C14.379 20.5498 15.659 21.2098 17.019 21.2098C19.339 21.2098 21.219 19.3298 21.219 17.0098C21.219 15.6598 20.559 14.3798 19.459 13.5898C19.119 13.3498 19.049 12.8798 19.289 12.5398C19.529 12.1998 19.999 12.1298 20.339 12.3698C21.829 13.4398 22.719 15.1698 22.719 17.0098C22.719 20.1698 20.169 22.7198 17.019 22.7198Z"
      fill="white"
    />
  </svg>
);

const RavanhesabHazinehaMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.74 22.75H6.26C3.77 22.75 1.75 20.73 1.75 18.24V11.51C1.75 9.02001 3.77 7 6.26 7H17.74C20.23 7 22.25 9.02001 22.25 11.51V12.95C22.25 13.36 21.91 13.7 21.5 13.7H19.48C19.13 13.7 18.81 13.83 18.58 14.07L18.57 14.08C18.29 14.35 18.16 14.72 18.19 15.1C18.25 15.76 18.88 16.29 19.6 16.29H21.5C21.91 16.29 22.25 16.63 22.25 17.04V18.23C22.25 20.73 20.23 22.75 17.74 22.75ZM6.26 8.5C4.6 8.5 3.25 9.85001 3.25 11.51V18.24C3.25 19.9 4.6 21.25 6.26 21.25H17.74C19.4 21.25 20.75 19.9 20.75 18.24V17.8H19.6C18.09 17.8 16.81 16.68 16.69 15.24C16.61 14.42 16.91 13.61 17.51 13.02C18.03 12.49 18.73 12.2 19.48 12.2H20.75V11.51C20.75 9.85001 19.4 8.5 17.74 8.5H6.26Z"
      fill="white"
    />
    <path
      d="M2.5 13.16C2.09 13.16 1.75 12.82 1.75 12.41V7.84006C1.75 6.35006 2.69 5.00001 4.08 4.47001L12.02 1.47001C12.84 1.16001 13.75 1.27005 14.46 1.77005C15.18 2.27005 15.6 3.08005 15.6 3.95005V7.75003C15.6 8.16003 15.26 8.50003 14.85 8.50003C14.44 8.50003 14.1 8.16003 14.1 7.75003V3.95005C14.1 3.57005 13.92 3.22003 13.6 3.00003C13.28 2.78003 12.9 2.73003 12.54 2.87003L4.6 5.87003C3.79 6.18003 3.24 6.97006 3.24 7.84006V12.41C3.25 12.83 2.91 13.16 2.5 13.16Z"
      fill="white"
    />
    <path
      d="M19.6005 17.8002C18.0905 17.8002 16.8105 16.6802 16.6905 15.2402C16.6105 14.4102 16.9105 13.6002 17.5105 13.0102C18.0205 12.4902 18.7205 12.2002 19.4705 12.2002H21.5505C22.5405 12.2302 23.3005 13.0102 23.3005 13.9702V16.0302C23.3005 16.9902 22.5405 17.7702 21.5805 17.8002H19.6005ZM21.5305 13.7002H19.4805C19.1305 13.7002 18.8105 13.8302 18.5805 14.0702C18.2905 14.3502 18.1505 14.7302 18.1905 15.1102C18.2505 15.7702 18.8805 16.3002 19.6005 16.3002H21.5605C21.6905 16.3002 21.8105 16.1802 21.8105 16.0302V13.9702C21.8105 13.8202 21.6905 13.7102 21.5305 13.7002Z"
      fill="#F5C364"
    />
    <path
      d="M14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z"
      fill="#F5C364"
    />
  </svg>
);

const RavanhesabBankMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 18.75C3.59 18.75 3.25 18.41 3.25 18V11C3.25 10.59 3.59 10.25 4 10.25C4.41 10.25 4.75 10.59 4.75 11V18C4.75 18.41 4.41 18.75 4 18.75Z"
      fill="#F5C364"
    />
    <path
      d="M8 18.75C7.59 18.75 7.25 18.41 7.25 18V11C7.25 10.59 7.59 10.25 8 10.25C8.41 10.25 8.75 10.59 8.75 11V18C8.75 18.41 8.41 18.75 8 18.75Z"
      fill="#F5C364"
    />
    <path
      d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V11C11.25 10.59 11.59 10.25 12 10.25C12.41 10.25 12.75 10.59 12.75 11V18C12.75 18.41 12.41 18.75 12 18.75Z"
      fill="#F5C364"
    />
    <path
      d="M16 18.75C15.59 18.75 15.25 18.41 15.25 18V11C15.25 10.59 15.59 10.25 16 10.25C16.41 10.25 16.75 10.59 16.75 11V18C16.75 18.41 16.41 18.75 16 18.75Z"
      fill="#F5C364"
    />
    <path
      d="M20 18.75C19.59 18.75 19.25 18.41 19.25 18V11C19.25 10.59 19.59 10.25 20 10.25C20.41 10.25 20.75 10.59 20.75 11V18C20.75 18.41 20.41 18.75 20 18.75Z"
      fill="#F5C364"
    />
    <path
      d="M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z"
      fill="white"
    />
    <path
      d="M12 9.25C10.76 9.25 9.75 8.24 9.75 7C9.75 5.76 10.76 4.75 12 4.75C13.24 4.75 14.25 5.76 14.25 7C14.25 8.24 13.24 9.25 12 9.25ZM12 6.25C11.59 6.25 11.25 6.59 11.25 7C11.25 7.41 11.59 7.75 12 7.75C12.41 7.75 12.75 7.41 12.75 7C12.75 6.59 12.41 6.25 12 6.25Z"
      fill="white"
    />
    <path
      d="M21 11.7501H3C2.04 11.7501 1.25 10.9601 1.25 10.0001V6.68013C1.25 6.00013 1.71998 5.31013 2.34998 5.06013L11.35 1.46016C11.73 1.31016 12.27 1.31016 12.65 1.46016L21.65 5.06013C22.28 5.31013 22.75 6.01013 22.75 6.68013V10.0001C22.75 10.9601 21.96 11.7501 21 11.7501ZM12 2.84016C11.96 2.84016 11.92 2.84011 11.9 2.85011L2.90997 6.45015C2.84997 6.48015 2.75 6.61013 2.75 6.68013V10.0001C2.75 10.1401 2.86 10.2501 3 10.2501H21C21.14 10.2501 21.25 10.1401 21.25 10.0001V6.68013C21.25 6.61013 21.16 6.48015 21.09 6.45015L12.09 2.85011C12.07 2.84011 12.04 2.84016 12 2.84016Z"
      fill="white"
    />
    <path
      d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22V19C1.25 18.04 2.04 17.25 3 17.25H21C21.96 17.25 22.75 18.04 22.75 19V22C22.75 22.41 22.41 22.75 22 22.75ZM2.75 21.25H21.25V19C21.25 18.86 21.14 18.75 21 18.75H3C2.86 18.75 2.75 18.86 2.75 19V21.25Z"
      fill="white"
    />
  </svg>
);
const RavanhesabPeopleMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.16055 11.62C9.13055 11.62 9.11055 11.62 9.08055 11.62C9.03055 11.61 8.96055 11.61 8.90055 11.62C6.00055 11.53 3.81055 9.25 3.81055 6.44C3.81055 3.58 6.14055 1.25 9.00055 1.25C11.8605 1.25 14.1905 3.58 14.1905 6.44C14.1805 9.25 11.9805 11.53 9.19055 11.62C9.18055 11.62 9.17055 11.62 9.16055 11.62ZM9.00055 2.75C6.97055 2.75 5.31055 4.41 5.31055 6.44C5.31055 8.44 6.87055 10.05 8.86055 10.12C8.92055 10.11 9.05055 10.11 9.18055 10.12C11.1405 10.03 12.6805 8.42 12.6905 6.44C12.6905 4.41 11.0305 2.75 9.00055 2.75Z"
      fill="white"
    />
    <path
      d="M16.5404 11.75C16.5104 11.75 16.4804 11.75 16.4504 11.74C16.0404 11.78 15.6204 11.49 15.5804 11.08C15.5404 10.67 15.7904 10.3 16.2004 10.25C16.3204 10.24 16.4504 10.24 16.5604 10.24C18.0204 10.16 19.1604 8.96 19.1604 7.49C19.1604 5.97 17.9304 4.74 16.4104 4.74C16.0004 4.75 15.6604 4.41 15.6604 4C15.6604 3.59 16.0004 3.25 16.4104 3.25C18.7504 3.25 20.6604 5.16 20.6604 7.5C20.6604 9.8 18.8604 11.66 16.5704 11.75C16.5604 11.75 16.5504 11.75 16.5404 11.75Z"
      fill="#F5C364"
    />
    <path
      d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
      fill="white"
    />
    <path
      d="M18.3402 20.75C17.9902 20.75 17.6802 20.51 17.6102 20.15C17.5302 19.74 17.7902 19.35 18.1902 19.26C18.8202 19.13 19.4002 18.88 19.8502 18.53C20.4202 18.1 20.7302 17.56 20.7302 16.99C20.7302 16.42 20.4202 15.88 19.8602 15.46C19.4202 15.12 18.8702 14.88 18.2202 14.73C17.8202 14.64 17.5602 14.24 17.6502 13.83C17.7402 13.43 18.1402 13.17 18.5502 13.26C19.4102 13.45 20.1602 13.79 20.7702 14.26C21.7002 14.96 22.2302 15.95 22.2302 16.99C22.2302 18.03 21.6902 19.02 20.7602 19.73C20.1402 20.21 19.3602 20.56 18.5002 20.73C18.4402 20.75 18.3902 20.75 18.3402 20.75Z"
      fill="#F5C364"
    />
  </svg>
);

const RavanhesabKalaMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.9991 13.3001C11.8691 13.3001 11.7391 13.2701 11.6191 13.2001L2.78911 8.0901C2.43911 7.8801 2.30911 7.4201 2.51911 7.0601C2.72911 6.7001 3.18911 6.5801 3.54911 6.7901L11.9991 11.6801L20.3991 6.8201C20.7591 6.6101 21.2191 6.7401 21.4291 7.0901C21.6391 7.4501 21.5091 7.9101 21.1591 8.1201L12.3891 13.2001C12.2591 13.2601 12.1291 13.3001 11.9991 13.3001Z"
      fill="#F5C364"
    />
    <path
      d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z"
      fill="#F5C364"
    />
    <path
      d="M12.0006 22.75C11.1206 22.75 10.2506 22.56 9.56063 22.18L4.22063 19.21C2.77063 18.41 1.64062 16.48 1.64062 14.82V9.17C1.64062 7.51 2.77063 5.59 4.22063 4.78L9.56063 1.82C10.9306 1.06 13.0706 1.06 14.4406 1.82L19.7806 4.79C21.2306 5.59 22.3606 7.52 22.3606 9.18V14.83C22.3606 16.49 21.2306 18.41 19.7806 19.22L14.4406 22.18C13.7506 22.56 12.8806 22.75 12.0006 22.75ZM12.0006 2.75C11.3706 2.75 10.7506 2.88 10.2906 3.13L4.95063 6.1C3.99063 6.63 3.14064 8.07 3.14064 9.17V14.82C3.14064 15.92 3.99063 17.36 4.95063 17.9L10.2906 20.87C11.2006 21.38 12.8006 21.38 13.7106 20.87L19.0506 17.9C20.0106 17.36 20.8606 15.93 20.8606 14.82V9.17C20.8606 8.07 20.0106 6.63 19.0506 6.09L13.7106 3.12C13.2506 2.88 12.6306 2.75 12.0006 2.75Z"
      fill="white"
    />
  </svg>
);

const RavanhesabAnbarMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.4997 22.7502H4.07973C2.50973 22.7502 1.21973 21.4902 1.21973 19.9302V5.09019C1.21973 3.56019 1.78973 2.37019 2.82973 1.72019C3.87973 1.06019 5.23973 1.08019 6.64973 1.78019L11.0897 3.96019C12.2997 4.56019 13.2497 6.07019 13.2497 7.41019V22.0002C13.2497 22.4102 12.9097 22.7502 12.4997 22.7502ZM4.55973 2.75019C4.20973 2.75019 3.88973 2.83019 3.61973 3.00019C3.03973 3.36019 2.71973 4.11019 2.71973 5.09019V19.9302C2.71973 20.6602 3.32973 21.2502 4.07973 21.2502H11.7497V7.41019C11.7497 6.64019 11.1297 5.65019 10.4197 5.31019L5.97973 3.13019C5.46973 2.88019 4.98973 2.75019 4.55973 2.75019Z"
      fill="white"
    />
    <path
      d="M18.81 22.7498H12.5C12.09 22.7498 11.75 22.4098 11.75 21.9998V10.4198C11.75 10.1898 11.85 9.97978 12.03 9.83978C12.21 9.69978 12.43 9.63978 12.66 9.68978L13.13 9.78978L19.67 11.2498C21.66 11.6898 22.66 12.8598 22.72 14.8498C22.73 14.8498 22.73 14.9498 22.73 15.0598V18.8398C22.72 21.3998 21.37 22.7498 18.81 22.7498ZM13.25 21.2498H18.81C20.57 21.2498 21.22 20.5998 21.22 18.8398V14.9798C21.17 13.6098 20.65 12.9998 19.34 12.7098L13.25 11.3498V21.2498Z"
      fill="white"
    />
    <path
      d="M8.97 9.75H5.5C5.09 9.75 4.75 9.41 4.75 9C4.75 8.59 5.09 8.25 5.5 8.25H8.97C9.38 8.25 9.72 8.59 9.72 9C9.72 9.41 9.39 9.75 8.97 9.75Z"
      fill="#F5C364"
    />
    <path
      d="M8.97 13.75H5.5C5.09 13.75 4.75 13.41 4.75 13C4.75 12.59 5.09 12.25 5.5 12.25H8.97C9.38 12.25 9.72 12.59 9.72 13C9.72 13.41 9.39 13.75 8.97 13.75Z"
      fill="#F5C364"
    />
    <path
      d="M15.2197 17.75C13.5697 17.75 12.2197 16.4 12.2197 14.75V10.52C12.2197 10.29 12.3197 10.08 12.4997 9.92998C12.6797 9.77998 12.9097 9.72998 13.1297 9.77998L17.6297 10.79C17.9697 10.87 18.2197 11.17 18.2197 11.52V14.74C18.2197 16.4 16.8797 17.75 15.2197 17.75ZM13.7197 11.46V14.75C13.7197 15.58 14.3897 16.25 15.2197 16.25C16.0497 16.25 16.7197 15.58 16.7197 14.75V12.13L13.7197 11.46Z"
      fill="white"
    />
    <path
      d="M19.7197 17.7501C18.0697 17.7501 16.7197 16.4001 16.7197 14.7501V11.5301C16.7197 11.3001 16.8197 11.0901 16.9997 10.9501C17.1797 10.8101 17.4097 10.7501 17.6297 10.8001L19.6597 11.2501C21.6497 11.6901 22.6497 12.8601 22.7097 14.8501C22.7097 14.8701 22.7097 14.8901 22.7097 14.9101C22.6297 16.5001 21.3197 17.7501 19.7197 17.7501ZM18.2197 12.4601V14.7501C18.2197 15.5801 18.8897 16.2501 19.7197 16.2501C20.5097 16.2501 21.1597 15.6401 21.2097 14.8601C21.1597 13.6001 20.6397 13.0001 19.3397 12.7101L18.2197 12.4601Z"
      fill="white"
    />
  </svg>
);

const RavanhesabSarmayeMenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM6.25 14.5C6.25 14.91 5.91 15.25 5.5 15.25C5.09 15.25 4.75 14.91 4.75 14.5V9.5C4.75 9.09 5.09 8.75 5.5 8.75C5.91 8.75 6.25 9.09 6.25 9.5V14.5ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15ZM19.25 14.5C19.25 14.91 18.91 15.25 18.5 15.25C18.09 15.25 17.75 14.91 17.75 14.5V9.5C17.75 9.09 18.09 8.75 18.5 8.75C18.91 8.75 19.25 9.09 19.25 9.5V14.5Z"
      fill="#C5C9CE"
    />
  </svg>
);

const RavanhesabFishMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22 9.25H2C1.59 9.25 1.25 8.91 1.25 8.5C1.25 8.09 1.59 7.75 2 7.75H22C22.41 7.75 22.75 8.09 22.75 8.5C22.75 8.91 22.41 9.25 22 9.25Z"
      fill="white"
    />
    <path
      d="M8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z"
      fill="#F5C364"
    />
    <path
      d="M14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
      fill="#F5C364"
    />
    <path
      d="M17.56 21.25H6.44C2.46 21.25 1.25 20.05 1.25 16.11V7.89C1.25 3.95 2.46 2.75 6.44 2.75H17.55C21.53 2.75 22.74 3.95 22.74 7.89V16.1C22.75 20.05 21.54 21.25 17.56 21.25ZM6.44 4.25C3.3 4.25 2.75 4.79 2.75 7.89V16.1C2.75 19.2 3.3 19.74 6.44 19.74H17.55C20.69 19.74 21.24 19.2 21.24 16.1V7.89C21.24 4.79 20.69 4.25 17.55 4.25H6.44Z"
      fill="white"
    />
  </svg>
);
const RavanhesabBilanSarmayeMenuIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1709 6.63953C18.7409 4.46953 17.1309 3.51953 14.8909 3.51953H6.11094C3.47094 3.51953 1.71094 4.83953 1.71094 7.91953V13.0695C1.71094 15.2895 2.62094 16.5895 4.12094 17.1495C4.34094 17.2295 4.58094 17.2995 4.83094 17.3395C5.23094 17.4295 5.66094 17.4695 6.11094 17.4695H14.9009C17.5409 17.4695 19.3009 16.1495 19.3009 13.0695V7.91953C19.3009 7.44953 19.2609 7.02953 19.1709 6.63953ZM5.53094 11.9995C5.53094 12.4095 5.19094 12.7495 4.78094 12.7495C4.37094 12.7495 4.03094 12.4095 4.03094 11.9995V8.99953C4.03094 8.58953 4.37094 8.24953 4.78094 8.24953C5.19094 8.24953 5.53094 8.58953 5.53094 8.99953V11.9995ZM10.5009 13.1395C9.04094 13.1395 7.86094 11.9595 7.86094 10.4995C7.86094 9.03953 9.04094 7.85953 10.5009 7.85953C11.9609 7.85953 13.1409 9.03953 13.1409 10.4995C13.1409 11.9595 11.9609 13.1395 10.5009 13.1395ZM16.9609 11.9995C16.9609 12.4095 16.6209 12.7495 16.2109 12.7495C15.8009 12.7495 15.4609 12.4095 15.4609 11.9995V8.99953C15.4609 8.58953 15.8009 8.24953 16.2109 8.24953C16.6209 8.24953 16.9609 8.58953 16.9609 8.99953V11.9995Z"
      fill="#C5C9CE"
    />
    <path
      d="M22.3017 10.9183V16.0683C22.3017 19.1483 20.5417 20.4783 17.8917 20.4783H9.11172C8.36172 20.4783 7.69172 20.3683 7.11172 20.1483C6.64172 19.9783 6.23172 19.7283 5.90172 19.4083C5.72172 19.2383 5.86172 18.9683 6.11172 18.9683H14.8917C18.5917 18.9683 20.7917 16.7683 20.7917 13.0783V7.91832C20.7917 7.67832 21.0617 7.52832 21.2317 7.70832C21.9117 8.42832 22.3017 9.47832 22.3017 10.9183Z"
      fill="#C5C9CE"
    />
  </svg>
);

const RavanhesabCalculatorMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14 22.75H10C4.57 22.75 2.25 20.43 2.25 15V9C2.25 3.57 4.57 1.25 10 1.25H14C19.43 1.25 21.75 3.57 21.75 9V15C21.75 20.43 19.43 22.75 14 22.75ZM10 2.75C5.39 2.75 3.75 4.39 3.75 9V15C3.75 19.61 5.39 21.25 10 21.25H14C18.61 21.25 20.25 19.61 20.25 15V9C20.25 4.39 18.61 2.75 14 2.75H10Z"
      fill="white"
    />
    <path
      d="M15 10.8301H9C7.76 10.8301 6.75 9.82008 6.75 8.58008V7.58008C6.75 6.34008 7.76 5.33008 9 5.33008H15C16.24 5.33008 17.25 6.34008 17.25 7.58008V8.58008C17.25 9.82008 16.24 10.8301 15 10.8301ZM9 6.83008C8.59 6.83008 8.25 7.17008 8.25 7.58008V8.58008C8.25 8.99008 8.59 9.33008 9 9.33008H15C15.41 9.33008 15.75 8.99008 15.75 8.58008V7.58008C15.75 7.17008 15.41 6.83008 15 6.83008H9Z"
      fill="#F5C364"
    />
    <path
      d="M8.15016 14.9201C8.02016 14.9201 7.89016 14.8901 7.77016 14.8401C7.65016 14.7901 7.54016 14.7201 7.45016 14.6301C7.26016 14.4401 7.16016 14.1901 7.16016 13.9201C7.16016 13.7901 7.18016 13.6601 7.23016 13.5401C7.28016 13.4101 7.35016 13.3101 7.45016 13.2101C7.49016 13.1701 7.54016 13.1201 7.60016 13.0901C7.65016 13.0501 7.71016 13.0201 7.77016 13.0001C7.83016 12.9701 7.90016 12.9501 7.96016 12.9401C8.28016 12.8701 8.63016 12.9801 8.86016 13.2101C8.95016 13.3001 9.03016 13.4101 9.08016 13.5401C9.13016 13.6601 9.16016 13.7901 9.16016 13.9201C9.16016 14.1901 9.05016 14.4401 8.86016 14.6301C8.67016 14.8201 8.42016 14.9201 8.15016 14.9201Z"
      fill="white"
    />
    <path
      d="M12.1602 14.9199C11.8902 14.9199 11.6402 14.8199 11.4502 14.6299C11.2602 14.4399 11.1602 14.1899 11.1602 13.9199C11.1602 13.7899 11.1802 13.6599 11.2302 13.5399C11.2802 13.4099 11.3502 13.3099 11.4502 13.2099C11.4902 13.1699 11.5402 13.1199 11.6002 13.0899C11.6502 13.0499 11.7102 13.0199 11.7702 12.9999C11.8302 12.9699 11.9002 12.9499 11.9602 12.9399C12.1502 12.8999 12.3502 12.9199 12.5402 12.9999C12.6602 13.0499 12.7702 13.1199 12.8602 13.2099C12.9502 13.3099 13.0302 13.4099 13.0802 13.5399C13.1302 13.6599 13.1602 13.7899 13.1602 13.9199C13.1602 14.1899 13.0502 14.4399 12.8602 14.6299C12.6702 14.8199 12.4202 14.9199 12.1602 14.9199Z"
      fill="white"
    />
    <path
      d="M16.1502 14.9201C16.0202 14.9201 15.8902 14.8901 15.7702 14.8401C15.6502 14.7901 15.5402 14.7201 15.4502 14.6301C15.3502 14.5301 15.2802 14.4201 15.2302 14.3001C15.1802 14.1801 15.1602 14.0501 15.1602 13.9201C15.1602 13.7901 15.1802 13.6601 15.2302 13.5401C15.2802 13.4101 15.3502 13.3101 15.4502 13.2101C15.8202 12.8401 16.4902 12.8401 16.8602 13.2101C17.0502 13.4001 17.1602 13.6601 17.1602 13.9201C17.1602 14.1901 17.0502 14.4401 16.8602 14.6301C16.6802 14.8101 16.4302 14.9201 16.1502 14.9201Z"
      fill="white"
    />
    <path
      d="M8.16039 18.9199C7.89039 18.9199 7.64039 18.8199 7.45039 18.6299C7.26039 18.4399 7.15039 18.1899 7.15039 17.9199C7.15039 17.6599 7.26039 17.3999 7.45039 17.2099C7.49039 17.1699 7.55039 17.1199 7.60039 17.0899C7.65039 17.0499 7.71039 17.0199 7.77039 16.9999C7.83039 16.9699 7.90039 16.9499 7.96039 16.9399C8.29039 16.8799 8.63039 16.9799 8.86039 17.2099C8.91039 17.2599 8.95039 17.3099 8.99039 17.3599C9.02039 17.4199 9.05039 17.4799 9.08039 17.5399C9.10039 17.5999 9.12039 17.6599 9.14039 17.7199C9.15039 17.7899 9.16039 17.8499 9.16039 17.9199C9.16039 18.1899 9.05039 18.4399 8.86039 18.6299C8.67039 18.8199 8.42039 18.9199 8.16039 18.9199Z"
      fill="white"
    />
    <path
      d="M12.1604 18.9199C11.8904 18.9199 11.6404 18.8199 11.4504 18.6299C11.2604 18.4399 11.1504 18.1899 11.1504 17.9199C11.1504 17.6599 11.2604 17.3999 11.4504 17.2099C11.6804 16.9799 12.0304 16.8799 12.3504 16.9399C12.4104 16.9499 12.4804 16.9699 12.5404 16.9999C12.6004 17.0199 12.6604 17.0499 12.7104 17.0899C12.7604 17.1199 12.8104 17.1699 12.8604 17.2099C13.0504 17.3999 13.1504 17.6599 13.1504 17.9199C13.1504 18.1899 13.0504 18.4399 12.8604 18.6299C12.6704 18.8199 12.4204 18.9199 12.1604 18.9199Z"
      fill="white"
    />
    <path
      d="M16.1502 18.92C15.8902 18.92 15.6402 18.82 15.4502 18.63C15.2602 18.44 15.1602 18.19 15.1602 17.92C15.1602 17.66 15.2602 17.4 15.4502 17.21C15.5402 17.12 15.6502 17.05 15.7702 17C16.1402 16.85 16.5902 16.93 16.8602 17.21C17.0502 17.4 17.1502 17.66 17.1502 17.92C17.1502 18.19 17.0502 18.44 16.8602 18.63C16.7702 18.72 16.6602 18.79 16.5402 18.84C16.4202 18.89 16.2902 18.92 16.1502 18.92Z"
      fill="white"
    />
  </svg>
);

const RavanhesabLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="28"
    viewBox="0 0 173 28"
    fill="none"
  >
    <path
      d="M124.03 0H124.017C122.401 0 121.088 1.31332 121.088 2.92871V19.122C121.088 20.7373 119.787 22.0507 118.185 22.0901C118.159 22.0901 118.145 22.0901 118.119 22.0901C116.49 22.0901 115.164 23.4165 115.164 25.045C115.164 26.6735 116.49 28 118.119 28C118.329 28 118.526 27.9737 118.71 27.9343C123.32 27.6191 126.972 23.8236 126.972 19.1351V2.94184C126.959 1.31332 125.645 0 124.03 0Z"
      fill="white"
    />
    <path
      d="M115.505 7.36773C115.505 3.29644 112.209 0 108.15 0C104.091 0 100.795 3.29644 100.795 7.3546V14.4597C100.795 16.0882 102.108 17.4015 103.737 17.4015C105.365 17.4015 106.679 16.0882 106.679 14.4597V7.3546C106.679 6.54034 107.336 5.88368 108.15 5.88368C108.964 5.88368 109.621 6.54034 109.621 7.3546V16.2064C109.621 19.4634 106.981 22.1032 103.724 22.1032C102.095 22.1032 100.781 23.4165 100.781 25.045C100.781 26.6735 102.095 27.9869 103.724 27.9869C110.225 27.9869 115.505 22.7073 115.505 16.2064V7.3546V7.36773Z"
      fill="white"
    />
    <path
      d="M94.8711 0.0263672H94.858C93.2424 0.0263672 91.929 1.33969 91.929 2.95507V25.0451C91.929 26.6736 93.2424 27.987 94.8711 27.987C96.4998 27.987 97.8132 26.6736 97.8132 25.0451V2.96821C97.8132 1.35282 96.4998 0.0395004 94.8842 0.0395004L94.8711 0.0263672Z"
      fill="white"
    />
    <path
      d="M68.313 0H59.4603C57.8447 0 56.5313 1.31332 56.5313 2.92871V14.4597C56.5313 16.0882 57.8447 17.4015 59.4734 17.4015C61.1021 17.4015 62.4155 16.0882 62.4155 14.4597V5.88368H65.384V16.1932C65.384 19.4503 62.7439 22.1032 59.4734 22.1032C56.2029 22.1032 53.5628 19.4634 53.5628 16.1932V8.82552C53.5628 7.21013 52.2494 5.89681 50.6338 5.89681H50.6207C49.0051 5.89681 47.6917 7.21013 47.6917 8.82552V20.6191C47.6917 21.4334 47.035 22.0901 46.2206 22.0901C45.4063 22.0901 44.7495 21.4334 44.7495 20.6191V8.83865C44.7495 7.22326 43.4361 5.90994 41.8205 5.90994H41.8074H41.7943C40.1787 5.90994 38.8653 7.22326 38.8653 8.83865V20.6323C38.8653 21.4465 38.2085 22.1032 37.3942 22.1032C36.5798 22.1032 35.9231 21.4465 35.9231 20.6323V8.83865C35.9231 7.22326 34.6097 5.90994 32.9941 5.90994H32.9678C31.3523 5.90994 30.0388 7.22326 30.0388 8.83865V20.6323C30.0388 21.4465 29.3821 22.1032 28.5678 22.1032C27.7534 22.1032 27.0967 21.4465 27.0967 20.6323V2.94184C27.0179 1.31332 25.7044 0 24.0889 0H24.0757C22.4602 0 21.1467 1.31332 21.1467 2.92871V20.6191C21.1467 24.6904 24.4435 27.9737 28.5021 27.9737C30.1702 27.9737 31.6938 27.3959 32.9284 26.4634C34.1631 27.3959 35.6867 27.9737 37.3548 27.9737C39.0229 27.9737 40.5465 27.3959 41.7811 26.4634C43.0158 27.3959 44.5394 27.9737 46.2075 27.9737C48.5192 27.9737 50.555 26.8837 51.9079 25.2289C53.9569 26.9493 56.5838 27.9737 59.4734 27.9737C65.975 27.9737 71.2551 22.6942 71.2551 16.1932V2.94184C71.242 1.31332 69.9285 0 68.313 0Z"
      fill="white"
    />
    <path
      d="M77.1655 5.90994C78.7942 5.90994 80.1208 4.58349 80.1208 2.95497C80.1208 1.32645 78.7942 0 77.1655 0C75.5368 0 74.2102 1.32645 74.2102 2.95497C74.2102 4.58349 75.5368 5.90994 77.1655 5.90994Z"
      fill="white"
    />
    <path
      d="M86.0182 0C84.3895 0 83.0761 1.31332 83.0761 2.94184V20.6191C83.0761 21.4465 82.4062 22.1032 81.5919 22.1032C80.7775 22.1032 80.1077 21.4334 80.1077 20.6191V12.2664C80.1077 10.6379 78.7942 9.32458 77.1655 9.32458C75.5368 9.32458 74.2234 10.6379 74.2234 12.2664V20.6191C74.2234 24.6904 77.5202 27.9869 81.5919 27.9869C85.6636 27.9869 88.9604 24.6904 88.9604 20.6191V2.94184C88.9604 1.32645 87.6469 0 86.0182 0Z"
      fill="white"
    />
    <path
      d="M14.8683 0C13.2528 0 11.9393 1.32645 11.9393 2.95497V9.37711C11.9393 11.0056 10.6127 12.3321 8.97091 12.3321H8.87897C7.23715 12.3321 5.91056 11.0056 5.91056 9.37711V2.95497C5.91056 1.33959 4.5971 0 2.95528 0C1.31346 0 0 1.32645 0 2.95497V9.37711C0 14.2627 3.95351 18.2158 8.83957 18.2158H8.95778C13.8438 18.2158 17.8105 14.2627 17.8105 9.37711V2.95497C17.8105 1.33959 16.4839 0 14.8552 0H14.8683Z"
      fill="white"
    />
    <path
      d="M8.90523 22.0901C7.27654 22.0901 5.94995 23.4165 5.94995 25.0451C5.94995 26.6736 7.27654 28 8.90523 28C10.5339 28 11.8605 26.6736 11.8605 25.0451C11.8605 23.4165 10.5339 22.0901 8.90523 22.0901Z"
      fill="white"
    />
    <path
      d="M162.939 0H155.058C149.502 0 144.997 4.50469 144.997 10.06V17.94C144.997 23.4953 149.502 28 155.058 28H162.939C168.495 28 173 23.4953 173 17.94V10.06C173 4.50469 168.495 0 162.939 0ZM155.518 17.1914C155.084 17.2702 154.651 17.3227 154.191 17.3227H150.303C148.964 17.3227 147.887 16.2458 147.887 14.9062C147.887 13.7373 148.714 12.7655 149.817 12.5422C149.975 12.5159 150.133 12.4897 150.303 12.4897H154.191C154.191 12.4897 154.244 12.4897 154.27 12.4897C155.584 12.4503 156.621 11.3865 156.621 10.06V6.63227C156.621 5.30582 157.698 4.21576 159.038 4.21576C160.378 4.21576 161.455 5.29268 161.455 6.63227V10.0732C161.455 11.2946 161.126 12.4371 160.588 13.4484C160.562 13.4878 160.535 13.5403 160.509 13.5797C160.351 13.8687 160.167 14.1576 159.97 14.4203C159.944 14.4465 159.918 14.4728 159.892 14.5122C159.524 14.985 159.09 15.4184 158.618 15.7861C158.539 15.8518 158.46 15.9174 158.381 15.9831C158.21 16.1013 158.027 16.2064 157.843 16.3114C157.646 16.4296 157.449 16.5347 157.238 16.6398C157.068 16.7186 156.91 16.7842 156.739 16.8499C156.477 16.955 156.214 17.0338 155.938 17.0994C155.794 17.1388 155.649 17.1782 155.505 17.2045L155.518 17.1914ZM159.012 23.7711C157.672 23.7711 156.595 22.6942 156.595 21.3546C156.595 20.015 157.672 18.9381 159.012 18.9381C160.351 18.9381 161.428 20.015 161.428 21.3546C161.428 22.6942 160.351 23.7711 159.012 23.7711ZM167.694 17.3227H159.419C161.034 16.1538 162.23 14.4597 162.794 12.4897H167.694C169.033 12.4897 170.11 13.5666 170.11 14.9062C170.11 16.2458 169.033 17.3227 167.694 17.3227Z"
      fill="white"
    />
  </svg>
);

const BlueRavanhesabLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="24"
      fill="none"
      viewBox="0 0 140 24"
    >
      <g fill="#0F67B1" clipPath="url(#clip0_953_183)">
        <path
          d="M106.3 0a2.51 2.51 0 00-2.51 2.521v13.88a2.557 2.557 0 01-2.477 2.544 2.534 2.534 0 000 5.066c.171-.002.34-.02.507-.056a7.576 7.576 0 007.081-7.542V2.52A2.508 2.508 0 00106.3 0zM98.994 6.315a6.316 6.316 0 10-12.619 0v6.068a2.521 2.521 0 105.043 0V6.315a1.272 1.272 0 112.533 0v7.587a5.054 5.054 0 01-5.02 5.044 2.532 2.532 0 000 5.054 10.131 10.131 0 0010.13-10.131l-.067-7.554zM81.31 0a2.51 2.51 0 00-2.51 2.544v18.923a2.522 2.522 0 005.043 0V2.544A2.511 2.511 0 0081.31 0zM58.536 0H50.95a2.511 2.511 0 00-2.544 2.522v9.86a2.521 2.521 0 105.043 0V5.044h2.544v8.848a5.066 5.066 0 01-10.13 0V7.576a2.51 2.51 0 00-2.466-2.51 2.51 2.51 0 00-2.533 2.51v10.131a1.273 1.273 0 01-2.533 0V7.576a2.511 2.511 0 00-5.02 0v10.131a1.272 1.272 0 01-2.533 0V7.576a2.512 2.512 0 00-2.556-2.51 2.51 2.51 0 00-2.51 2.51v10.131a1.272 1.272 0 01-2.533 0V2.522A2.51 2.51 0 0020.645 0a2.522 2.522 0 00-2.521 2.522v15.163A6.315 6.315 0 0024.439 24a6.236 6.236 0 003.782-1.295 6.18 6.18 0 007.588 0 6.202 6.202 0 008.679-1.058 10.131 10.131 0 0016.581-7.733V2.522A2.51 2.51 0 0058.536 0zM66.135 5.066a2.533 2.533 0 10-2.533-2.533 2.52 2.52 0 002.533 2.533z"></path>
        <path
          d="M73.722 0a2.533 2.533 0 00-2.521 2.522v15.152a1.272 1.272 0 01-2.544 0v-7.16a2.522 2.522 0 00-5.043 0v7.16a6.317 6.317 0 0010.78 4.465 6.315 6.315 0 001.85-4.465V2.522A2.521 2.521 0 0073.722 0zM12.743 0a2.522 2.522 0 00-2.522 2.533v5.505a2.544 2.544 0 01-2.544 2.532h-.09a2.544 2.544 0 01-2.544-2.532V2.533a2.522 2.522 0 10-5.043 0v5.505a7.576 7.576 0 007.576 7.575h.101a7.577 7.577 0 007.588-7.575V2.533A2.533 2.533 0 0012.742 0zM7.632 18.934a2.533 2.533 0 100 5.066 2.533 2.533 0 000-5.066zM131.077 0h-6.754a8.608 8.608 0 00-7.96 5.324 8.622 8.622 0 00-.652 3.299v6.754a8.622 8.622 0 002.518 6.097A8.612 8.612 0 00124.323 24h6.754a8.622 8.622 0 008.623-8.623V8.623A8.624 8.624 0 00131.077 0zm-6.349 14.736c-.371.07-.748.108-1.126.112h-3.377a2.07 2.07 0 01-1.66-3.292 2.07 2.07 0 011.244-.805 2.49 2.49 0 01.416 0h3.377a2.085 2.085 0 002.027-2.083V5.685a2.059 2.059 0 01.548-1.562 2.06 2.06 0 011.517-.662 2.071 2.071 0 012.066 2.224v2.95a6.097 6.097 0 01-.743 2.88 1.134 1.134 0 01-.056.114c-.138.25-.293.49-.462.72l-.067.079a5.925 5.925 0 01-1.126 1.125c-.068.057-.135.124-.203.17a3.889 3.889 0 01-.461.28 5.663 5.663 0 01-.507.282l-.439.18c-.219.088-.445.16-.675.214l-.293.056zm2.983 5.628a2.072 2.072 0 112.071-2.071 2.07 2.07 0 01-2.071 2.082v-.011zm7.441-5.527h-7.092a7.732 7.732 0 002.893-4.143h4.199a2.074 2.074 0 012.071 2.071 2.072 2.072 0 01-2.071 2.072z"></path>
      </g>
      <defs>
        <clipPath id="clip0_953_183">
          <path fill="#fff" d="M0 0H139.7V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

const ArkaLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="28"
      fill="none"
      viewBox="0 0 35 28"
    >
      <g clipPath="url(#clip0_187_170)">
        <path
          fill="#fff"
          d="M10.124 21.28H6.038C2.708 21.28 0 18.558 0 15.213V1.4C0 .627.624 0 1.393 0c.77 0 1.394.627 1.394 1.4v13.813a3.262 3.262 0 003.25 3.267h4.087a3.262 3.262 0 003.251-3.267v-4.106a3.262 3.262 0 00-3.25-3.267h-.372c-.77 0-1.393-.627-1.393-1.4 0-.773.624-1.4 1.393-1.4h.371c3.33 0 6.038 2.722 6.038 6.067v4.106c0 3.345-2.708 6.067-6.037 6.067z"
        ></path>
        <path
          fill="url(#paint0_linear_187_170)"
          d="M10.125 5.029h-.372c-.769 0-1.393.627-1.393 1.4 0 .773.624 1.4 1.393 1.4h.372a3.24 3.24 0 012.619 1.338c.829-.42 1.624-.875 2.411-1.422a6.031 6.031 0 00-5.03-2.716z"
        ></path>
        <path
          fill="#fff"
          d="M8.08 12.88c-.768 0-1.393-.627-1.393-1.4V6.067C6.688 2.722 9.396 0 12.726 0h5.387c.77 0 1.394.627 1.394 1.4 0 .773-.625 1.4-1.394 1.4h-5.387a3.262 3.262 0 00-3.25 3.267v5.413c0 .773-.625 1.4-1.394 1.4zM16.812 28h-3.715c-.77 0-1.393-.627-1.393-1.4 0-.773.624-1.4 1.393-1.4h3.715a3.262 3.262 0 003.251-3.267V16.52c0-.773.624-1.4 1.393-1.4.77 0 1.394.627 1.394 1.4v5.413c0 3.345-2.709 6.067-6.038 6.067zM28.144 21.28c-.769 0-1.393-.627-1.393-1.4V6.44c0-.773.624-1.4 1.393-1.4.77 0 1.394.627 1.394 1.4v13.44c0 .773-.625 1.4-1.394 1.4z"
        ></path>
        <path
          fill="#fff"
          d="M21.456 12.88c-.769 0-1.393-.627-1.393-1.4V6.067C20.063 2.722 22.772 0 26.101 0h7.059c.769 0 1.393.627 1.393 1.4 0 .773-.624 1.4-1.393 1.4H26.1a3.262 3.262 0 00-3.25 3.267v5.413c0 .773-.625 1.4-1.394 1.4z"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_187_170"
          x1="12.87"
          x2="10.157"
          y1="9.21"
          y2="4.536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.99" stopColor="#CBCBCB"></stop>
        </linearGradient>
        <clipPath id="clip0_187_170">
          <path fill="#fff" d="M0 0H34.553V28H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

const CalenderIcon = () => {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M8 6.25C7.59 6.25 7.25 5.91 7.25 5.5V2.5C7.25 2.09 7.59 1.75 8 1.75C8.41 1.75 8.75 2.09 8.75 2.5V5.5C8.75 5.91 8.41 6.25 8 6.25Z"
      fill="#DADADA"
    />
    <path
      d="M16 6.25C15.59 6.25 15.25 5.91 15.25 5.5V2.5C15.25 2.09 15.59 1.75 16 1.75C16.41 1.75 16.75 2.09 16.75 2.5V5.5C16.75 5.91 16.41 6.25 16 6.25Z"
      fill="#DADADA"
    />
    <path
      d="M8.5 15.0001C8.37 15.0001 8.24 14.9701 8.12 14.9201C7.99 14.8701 7.89 14.8001 7.79 14.7101C7.61 14.5201 7.5 14.2701 7.5 14.0001C7.5 13.8701 7.53 13.7401 7.58 13.6201C7.63 13.5001 7.7 13.3901 7.79 13.2901C7.89 13.2001 7.99 13.1301 8.12 13.0801C8.48 12.9301 8.93 13.0101 9.21 13.2901C9.39 13.4801 9.5 13.7401 9.5 14.0001C9.5 14.0601 9.49 14.1301 9.48 14.2001C9.47 14.2601 9.45 14.3201 9.42 14.3801C9.4 14.4401 9.37 14.5001 9.33 14.5601C9.3 14.6101 9.25 14.6601 9.21 14.7101C9.02 14.8901 8.76 15.0001 8.5 15.0001Z"
      fill="#DADADA"
    />
    <path
      d="M12 14.9999C11.87 14.9999 11.74 14.9699 11.62 14.9199C11.49 14.8699 11.39 14.7999 11.29 14.7099C11.11 14.5199 11 14.2699 11 13.9999C11 13.8699 11.03 13.7399 11.08 13.6199C11.13 13.4999 11.2 13.3899 11.29 13.2899C11.39 13.1999 11.49 13.1299 11.62 13.0799C11.98 12.9199 12.43 13.0099 12.71 13.2899C12.89 13.4799 13 13.7399 13 13.9999C13 14.0599 12.99 14.1299 12.98 14.1999C12.97 14.2599 12.95 14.3199 12.92 14.3799C12.9 14.4399 12.87 14.4999 12.83 14.5599C12.8 14.6099 12.75 14.6599 12.71 14.7099C12.52 14.8899 12.26 14.9999 12 14.9999Z"
      fill="#DADADA"
    />
    <path
      d="M15.5 14.9999C15.37 14.9999 15.24 14.9699 15.12 14.9199C14.99 14.8699 14.89 14.7999 14.79 14.7099C14.75 14.6599 14.71 14.6099 14.67 14.5599C14.63 14.4999 14.6 14.4399 14.58 14.3799C14.55 14.3199 14.53 14.2599 14.52 14.1999C14.51 14.1299 14.5 14.0599 14.5 13.9999C14.5 13.7399 14.61 13.4799 14.79 13.2899C14.89 13.1999 14.99 13.1299 15.12 13.0799C15.49 12.9199 15.93 13.0099 16.21 13.2899C16.39 13.4799 16.5 13.7399 16.5 13.9999C16.5 14.0599 16.49 14.1299 16.48 14.1999C16.47 14.2599 16.45 14.3199 16.42 14.3799C16.4 14.4399 16.37 14.4999 16.33 14.5599C16.3 14.6099 16.25 14.6599 16.21 14.7099C16.02 14.8899 15.76 14.9999 15.5 14.9999Z"
      fill="#DADADA"
    />
    <path
      d="M8.5 18.4999C8.37 18.4999 8.24 18.47 8.12 18.42C8 18.37 7.89 18.2999 7.79 18.2099C7.61 18.0199 7.5 17.7599 7.5 17.4999C7.5 17.3699 7.53 17.2399 7.58 17.1199C7.63 16.9899 7.7 16.88 7.79 16.79C8.16 16.42 8.84 16.42 9.21 16.79C9.39 16.98 9.5 17.2399 9.5 17.4999C9.5 17.7599 9.39 18.0199 9.21 18.2099C9.02 18.3899 8.76 18.4999 8.5 18.4999Z"
      fill="#DADADA"
    />
    <path
      d="M12 18.4999C11.74 18.4999 11.48 18.3899 11.29 18.2099C11.11 18.0199 11 17.7599 11 17.4999C11 17.3699 11.03 17.2399 11.08 17.1199C11.13 16.9899 11.2 16.88 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.8 16.88 12.87 16.9899 12.92 17.1199C12.97 17.2399 13 17.3699 13 17.4999C13 17.7599 12.89 18.0199 12.71 18.2099C12.52 18.3899 12.26 18.4999 12 18.4999Z"
      fill="#DADADA"
    />
    <path
      d="M15.5 18.4999C15.24 18.4999 14.98 18.3899 14.79 18.2099C14.7 18.1199 14.63 18.0099 14.58 17.8799C14.53 17.7599 14.5 17.6299 14.5 17.4999C14.5 17.3699 14.53 17.2399 14.58 17.1199C14.63 16.9899 14.7 16.8799 14.79 16.7899C15.02 16.5599 15.37 16.4499 15.69 16.5199C15.76 16.5299 15.82 16.5499 15.88 16.5799C15.94 16.5999 16 16.6299 16.06 16.6699C16.11 16.6999 16.16 16.7499 16.21 16.7899C16.39 16.9799 16.5 17.2399 16.5 17.4999C16.5 17.7599 16.39 18.0199 16.21 18.2099C16.02 18.3899 15.76 18.4999 15.5 18.4999Z"
      fill="#DADADA"
    />
    <path
      d="M20.5 10.3398H3.5C3.09 10.3398 2.75 9.99984 2.75 9.58984C2.75 9.17984 3.09 8.83984 3.5 8.83984H20.5C20.91 8.83984 21.25 9.17984 21.25 9.58984C21.25 9.99984 20.91 10.3398 20.5 10.3398Z"
      fill="#DADADA"
    />
    <path
      d="M16 23.25H8C4.35 23.25 2.25 21.15 2.25 17.5V9C2.25 5.35 4.35 3.25 8 3.25H16C19.65 3.25 21.75 5.35 21.75 9V17.5C21.75 21.15 19.65 23.25 16 23.25ZM8 4.75C5.14 4.75 3.75 6.14 3.75 9V17.5C3.75 20.36 5.14 21.75 8 21.75H16C18.86 21.75 20.25 20.36 20.25 17.5V9C20.25 6.14 18.86 4.75 16 4.75H8Z"
      fill="#DADADA"
    />
  </svg>

}
const AddToTableIcon = () => <div style={{
  background: '#5D70B5', borderRadius: 10, padding: 8,
  width: "max-content"
}}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M15.3337 12.2188H7.66699C7.27408 12.2188 6.94824 11.8929 6.94824 11.5C6.94824 11.1071 7.27408 10.7812 7.66699 10.7812H15.3337C15.7266 10.7812 16.0524 11.1071 16.0524 11.5C16.0524 11.8929 15.7266 12.2188 15.3337 12.2188Z"
      fill="white"
    />
    <path
      d="M11.5 16.0522C11.1071 16.0522 10.7812 15.7263 10.7812 15.3334V7.66675C10.7812 7.27383 11.1071 6.948 11.5 6.948C11.8929 6.948 12.2188 7.27383 12.2188 7.66675V15.3334C12.2188 15.7263 11.8929 16.0522 11.5 16.0522Z"
      fill="white"
    />
    <path
      d="M14.3753 21.8022H8.62533C3.42158 21.8022 1.19824 19.5788 1.19824 14.3751V8.62508C1.19824 3.42133 3.42158 1.198 8.62533 1.198H14.3753C19.5791 1.198 21.8024 3.42133 21.8024 8.62508V14.3751C21.8024 19.5788 19.5791 21.8022 14.3753 21.8022ZM8.62533 2.6355C4.20741 2.6355 2.63574 4.20716 2.63574 8.62508V14.3751C2.63574 18.793 4.20741 20.3647 8.62533 20.3647H14.3753C18.7932 20.3647 20.3649 18.793 20.3649 14.3751V8.62508C20.3649 4.20716 18.7932 2.6355 14.3753 2.6355H8.62533Z"
      fill="white"
    />
  </svg>
</div>

const SearchIconSubmitDoc = () => <svg
  width={24}
  height={25}
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="search-normal-1 1">
    <path
      id="Vector"
      d="M11.5 22.25C5.85 22.25 1.25 17.65 1.25 12C1.25 6.35 5.85 1.75 11.5 1.75C17.15 1.75 21.75 6.35 21.75 12C21.75 17.65 17.15 22.25 11.5 22.25ZM11.5 3.25C6.67 3.25 2.75 7.18 2.75 12C2.75 16.82 6.67 20.75 11.5 20.75C16.33 20.75 20.25 16.82 20.25 12C20.25 7.18 16.33 3.25 11.5 3.25Z"
      fill="#DADADA"
    />
    <path
      id="Vector_2"
      d="M22.0004 23.2499C21.8104 23.2499 21.6204 23.1799 21.4704 23.0299L19.4704 21.0299C19.1804 20.7399 19.1804 20.2599 19.4704 19.9699C19.7604 19.6799 20.2404 19.6799 20.5304 19.9699L22.5304 21.9699C22.8204 22.2599 22.8204 22.7399 22.5304 23.0299C22.3804 23.1799 22.1904 23.2499 22.0004 23.2499Z"
      fill="#DADADA"
    />
  </g>
</svg>

const Spinner = () => <>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{
      margin: "auto",
      background: "rgb(241, 242, 243)",
      display: "block",
      shapeRendering: "auto"
    }}
    width="50px"
    height="50px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx={50}
      cy={50}
      r={32}
      strokeWidth={8}
      stroke="#1d3f72"
      strokeDasharray="50.26548245743669 50.26548245743669"
      fill="none"
      strokeLinecap="round"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1s"
        keyTimes="0;1"
        values="0 50 50;360 50 50"
      />
    </circle>
  </svg>
</>

const PlusIcon = () => <svg
  width={25}
  height={25}
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.5 23.25C6.57 23.25 1.75 18.43 1.75 12.5C1.75 6.57 6.57 1.75 12.5 1.75C18.43 1.75 23.25 6.57 23.25 12.5C23.25 18.43 18.43 23.25 12.5 23.25ZM12.5 3.25C7.4 3.25 3.25 7.4 3.25 12.5C3.25 17.6 7.4 21.75 12.5 21.75C17.6 21.75 21.75 17.6 21.75 12.5C21.75 7.4 17.6 3.25 12.5 3.25Z"
    fill="#5D70B5"
  />
  <path
    d="M16.5 13.25H8.5C8.09 13.25 7.75 12.91 7.75 12.5C7.75 12.09 8.09 11.75 8.5 11.75H16.5C16.91 11.75 17.25 12.09 17.25 12.5C17.25 12.91 16.91 13.25 16.5 13.25Z"
    fill="#5D70B5"
  />
  <path
    d="M12.5 17.25C12.09 17.25 11.75 16.91 11.75 16.5V8.5C11.75 8.09 12.09 7.75 12.5 7.75C12.91 7.75 13.25 8.09 13.25 8.5V16.5C13.25 16.91 12.91 17.25 12.5 17.25Z"
    fill="#5D70B5"
  />
</svg>

const ReviewAccountButton = () => <div style={{
  width: 35,
  height: 35,
  background: '#F1F1F1',
  display: "flex",
  justifyContent: 'center',
  alignItems: "center",
  borderRadius: 5,
  margin: '0 5px',
  padding: '5px',
  cursor: "pointer",
}}>
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="copy-link-svgrepo-com 1" clipPath="url(#clip0_1708_24)">
      <path
        id="Vector"
        d="M3.46347 12C2.78383 12.0001 2.11942 11.7954 1.55427 11.4117C0.989121 11.0279 0.54863 10.4825 0.288514 9.84422C0.0283991 9.20599 -0.0396544 8.50367 0.0929617 7.82612C0.225578 7.14857 0.552906 6.52621 1.03354 6.03778L4.57889 2.43475C5.22329 1.77968 6.09731 1.41165 7.00866 1.41162C7.92002 1.41159 8.79406 1.77955 9.43851 2.43457C10.083 3.08958 10.445 3.97799 10.4451 4.90436C10.4451 5.83072 10.0831 6.71916 9.43868 7.37422L9.05514 7.76429L8.07194 6.76695L8.45924 6.37314C8.84166 5.98245 9.05612 5.4536 9.05561 4.90247C9.0551 4.35134 8.83967 3.82289 8.45653 3.43293C8.06641 3.0545 7.54787 2.84335 7.00861 2.84335C6.46935 2.84335 5.95081 3.0545 5.56069 3.43293L2.01576 7.03575C1.8256 7.22896 1.67475 7.45835 1.57183 7.71083C1.46891 7.96332 1.41594 8.23394 1.41594 8.50723C1.41594 8.78053 1.46891 9.05115 1.57183 9.30363C1.67475 9.55611 1.8256 9.78551 2.01576 9.97871C2.40588 10.3571 2.92442 10.5683 3.46368 10.5683C4.00294 10.5683 4.52148 10.3571 4.9116 9.97871L5.89375 10.9772C5.57529 11.3025 5.19653 11.5604 4.77938 11.736C4.36223 11.9115 3.91497 12.0013 3.46347 12Z"
        fill="#B9B9B9"
      />
      <path
        id="Vector_2"
        d="M9.01901 10.5882C8.33937 10.5884 7.67496 10.3836 7.10981 9.99991C6.54466 9.61618 6.10417 9.0707 5.84406 8.43246C5.58394 7.79423 5.51589 7.09191 5.6485 6.41436C5.78112 5.73681 6.10845 5.11445 6.58908 4.62602L6.97283 4.23595L7.95499 5.23449L7.57124 5.62434C7.38112 5.81756 7.23031 6.04694 7.12742 6.2994C7.02453 6.55186 6.97157 6.82245 6.97157 7.09572C6.97157 7.36899 7.02453 7.63958 7.12742 7.89204C7.23031 8.1445 7.38112 8.37388 7.57124 8.56709C7.96135 8.94553 8.47989 9.15667 9.01915 9.15667C9.55841 9.15667 10.077 8.94553 10.4671 8.56709C10.6476 8.38356 13.7513 5.22877 14.0124 4.96392C14.3958 4.57341 14.611 4.04428 14.611 3.49262C14.611 2.94096 14.3958 2.41183 14.0124 2.02131C13.6223 1.64288 13.1038 1.43173 12.5645 1.43173C12.0252 1.43173 11.5067 1.64288 11.1166 2.02131L10.1344 1.02284C10.7791 0.368779 11.6528 0.00160792 12.5636 0.0020145C13.4744 0.00242107 14.3478 0.370372 14.9919 1.02501C15.6359 1.67965 15.998 2.56742 15.9984 3.49324C15.9988 4.41906 15.6377 5.30719 14.9942 5.96246C14.7328 6.22787 11.6303 9.3809 11.4499 9.56493C11.1314 9.89036 10.7525 10.1484 10.3353 10.324C9.91802 10.4997 9.47064 10.5895 9.01901 10.5882Z"
        fill="#B9B9B9"
      />
    </g>
    <defs>
      <clipPath id="clip0_1708_24">
        <rect width={16} height={12} fill="white"/>
      </clipPath>
    </defs>
  </svg>


</div>
const DownArrowBorder = (props) => <svg
  {...props}
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
    fill="#B9B9B9"
  />
  <path
    d="M12.0002 14.9098C11.8102 14.9098 11.6202 14.8398 11.4702 14.6898L7.94016 11.1598C7.65016 10.8698 7.65016 10.3898 7.94016 10.0998C8.23016 9.80983 8.71016 9.80983 9.00016 10.0998L12.0002 13.0998L15.0002 10.0998C15.2902 9.80983 15.7702 9.80983 16.0602 10.0998C16.3502 10.3898 16.3502 10.8698 16.0602 11.1598L12.5302 14.6898C12.3802 14.8398 12.1902 14.9098 12.0002 14.9098Z"
    fill="#B9B9B9"
  />
</svg>

const PersonsSvg = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    fill="#fff"
    d="M9.16 11.62h-.08a.543.543 0 00-.18 0C6 11.53 3.81 9.25 3.81 6.44c0-2.86 2.33-5.19 5.19-5.19 2.86 0 5.19 2.33 5.19 5.19-.01 2.81-2.21 5.09-5 5.18h-.03zM9 2.75a3.7 3.7 0 00-3.69 3.69c0 2 1.56 3.61 3.55 3.68.06-.01.19-.01.32 0 1.96-.09 3.5-1.7 3.51-3.68A3.7 3.7 0 009 2.75zM16.54 11.75c-.03 0-.06 0-.09-.01-.41.04-.83-.25-.87-.66-.04-.41.21-.78.62-.83.12-.01.25-.01.36-.01 1.46-.08 2.6-1.28 2.6-2.75 0-1.52-1.23-2.75-2.75-2.75a.74.74 0 01-.75-.74c0-.41.34-.75.75-.75a4.26 4.26 0 014.25 4.25c0 2.3-1.8 4.16-4.09 4.25h-.03zM9.17 22.55c-1.96 0-3.93-.5-5.42-1.5-1.39-.92-2.15-2.18-2.15-3.55 0-1.37.76-2.64 2.15-3.57 3-1.99 7.86-1.99 10.84 0 1.38.92 2.15 2.18 2.15 3.55 0 1.37-.76 2.64-2.15 3.57-1.5 1-3.46 1.5-5.42 1.5zm-4.59-7.36c-.96.64-1.48 1.46-1.48 2.32 0 .85.53 1.67 1.48 2.3 2.49 1.67 6.69 1.67 9.18 0 .96-.64 1.48-1.46 1.48-2.32 0-.85-.53-1.67-1.48-2.3-2.49-1.66-6.69-1.66-9.18 0zM18.34 20.75c-.35 0-.66-.24-.73-.6a.76.76 0 01.58-.89c.63-.13 1.21-.38 1.66-.73.57-.43.88-.97.88-1.54 0-.57-.31-1.11-.87-1.53-.44-.34-.99-.58-1.64-.73a.756.756 0 01-.57-.9c.09-.4.49-.66.9-.57.86.19 1.61.53 2.22 1 .93.7 1.46 1.69 1.46 2.73s-.54 2.03-1.47 2.74c-.62.48-1.4.83-2.26 1-.06.02-.11.02-.16.02z"
  ></path>
</svg>

const LocSvg = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    fill="#fff"
    d="M12 14.17c-2.13 0-3.87-1.73-3.87-3.87S9.87 6.44 12 6.44s3.87 1.73 3.87 3.87-1.74 3.86-3.87 3.86zm0-6.23c-1.3 0-2.37 1.06-2.37 2.37s1.06 2.37 2.37 2.37 2.37-1.06 2.37-2.37S13.3 7.94 12 7.94z"
  ></path>
  <path
    fill="#fff"
    d="M12 22.76a5.97 5.97 0 01-4.13-1.67c-2.95-2.84-6.21-7.37-4.98-12.76C4 3.44 8.27 1.25 12 1.25h.01c3.73 0 8 2.19 9.11 7.09 1.22 5.39-2.04 9.91-4.99 12.75A5.97 5.97 0 0112 22.76zm0-20.01c-2.91 0-6.65 1.55-7.64 5.91C3.28 13.37 6.24 17.43 8.92 20a4.426 4.426 0 006.17 0c2.67-2.57 5.63-6.63 4.57-11.34-1-4.36-4.75-5.91-7.66-5.91z"
  ></path>
</svg>

const AboutUsSvg = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    fill="#fff"
    d="M12 22.75c-.7 0-1.41-.27-1.94-.8l-1.71-1.69c-.42-.42-1-.65-1.59-.65H6c-2.07 0-3.75-1.67-3.75-3.72V4.98c0-2.05 1.68-3.72 3.75-3.72h12c2.07 0 3.75 1.67 3.75 3.72v10.91c0 2.05-1.68 3.72-3.75 3.72h-.76a2.3 2.3 0 00-1.59.65l-1.71 1.69c-.53.53-1.24.8-1.94.8zm-6-20c-1.24 0-2.25 1-2.25 2.22v10.91c0 1.23 1.01 2.22 2.25 2.22h.76c.99 0 1.95.4 2.65 1.09l1.71 1.69c.49.48 1.28.48 1.77 0l1.71-1.69c.7-.69 1.66-1.09 2.65-1.09H18c1.24 0 2.25-1 2.25-2.22V4.97c0-1.23-1.01-2.22-2.25-2.22H6z"
  ></path>
  <path
    fill="#fff"
    d="M12 10.75c-1.7 0-3.08-1.38-3.08-3.08a3.081 3.081 0 016.16 0c0 1.7-1.38 3.08-3.08 3.08zm0-4.66c-.87 0-1.58.71-1.58 1.58 0 .87.71 1.58 1.58 1.58.87 0 1.58-.71 1.58-1.58 0-.87-.71-1.58-1.58-1.58zM16 16.41c-.41 0-.75-.34-.75-.75 0-1.38-1.46-2.51-3.25-2.51s-3.25 1.13-3.25 2.51c0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-2.21 2.13-4.01 4.75-4.01s4.75 1.8 4.75 4.01c0 .41-.34.75-.75.75z"
  ></path>
</svg>

const Toka = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="126"
  height="37"
  fill="none"
  viewBox="0 0 126 37"
>
  <path
    fill="#fff"
    d="M44.69 37v-7.056h-.62c-5.965 0-10.819-4.854-10.819-10.818v-4.704h14.262V24.3H44.69v-7.056h-8.618v1.882c0 4.407 3.59 7.996 7.997 7.996h14.732v2.822h-11.29V37M10.819 29.94a10.757 10.757 0 01-7.649-3.166A10.753 10.753 0 010 19.121V.005h2.822v19.111c0 2.136.833 4.144 2.343 5.659a7.938 7.938 0 005.649 2.338h.005c6.712 0 9.3-.014 9.544-.029 4.144-.413 7.239-3.833 7.239-7.963v-3.293h2.822v3.293a10.78 10.78 0 01-9.737 10.767c-.263.033-.348.042-9.864.047h-.009l.005.005z"
  ></path>
  <path
    fill="#fff"
    d="M16.468 10.828v3.594h13.96v4.704a10.78 10.78 0 01-9.736 10.767c-.263.028-.353.037-9.869.047h-.004a10.74 10.74 0 01-7.649-3.166A10.753 10.753 0 010 19.121V0h2.822v19.116c0 2.136.833 4.144 2.343 5.654a7.945 7.945 0 005.654 2.343h.004c6.713-.005 9.3-.014 9.544-.029 4.144-.413 7.24-3.833 7.24-7.963v-1.882H16.468v7.056h-2.822V10.823A10.782 10.782 0 0123.382.061s.861-.033 1.416-.033c1.134-.004 3.25-.01 7.193-.014v2.822c-5.132.005-7.607.01-8.218.02a.428.428 0 01-.108.013 7.969 7.969 0 00-7.197 7.96zM58.802 14.422h-8.467v2.822h8.467v-2.822z"
  ></path>
  <path
    fill="#FAA72D"
    d="M101.287 20.408V4.025c.879-.006 1.887-.006 3.024-.006 4.694 0 7.128.006 7.89.018l.19.019c5.119.504 9.126 4.836 9.126 9.863v6.483h-20.23v.006z"
  ></path>
  <path
    fill="#707070"
    d="M101.287 4.025V24.71c0 6.79-5.5 12.29-12.29 12.29l-1.893-.018v-22.94c0-5.18 3.92-9.476 9.12-9.986l.184-.019c.577-.012 2.12-.012 4.879-.012z"
  ></path>
  <path
    fill="#231F20"
    d="M87.104 36.982h-4.302V14.33c0-7.405 5.592-13.538 13.003-14.27 0 0 1.18-.043 1.875-.049.823 0 2.052-.006 3.865-.012h5.531c1.812 0 3.041 0 3.865.012.7 0 1.874.05 1.874.05 7.295.718 13.003 6.931 13.003 14.146v6.2h-4.301v-6.2c0-5.027-4.007-9.36-9.12-9.863l-.19-.019c-.762-.012-3.196-.018-7.897-.024-4.707 0-7.14.012-7.896.024l-.19.019c-5.2.51-9.12 4.805-9.12 9.986v22.651z"
  ></path>
  <path fill="#fff" d="M95.695 10.146h-2.667v2.667h2.667v-2.667z"></path>
</svg>

const ScrumIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <g
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    clipPath="url(#clip0_13_82)"
  >
    <path
      stroke="#FFBD35"
      d="M12 13v-1.108c0-1.067 0-1.6-.078-2.047-.426-2.458-2.539-4.385-5.233-4.774C6.2 5 5.17 5 4 5"
    ></path>
    <path
      stroke="#FFBD35"
      d="M4.75 3.3C4.396 3.644 3 4.56 3 5.05S4.396 6.456 4.75 6.8"
    ></path>
    <path stroke="#fff" d="M14 22H9.5a4.5 4.5 0 110-9H21"></path>
    <path stroke="#fff" d="M18 10s3 2.21 3 3-3 3-3 3"></path>
  </g>
  <defs>
    <clipPath id="clip0_13_82">
      <path fill="#fff" d="M0 0H20V21H0z" transform="translate(2 2)"></path>
    </clipPath>
  </defs>
</svg>

const ProgrammersIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M20 14.5v-8c0-1.886 0-2.828-.586-3.414C18.828 2.5 17.886 2.5 16 2.5H8c-1.886 0-2.828 0-3.414.586C4 3.672 4 4.614 4 6.5v8M3.498 15.515L4.02 14.5h15.932l.55 1.015c1.443 2.662 1.803 3.993 1.254 4.989-.548.996-2.002.996-4.91.996H7.154c-2.909 0-4.363 0-4.911-.996-.549-.996-.19-2.327 1.254-4.989z"
  ></path>
  <path
    stroke="#FFBD35"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M15.5 7l.92.793c.387.333.58.5.58.707 0 .207-.193.374-.58.707L15.5 10M8.5 7l-.92.793c-.387.333-.58.5-.58.707 0 .207.193.374.58.707L8.5 10M13 6l-2 5"
  ></path>
</svg>

const DocumentationIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    fill="#FFBD35"
    d="M15 12.95H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75zM12.38 16.95H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.38c.41 0 .75.34.75.75s-.34.75-.75.75z"
  ></path>
  <path
    fill="#fff"
    d="M14 6.75h-4c-.96 0-2.75 0-2.75-2.75S9.04 1.25 10 1.25h4c.96 0 2.75 0 2.75 2.75 0 .96 0 2.75-2.75 2.75zm-4-4c-.99 0-1.25 0-1.25 1.25S9.01 5.25 10 5.25h4c1.25 0 1.25-.26 1.25-1.25 0-1.25-.26-1.25-1.25-1.25h-4z"
  ></path>
  <path
    fill="#fff"
    d="M15 22.75H9c-5.62 0-6.75-2.58-6.75-6.75v-6c0-4.56 1.65-6.51 5.71-6.72.4-.02.77.29.79.71.02.42-.3.76-.71.78C5.2 4.93 3.75 5.78 3.75 10v6c0 3.7.73 5.25 5.25 5.25h6c4.52 0 5.25-1.55 5.25-5.25v-6c0-4.22-1.45-5.07-4.29-5.23a.757.757 0 01-.71-.79c.02-.41.38-.73.79-.71 4.06.22 5.71 2.17 5.71 6.72v6c0 4.18-1.13 6.76-6.75 6.76z"
  ></path>
</svg>

const VersionIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#fff"
    strokeWidth="1.5"
    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10z"
  ></path>
  <path
    stroke="#FFBD35"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M10 16.5h4M15 7l-2.106 4.695C12.504 12.565 12.31 13 12 13c-.309 0-.504-.435-.894-1.305L9 7"
  ></path>
</svg>

const BalanceSheetIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#fff"
    strokeWidth="1.5"
    d="M12 19.5c-1.332.622-3.083 1-5 1-1.066 0-2.08-.117-3-.327-1.582-.363-2-1.293-2-2.787V6.614c0-.985 1.04-1.661 2-1.441.92.21 1.934.327 3 .327 1.917 0 3.668-.378 5-1 1.332-.622 3.083-1 5-1 1.066 0 2.08.117 3 .327 1.582.363 2 1.293 2 2.787v10.772c0 .985-1.04 1.661-2 1.441-.92-.21-1.934-.327-3-.327-1.917 0-3.668.378-5 1z"
  ></path>
  <path
    stroke="#FFBD35"
    strokeWidth="1.5"
    d="M14.5 12a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
  ></path>
  <path
    stroke="#FFBD35"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M5.5 13v.009M18.5 10.992v.01"
  ></path>
</svg>

const ReportsIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#FFBD35"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M21 7.987c-1.84 0-3.808.256-5.123-1.494-1.497-1.99-4.257-1.99-5.754 0C8.808 8.243 6.84 7.987 5 7.987H3"
  ></path>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeWidth="1.5"
    d="M21 21H10c-3.3 0-4.95 0-5.975-1.025C3 18.95 3 17.3 3 14V3"
  ></path>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M13 10v11M18 13v8M8 13v7"
  ></path>
</svg>

const MonitorIcon = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M12 18v4M10 18l-5 4M14 18l5 4"
  ></path>
  <path
    stroke="#fff"
    strokeWidth="1.5"
    d="M2.5 12c0 2.828 0 4.243.879 5.121C4.257 18 5.672 18 8.5 18h7c2.828 0 4.243 0 5.121-.879.879-.878.879-2.293.879-5.121V8c0-2.828 0-4.243-.879-5.121C19.743 2 18.328 2 15.5 2h-7c-2.828 0-4.243 0-5.121.879C2.5 3.757 2.5 5.172 2.5 8v4z"
  ></path>
  <path
    stroke="#FFBD35"
    strokeLinecap="round"
    strokeWidth="1.5"
    d="M8 13v-3m4 3V7m4 6v-2"
  ></path>
</svg>

export {
  DownArrowBorder,
  ReviewAccountButton,
  PlusIcon,
  Spinner,
  AddToTableIcon,
  SearchIconSubmitDoc,
  CalenderIcon,
  RavanhesabLogo,
  RavanhesabCalculatorMenuIcon,
  RavanhesabBilanSarmayeMenuIcon,
  RavanhesabFishMenuIcon,
  RavanhesabSarmayeMenuIcon,
  RavanhesabAnbarMenuIcon,
  RavanhesabKalaMenuIcon,
  RavanhesabPeopleMenuIcon,
  RavanhesabBankMenuIcon,
  RavanhesabHazinehaMenuIcon,
  RavanhesabOmurMaliMenuIcon,
  responsiveMenu,
  ManagerIconSettingSvg,
  ChartSvg,
  ChartIcon,
  DashboardIcon,
  IndexIcon,
  OprationIcon,
  ReportIcon,
  SettingIcon,
  DeleteBoxInAdminDashboardSetting,
  DataIcon,
  TriangleSign,
  BgHeartNiko,
  NikoTimeBg,
  NikoMoneyBg,
  NikoHeartBg,
  NikoPeopleBg,
  NikoReportBg,
  NikoCommentBg,
  WaitingCommentBg,
  ArrowRightSquareFill,
  ArrowLeftSquareFill,
  PdfBootstrapIcon,

  //
  DashboardIconNiko,
  GalleryIconNiko,
  GroupIconNiko,
  LocationIconNiko,
  BlogIconNiko,
  MessageTextNiko,
  MessageTextBubbleNiko,
  MoneysNiko,
  NoteIconNiko,
  Profile2usersNiko,
  SettingNiko,
  ThreeDCubeIconNiko,
  //
  NikoGolestanIcon,
  EnvelopeIconAutoC,
  NotificationBellIconAutoC,
  PersonIconAutoC,
  LogoAutoC,
  DashboardIconAutoC,
  PaymentAutoCIcon,
  SupportAutoCIcon,
  BusAutoCIcon,
  SettingAutoCIcon,
  TaxiAutoCIcon,
  NumberOfTaxiesBus,
  CoinCardSvgBus,
  CustomServiceCardBus,
  MoneyCardSvgBus,
  MessageCardSvgBus,
  BusStopCardSvgBus,
  BusCardSvg,
  LogoutIcon,
  PersonsSvg,
  LocSvg,
  AboutUsSvg,
  Toka,
  ScrumIcon,
  ProgrammersIcon,
  DocumentationIcon,
  VersionIcon,
  BalanceSheetIcon,
  ReportsIcon,
  BlueRavanhesabLogo,
  ArkaLogo,
  MonitorIcon,
};
